//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const PORTAL_API_BASE_URL = new InjectionToken<string>('PORTAL_API_BASE_URL');

export interface IPortalApiService {
    /**
     * @return OK
     */
    gets_current_application_version(): Observable<string>;
    /**
     * Retrieve NBG branches from Neon Db
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @param body (optional) 
     * @return OK
     */
    getNbgBranches(page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined, body?: NbgBranchesRequest | undefined): Observable<NbgBranchResultSet>;
    /**
     * Get supported languages with calling codes
     * @return OK
     */
    getCountryCodes(): Observable<CountryCode[]>;
    /**
     * Gets buyer feedback form for given request
     * @return OK
     */
    getBuyerFeedbackForm(requestId: string): Observable<BuyerFeedbackForm>;
    /**
     * Submits buyer feedback for given request
     * @return No Content
     */
    submitBuyerFeedback(requestId: string, body: FeedbackQuestion[]): Observable<void>;
    /**
     * Validates recaptcha response
     * @return No Content
     */
    validateRecaptcha(body: string): Observable<void>;
    /**
     * Records an interested buyer or seller
     * @return No Content
     */
    registerToWaitingList(body: WaitingListFormRequest): Observable<void>;
    /**
     * Generates site's sitemap.
     * @return No Content
     */
    generateSitemap(): Observable<void>;
    /**
     * @return OK
     */
    getPartialReport(propertyId: string): Observable<PropertyReportPartial>;
    /**
     * @return OK
     */
    getReportDetails(propertyId: string): Observable<PropertyReport>;
    /**
     * @return OK
     */
    getPointsOfInterest(propertyId: string): Observable<PropertyPointOfInterest[]>;
    /**
     * Create account and account owner
     * @return OK
     */
    createAccountOwner(body: AccountOwner): Observable<string>;
    /**
     * Get account and account owner
     * @return OK
     */
    getAccountOwner(): Observable<AccountOwner>;
    /**
     * Update account owner
     * @return No Content
     */
    updateAccountOwner(body: AccountOwner): Observable<void>;
    /**
     * Update UTM information.
     * @return No Content
     */
    updateAccountOwnerContact(body: UtmDetails): Observable<void>;
    /**
     * Create anonymous account and account owner from UTM information.
     * @return OK
     */
    createOrUpdateAnonymousAccount(body: UtmDetails): Observable<string>;
    /**
     * Accepts a message from the user
     * @return No Content
     */
    contactUs(body: ContactUsRequest): Observable<void>;
    /**
     * Get all notifications for the user
     * @return OK
     */
    getNotifications(): Observable<Notifications>;
    /**
     * Gets my requests
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @param nonMineRequestsCaseTypeCodes (optional) 
     * @param requestTypes (optional) 
     * @return OK
     */
    getMyRequests(page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined, nonMineRequestsCaseTypeCodes?: string[] | undefined, requestTypes?: RequestTypeFilter[] | undefined): Observable<MyRequestsResponseResultSet>;
    /**
     * User saves a search
     * @return No Content
     */
    saveSearch(body: SavePropertySearchFilterRequest): Observable<void>;
    /**
     * Get all saved searches
     * @return OK
     */
    getSearches(savedSearchType: SavedSearchType): Observable<Search[]>;
    /**
     * Delete search by Id
     * @return No Content
     */
    deleteSearch(searchId: string): Observable<void>;
    /**
     * Update notification frequency of saved search
     * @return No Content
     */
    updateSavedSearchFrequency(searchId: string, frequency: NotificationFrequency): Observable<void>;
    /**
     * Save a user's search history
     * @return No Content
     */
    upsertSearchHistory(body: Search): Observable<void>;
    /**
     * @return No Content
     */
    acceptTerms(body: AcceptTnCRequest): Observable<void>;
    /**
     * Send a TOTP code
     * @return No Content
     */
    sendTotp(body: TotpRequestBody): Observable<void>;
    /**
     * Verify Totp code
     * @return No Content
     */
    verifyTotp(body: TotpVerificationBody): Observable<void>;
    /**
     * Retrieves a partner by userId
     * @return OK
     */
    getPartner(userId: string): Observable<Partner>;
    /**
     * Get property listing (index)
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @param searchTerm (optional) 
     * @param minPrice (optional) 
     * @param maxPrice (optional) 
     * @param type (optional) 
     * @param minSqMeters (optional) 
     * @param maxSqMeters (optional) 
     * @param floor (optional) 
     * @param hasParking (optional) 
     * @param parkingSpace (optional) 
     * @param bedrooms (optional) 
     * @param bathrooms (optional) 
     * @param minConstructionYear (optional) 
     * @param maxConstructionYear (optional) 
     * @param preApproved (optional) 
     * @param inAuction (optional) 
     * @param auctionRound (optional) 
     * @param hasElevator (optional) 
     * @param hasAlarm (optional) 
     * @param isAiry (optional) 
     * @param sieves (optional) 
     * @param hasSolarWaterHeating (optional) 
     * @param hasBoiler (optional) 
     * @param suitableForProfessionalUse (optional) 
     * @param suitableForTouristUse (optional) 
     * @param hasNightElectricCurrent (optional) 
     * @param hasSafetyDoor (optional) 
     * @param isBright (optional) 
     * @param accessibilityForDisabled (optional) 
     * @param hasPlayroom (optional) 
     * @param isPenthouse (optional) 
     * @param hasGarden (optional) 
     * @param hasPool (optional) 
     * @param hasStorageRoom (optional) 
     * @param petsAreAllowed (optional) 
     * @param hasTents (optional) 
     * @param isFloorApartment (optional) 
     * @param internalStaircase (optional) 
     * @param view (optional) 
     * @param numberOfRooms (optional) 
     * @param numberOfBathRooms (optional) 
     * @param hasGym (optional) 
     * @param hasSeaView (optional) 
     * @param hasGreatView (optional) 
     * @param hasAirconditioning (optional) 
     * @param hasFirePlace (optional) 
     * @param heatingType (optional) 
     * @param heatingControl (optional) 
     * @param area (optional) 
     * @param clauses (optional) 
     * @param isREO (optional) 
     * @param isSold (optional) 
     * @param tag (optional) 
     * @param searchFromMap (optional) 
     * @param propertyIds (optional) 
     * @return OK
     */
    getPropertyList(includeDetails: boolean, page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined, searchTerm?: string | undefined, minPrice?: number | undefined, maxPrice?: number | undefined, type?: PropertyType[] | undefined, minSqMeters?: number | undefined, maxSqMeters?: number | undefined, floor?: FloorFilter[] | undefined, hasParking?: boolean | undefined, parkingSpace?: BedroomFilter[] | undefined, bedrooms?: BedroomFilter[] | undefined, bathrooms?: BedroomFilter[] | undefined, minConstructionYear?: number | undefined, maxConstructionYear?: number | undefined, preApproved?: boolean | undefined, inAuction?: boolean | undefined, auctionRound?: AuctionRoundFilter[] | undefined, hasElevator?: boolean | undefined, hasAlarm?: boolean | undefined, isAiry?: boolean | undefined, sieves?: boolean | undefined, hasSolarWaterHeating?: boolean | undefined, hasBoiler?: boolean | undefined, suitableForProfessionalUse?: boolean | undefined, suitableForTouristUse?: boolean | undefined, hasNightElectricCurrent?: boolean | undefined, hasSafetyDoor?: boolean | undefined, isBright?: boolean | undefined, accessibilityForDisabled?: boolean | undefined, hasPlayroom?: boolean | undefined, isPenthouse?: boolean | undefined, hasGarden?: boolean | undefined, hasPool?: boolean | undefined, hasStorageRoom?: boolean | undefined, petsAreAllowed?: boolean | undefined, hasTents?: boolean | undefined, isFloorApartment?: boolean | undefined, internalStaircase?: boolean | undefined, view?: string | undefined, numberOfRooms?: string | undefined, numberOfBathRooms?: string | undefined, hasGym?: boolean | undefined, hasSeaView?: boolean | undefined, hasGreatView?: boolean | undefined, hasAirconditioning?: boolean | undefined, hasFirePlace?: boolean | undefined, heatingType?: HeatingType[] | undefined, heatingControl?: HeatingControl[] | undefined, area?: string | undefined, clauses?: string | undefined, isREO?: boolean | undefined, isSold?: boolean | undefined, tag?: string[] | undefined, searchFromMap?: boolean | undefined, propertyIds?: string[] | undefined): Observable<PropertyListResponse>;
    /**
     * Verify the Postal Code is allowed
     * @return OK
     */
    postalCodeIsAllowed(postalCode: string): Observable<void>;
    /**
     * Get buying property's listing details
     * @return OK
     */
    getBuyingListingDetails(propertyCode: string): Observable<PropertyListingDetails>;
    /**
     * Get property's listing details
     * @return OK
     */
    getListingDetails(propertyCode: string): Observable<PropertyListingDetails>;
    /**
     * Get the analytics for the requested property
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @return OK
     */
    getAnalytics(propertyId: string, lastDays: number, page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined): Observable<PropertyAnalytics>;
    /**
     * Toggle a property as favorite for the logged in user
     * @return No Content
     */
    togglePropertyFavorite(propertyId: string): Observable<void>;
    /**
     * Gets the list of offers the user made for the requested property
     * @param includeExpired (optional) 
     * @return OK
     */
    getMyOffersForProperty(propertyId: string, includeExpired?: boolean | undefined): Observable<PropertyOffersBuyerResponse>;
    /**
     * Accepts or rejects an offer for a specific property
     * @return No Content
     */
    submitOfferResult(propertyId: string, offerId: string, body: SubmitOfferResultRequest): Observable<void>;
    /**
     * Gets property's photos
     * @param isDraft (optional) 
     * @return OK
     */
    getPhotos(propertyId: string, isDraft?: boolean | undefined): Observable<PhotoResultSet>;
    /**
     * Uploads property's photo
     * @param file (optional) 
     * @param fileName (optional) 
     * @param length (optional) 
     * @param isDefault (optional) 
     * @param order (optional) 
     * @return OK
     */
    uploadPhoto(propertyId: string, file?: FileParameter | null | undefined, fileName?: string | null | undefined, length?: number | null | undefined, isDefault?: boolean | undefined, order?: number | null | undefined): Observable<Photo>;
    /**
     * Deletes property's photo
     * @return No Content
     */
    deletePhoto(propertyId: string, mediaGuid: string): Observable<void>;
    /**
     * Sets property photo's tag
     * @param body (optional) 
     * @return No Content
     */
    updateMediaTag(propertyId: string, mediaGuid: string, body?: MediaTag | undefined): Observable<void>;
    /**
     * Orders property's photos
     * @return No Content
     */
    updateMediaOrder(propertyId: string, body: MediaOrderRequest): Observable<void>;
    /**
     * Gets all the offers for this property
     * @param includeExpired (optional) 
     * @return OK
     */
    getOffersForProperty(propertyId: string, includeExpired?: boolean | undefined): Observable<PropertyOffersSellerResponse>;
    /**
     * Get related properties based on the property selected
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @return OK
     */
    getRelatedProperties(propertyId: string, page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined): Observable<PropertySummaryResultSet>;
    /**
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @param caseTypeCodes (optional) 
     * @return OK
     */
    listPropertyRequests(propertyId: string, page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined, caseTypeCodes?: string[] | undefined): Observable<CasePartialResultSet>;
    /**
     * @return OK
     */
    getThreeDCode(propertyId: string): Observable<ThreeDTourMedia>;
    /**
     * Adds a property to recently viewed. Max 10 entries
     * @return No Content
     */
    addRecentlyViewed(propertyId: string): Observable<void>;
    /**
     * Get property details by property Id or code
     * @return OK
     */
    getPropertyById(propertyIdOrCode: string): Observable<PropertyDetails>;
    /**
     * Get property details by property Id or code
     * @return OK
     */
    getPropertyByIdUnmasked(propertyIdOrCode: string): Observable<PropertyDetails>;
    /**
     * Retrieves a list with properties containing the address info
     * @param propertyIds (optional) 
     * @return OK
     */
    getPropertyAddressInfo(propertyIds?: string[] | undefined): Observable<PropertyAddressInfo[]>;
    /**
     * Get property details by property Id or code, independent of the property status
     * @return OK
     */
    getPropertyByIdOrCode(propertyIdOrCode: string): Observable<PropertyDetails>;
    /**
     * Gets buying properties
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @return OK
     */
    getMyBuyingProperties(page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined): Observable<PropertySummaryBuyingResultSet>;
    /**
     * Get property details by property Id or code only if the property is in draft status
     * @return OK
     */
    getDraftPropertyById(propertyIdOrCode: string): Observable<PropertyDetails>;
    /**
     * Resolves property ownership
     * @param code (optional) 
     * @param id (optional) 
     * @return OK
     */
    resolveOwnership(code?: string | undefined, id?: string | undefined): Observable<PropertyOwnershipResponse>;
    /**
     * Post a new property listing and returns the created property Id & Code
     * @return OK
     */
    postListing(body: ListingUploadInfo): Observable<CreateListingResponse>;
    /**
     * Update property's listing details
     * @return No Content
     */
    updateListingDetails(body: PropertyListingDetailsUpsertRequest): Observable<void>;
    /**
     * Get property listing for map (index)
     * @param searchTerm (optional) 
     * @param minPrice (optional) 
     * @param maxPrice (optional) 
     * @param type (optional) 
     * @param minSqMeters (optional) 
     * @param maxSqMeters (optional) 
     * @param floor (optional) 
     * @param hasParking (optional) 
     * @param parkingSpace (optional) 
     * @param bedrooms (optional) 
     * @param bathrooms (optional) 
     * @param minConstructionYear (optional) 
     * @param maxConstructionYear (optional) 
     * @param preApproved (optional) 
     * @param inAuction (optional) 
     * @param auctionRound (optional) 
     * @param hasElevator (optional) 
     * @param hasAlarm (optional) 
     * @param isAiry (optional) 
     * @param sieves (optional) 
     * @param hasSolarWaterHeating (optional) 
     * @param hasBoiler (optional) 
     * @param suitableForProfessionalUse (optional) 
     * @param suitableForTouristUse (optional) 
     * @param hasNightElectricCurrent (optional) 
     * @param hasSafetyDoor (optional) 
     * @param isBright (optional) 
     * @param accessibilityForDisabled (optional) 
     * @param hasPlayroom (optional) 
     * @param isPenthouse (optional) 
     * @param hasGarden (optional) 
     * @param hasPool (optional) 
     * @param hasStorageRoom (optional) 
     * @param petsAreAllowed (optional) 
     * @param hasTents (optional) 
     * @param isFloorApartment (optional) 
     * @param internalStaircase (optional) 
     * @param view (optional) 
     * @param numberOfRooms (optional) 
     * @param numberOfBathRooms (optional) 
     * @param hasGym (optional) 
     * @param hasSeaView (optional) 
     * @param hasGreatView (optional) 
     * @param hasAirconditioning (optional) 
     * @param hasFirePlace (optional) 
     * @param heatingType (optional) 
     * @param heatingControl (optional) 
     * @param area (optional) 
     * @param clauses (optional) 
     * @param isREO (optional) 
     * @param isSold (optional) 
     * @param tag (optional) 
     * @param searchFromMap (optional) 
     * @param propertyIds (optional) 
     * @return OK
     */
    getPropertyListForMap(includeDetails: boolean, searchTerm?: string | undefined, minPrice?: number | undefined, maxPrice?: number | undefined, type?: PropertyType[] | undefined, minSqMeters?: number | undefined, maxSqMeters?: number | undefined, floor?: FloorFilter[] | undefined, hasParking?: boolean | undefined, parkingSpace?: BedroomFilter[] | undefined, bedrooms?: BedroomFilter[] | undefined, bathrooms?: BedroomFilter[] | undefined, minConstructionYear?: number | undefined, maxConstructionYear?: number | undefined, preApproved?: boolean | undefined, inAuction?: boolean | undefined, auctionRound?: AuctionRoundFilter[] | undefined, hasElevator?: boolean | undefined, hasAlarm?: boolean | undefined, isAiry?: boolean | undefined, sieves?: boolean | undefined, hasSolarWaterHeating?: boolean | undefined, hasBoiler?: boolean | undefined, suitableForProfessionalUse?: boolean | undefined, suitableForTouristUse?: boolean | undefined, hasNightElectricCurrent?: boolean | undefined, hasSafetyDoor?: boolean | undefined, isBright?: boolean | undefined, accessibilityForDisabled?: boolean | undefined, hasPlayroom?: boolean | undefined, isPenthouse?: boolean | undefined, hasGarden?: boolean | undefined, hasPool?: boolean | undefined, hasStorageRoom?: boolean | undefined, petsAreAllowed?: boolean | undefined, hasTents?: boolean | undefined, isFloorApartment?: boolean | undefined, internalStaircase?: boolean | undefined, view?: string | undefined, numberOfRooms?: string | undefined, numberOfBathRooms?: string | undefined, hasGym?: boolean | undefined, hasSeaView?: boolean | undefined, hasGreatView?: boolean | undefined, hasAirconditioning?: boolean | undefined, hasFirePlace?: boolean | undefined, heatingType?: HeatingType[] | undefined, heatingControl?: HeatingControl[] | undefined, area?: string | undefined, clauses?: string | undefined, isREO?: boolean | undefined, isSold?: boolean | undefined, tag?: string[] | undefined, searchFromMap?: boolean | undefined, propertyIds?: string[] | undefined): Observable<PropertyListForMapResponse>;
    /**
     * Get's a list of user's favorite properties
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @return OK
     */
    getMyFavorites(page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined): Observable<PropertySummaryResultSet>;
    /**
     * Get's a list of user's recently viewed properties
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @return OK
     */
    getMyRecentlyViewed(page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined): Observable<PropertySummaryResultSet>;
    /**
     * Get user specific property suggestions
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @return OK
     */
    getMySuggestions(page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined): Observable<PropertySummaryResultSet>;
    /**
     * Get property listing (db)
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @param minPrice (optional) 
     * @param maxPrice (optional) 
     * @param minSqMeters (optional) 
     * @param maxSqMeters (optional) 
     * @param minYear (optional) 
     * @param maxYear (optional) 
     * @param propertyType (optional) 
     * @param isSold (optional) 
     * @param hasParking (optional) 
     * @param hasStorage (optional) 
     * @param hasGarden (optional) 
     * @param view (optional) 
     * @param floor (optional) 
     * @param roomNumber (optional) 
     * @param bathroomNumber (optional) 
     * @param auctionRound (optional) 
     * @param preApproved (optional) 
     * @param isReo (optional) 
     * @param searchFromMap (optional) 
     * @param ids (optional) 
     * @return OK
     */
    getPropertySearch(page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined, minPrice?: number | undefined, maxPrice?: number | undefined, minSqMeters?: number | undefined, maxSqMeters?: number | undefined, minYear?: number | undefined, maxYear?: number | undefined, propertyType?: string | undefined, isSold?: boolean | undefined, hasParking?: boolean | undefined, hasStorage?: boolean | undefined, hasGarden?: boolean | undefined, view?: View[] | undefined, floor?: string | undefined, roomNumber?: string | undefined, bathroomNumber?: string | undefined, auctionRound?: string | undefined, preApproved?: boolean | undefined, isReo?: boolean | undefined, searchFromMap?: boolean | undefined, ids?: string[] | undefined): Observable<PropertySummaryResultSet>;
    /**
     * Gets selling properties
     * @param caseTypeCode (optional) 
     * @return OK
     */
    getMySellingProperties(caseTypeCode?: string | undefined): Observable<PropertySummaryWithCountsResultSet>;
    /**
     * Sets property photo's tag
     * @return OK
     */
    getPropertyTags(): Observable<PropertyTag[]>;
    /**
     * @return OK
     */
    anonymous(lang: string): Observable<{ [key: string]: any; }>;
    /**
     * @return OK
     */
    initiateWorkflow(body: InitiateWorkflowRequest): Observable<string>;
    /**
     * @return No Content
     */
    submitWorkflow(requestId: string): Observable<void>;
    /**
     * @return OK
     */
    assetOnboardGetWorkflowForReview(propertyId: string): Observable<GetWorkflowForPropertyResponse>;
    /**
     * @return OK
     */
    assetOnboardSendForReview(propertyId: string): Observable<SendForReviewResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class PortalApiService implements IPortalApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PORTAL_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    gets_current_application_version(): Observable<string> {
        let url_ = this.baseUrl + "/application-version";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGets_current_application_version(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGets_current_application_version(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGets_current_application_version(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve NBG branches from Neon Db
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @param body (optional) 
     * @return OK
     */
    getNbgBranches(page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined, body?: NbgBranchesRequest | undefined): Observable<NbgBranchResultSet> {
        let url_ = this.baseUrl + "/configuration/nearByNbgBranches?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNbgBranches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNbgBranches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NbgBranchResultSet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NbgBranchResultSet>;
        }));
    }

    protected processGetNbgBranches(response: HttpResponseBase): Observable<NbgBranchResultSet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NbgBranchResultSet.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get supported languages with calling codes
     * @return OK
     */
    getCountryCodes(): Observable<CountryCode[]> {
        let url_ = this.baseUrl + "/configuration/supported-languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountryCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountryCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryCode[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryCode[]>;
        }));
    }

    protected processGetCountryCodes(response: HttpResponseBase): Observable<CountryCode[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryCode.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets buyer feedback form for given request
     * @return OK
     */
    getBuyerFeedbackForm(requestId: string): Observable<BuyerFeedbackForm> {
        let url_ = this.baseUrl + "/forms/{requestId}/buyer-feedback";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBuyerFeedbackForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBuyerFeedbackForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuyerFeedbackForm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuyerFeedbackForm>;
        }));
    }

    protected processGetBuyerFeedbackForm(response: HttpResponseBase): Observable<BuyerFeedbackForm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BuyerFeedbackForm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Submits buyer feedback for given request
     * @return No Content
     */
    submitBuyerFeedback(requestId: string, body: FeedbackQuestion[]): Observable<void> {
        let url_ = this.baseUrl + "/forms/{requestId}/buyer-feedback";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitBuyerFeedback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitBuyerFeedback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSubmitBuyerFeedback(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Validates recaptcha response
     * @return No Content
     */
    validateRecaptcha(body: string): Observable<void> {
        let url_ = this.baseUrl + "/forms/recaptcha/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateRecaptcha(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateRecaptcha(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidateRecaptcha(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Records an interested buyer or seller
     * @return No Content
     */
    registerToWaitingList(body: WaitingListFormRequest): Observable<void> {
        let url_ = this.baseUrl + "/forms/waiting-list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterToWaitingList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterToWaitingList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRegisterToWaitingList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Generates site's sitemap.
     * @return No Content
     */
    generateSitemap(): Observable<void> {
        let url_ = this.baseUrl + "/generate-sitemap";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateSitemap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateSitemap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateSitemap(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPartialReport(propertyId: string): Observable<PropertyReportPartial> {
        let url_ = this.baseUrl + "/marketability/{propertyId}";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartialReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartialReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyReportPartial>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyReportPartial>;
        }));
    }

    protected processGetPartialReport(response: HttpResponseBase): Observable<PropertyReportPartial> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyReportPartial.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getReportDetails(propertyId: string): Observable<PropertyReport> {
        let url_ = this.baseUrl + "/marketability/{propertyId}/details";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyReport>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyReport>;
        }));
    }

    protected processGetReportDetails(response: HttpResponseBase): Observable<PropertyReport> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyReport.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPointsOfInterest(propertyId: string): Observable<PropertyPointOfInterest[]> {
        let url_ = this.baseUrl + "/marketability/{propertyId}/pois";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPointsOfInterest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPointsOfInterest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyPointOfInterest[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyPointOfInterest[]>;
        }));
    }

    protected processGetPointsOfInterest(response: HttpResponseBase): Observable<PropertyPointOfInterest[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PropertyPointOfInterest.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create account and account owner
     * @return OK
     */
    createAccountOwner(body: AccountOwner): Observable<string> {
        let url_ = this.baseUrl + "/my/account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAccountOwner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAccountOwner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateAccountOwner(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get account and account owner
     * @return OK
     */
    getAccountOwner(): Observable<AccountOwner> {
        let url_ = this.baseUrl + "/my/account";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountOwner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountOwner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountOwner>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountOwner>;
        }));
    }

    protected processGetAccountOwner(response: HttpResponseBase): Observable<AccountOwner> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountOwner.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update account owner
     * @return No Content
     */
    updateAccountOwner(body: AccountOwner): Observable<void> {
        let url_ = this.baseUrl + "/my/account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAccountOwner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAccountOwner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAccountOwner(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update UTM information.
     * @return No Content
     */
    updateAccountOwnerContact(body: UtmDetails): Observable<void> {
        let url_ = this.baseUrl + "/my/account-contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAccountOwnerContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAccountOwnerContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAccountOwnerContact(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create anonymous account and account owner from UTM information.
     * @return OK
     */
    createOrUpdateAnonymousAccount(body: UtmDetails): Observable<string> {
        let url_ = this.baseUrl + "/my/anonymous-account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateAnonymousAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateAnonymousAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateOrUpdateAnonymousAccount(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Accepts a message from the user
     * @return No Content
     */
    contactUs(body: ContactUsRequest): Observable<void> {
        let url_ = this.baseUrl + "/my/contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactUs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactUs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processContactUs(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all notifications for the user
     * @return OK
     */
    getNotifications(): Observable<Notifications> {
        let url_ = this.baseUrl + "/my/notifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Notifications>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Notifications>;
        }));
    }

    protected processGetNotifications(response: HttpResponseBase): Observable<Notifications> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Notifications.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets my requests
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @param nonMineRequestsCaseTypeCodes (optional) 
     * @param requestTypes (optional) 
     * @return OK
     */
    getMyRequests(page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined, nonMineRequestsCaseTypeCodes?: string[] | undefined, requestTypes?: RequestTypeFilter[] | undefined): Observable<MyRequestsResponseResultSet> {
        let url_ = this.baseUrl + "/my/requests?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (nonMineRequestsCaseTypeCodes === null)
            throw new Error("The parameter 'nonMineRequestsCaseTypeCodes' cannot be null.");
        else if (nonMineRequestsCaseTypeCodes !== undefined)
            nonMineRequestsCaseTypeCodes && nonMineRequestsCaseTypeCodes.forEach(item => { url_ += "NonMineRequestsCaseTypeCodes=" + encodeURIComponent("" + item) + "&"; });
        if (requestTypes === null)
            throw new Error("The parameter 'requestTypes' cannot be null.");
        else if (requestTypes !== undefined)
            requestTypes && requestTypes.forEach(item => { url_ += "RequestTypes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MyRequestsResponseResultSet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MyRequestsResponseResultSet>;
        }));
    }

    protected processGetMyRequests(response: HttpResponseBase): Observable<MyRequestsResponseResultSet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MyRequestsResponseResultSet.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * User saves a search
     * @return No Content
     */
    saveSearch(body: SavePropertySearchFilterRequest): Observable<void> {
        let url_ = this.baseUrl + "/my/searches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveSearch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all saved searches
     * @return OK
     */
    getSearches(savedSearchType: SavedSearchType): Observable<Search[]> {
        let url_ = this.baseUrl + "/my/searches?";
        if (savedSearchType === undefined || savedSearchType === null)
            throw new Error("The parameter 'savedSearchType' must be defined and cannot be null.");
        else
            url_ += "savedSearchType=" + encodeURIComponent("" + savedSearchType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSearches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSearches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Search[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Search[]>;
        }));
    }

    protected processGetSearches(response: HttpResponseBase): Observable<Search[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Search.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete search by Id
     * @return No Content
     */
    deleteSearch(searchId: string): Observable<void> {
        let url_ = this.baseUrl + "/my/searches/{searchId}";
        if (searchId === undefined || searchId === null)
            throw new Error("The parameter 'searchId' must be defined.");
        url_ = url_.replace("{searchId}", encodeURIComponent("" + searchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSearch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update notification frequency of saved search
     * @return No Content
     */
    updateSavedSearchFrequency(searchId: string, frequency: NotificationFrequency): Observable<void> {
        let url_ = this.baseUrl + "/my/searches/{searchId}/frequency?";
        if (searchId === undefined || searchId === null)
            throw new Error("The parameter 'searchId' must be defined.");
        url_ = url_.replace("{searchId}", encodeURIComponent("" + searchId));
        if (frequency === undefined || frequency === null)
            throw new Error("The parameter 'frequency' must be defined and cannot be null.");
        else
            url_ += "frequency=" + encodeURIComponent("" + frequency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSavedSearchFrequency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSavedSearchFrequency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSavedSearchFrequency(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save a user's search history
     * @return No Content
     */
    upsertSearchHistory(body: Search): Observable<void> {
        let url_ = this.baseUrl + "/my/searches/history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertSearchHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertSearchHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpsertSearchHistory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    acceptTerms(body: AcceptTnCRequest): Observable<void> {
        let url_ = this.baseUrl + "/my/terms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptTerms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptTerms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAcceptTerms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send a TOTP code
     * @return No Content
     */
    sendTotp(body: TotpRequestBody): Observable<void> {
        let url_ = this.baseUrl + "/my/totp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTotp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTotp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTotp(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Verify Totp code
     * @return No Content
     */
    verifyTotp(body: TotpVerificationBody): Observable<void> {
        let url_ = this.baseUrl + "/my/totp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyTotp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyTotp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVerifyTotp(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a partner by userId
     * @return OK
     */
    getPartner(userId: string): Observable<Partner> {
        let url_ = this.baseUrl + "/partners/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Partner>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Partner>;
        }));
    }

    protected processGetPartner(response: HttpResponseBase): Observable<Partner> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Partner.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get property listing (index)
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @param searchTerm (optional) 
     * @param minPrice (optional) 
     * @param maxPrice (optional) 
     * @param type (optional) 
     * @param minSqMeters (optional) 
     * @param maxSqMeters (optional) 
     * @param floor (optional) 
     * @param hasParking (optional) 
     * @param parkingSpace (optional) 
     * @param bedrooms (optional) 
     * @param bathrooms (optional) 
     * @param minConstructionYear (optional) 
     * @param maxConstructionYear (optional) 
     * @param preApproved (optional) 
     * @param inAuction (optional) 
     * @param auctionRound (optional) 
     * @param hasElevator (optional) 
     * @param hasAlarm (optional) 
     * @param isAiry (optional) 
     * @param sieves (optional) 
     * @param hasSolarWaterHeating (optional) 
     * @param hasBoiler (optional) 
     * @param suitableForProfessionalUse (optional) 
     * @param suitableForTouristUse (optional) 
     * @param hasNightElectricCurrent (optional) 
     * @param hasSafetyDoor (optional) 
     * @param isBright (optional) 
     * @param accessibilityForDisabled (optional) 
     * @param hasPlayroom (optional) 
     * @param isPenthouse (optional) 
     * @param hasGarden (optional) 
     * @param hasPool (optional) 
     * @param hasStorageRoom (optional) 
     * @param petsAreAllowed (optional) 
     * @param hasTents (optional) 
     * @param isFloorApartment (optional) 
     * @param internalStaircase (optional) 
     * @param view (optional) 
     * @param numberOfRooms (optional) 
     * @param numberOfBathRooms (optional) 
     * @param hasGym (optional) 
     * @param hasSeaView (optional) 
     * @param hasGreatView (optional) 
     * @param hasAirconditioning (optional) 
     * @param hasFirePlace (optional) 
     * @param heatingType (optional) 
     * @param heatingControl (optional) 
     * @param area (optional) 
     * @param clauses (optional) 
     * @param isREO (optional) 
     * @param isSold (optional) 
     * @param tag (optional) 
     * @param searchFromMap (optional) 
     * @param propertyIds (optional) 
     * @return OK
     */
    getPropertyList(includeDetails: boolean, page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined, searchTerm?: string | undefined, minPrice?: number | undefined, maxPrice?: number | undefined, type?: PropertyType[] | undefined, minSqMeters?: number | undefined, maxSqMeters?: number | undefined, floor?: FloorFilter[] | undefined, hasParking?: boolean | undefined, parkingSpace?: BedroomFilter[] | undefined, bedrooms?: BedroomFilter[] | undefined, bathrooms?: BedroomFilter[] | undefined, minConstructionYear?: number | undefined, maxConstructionYear?: number | undefined, preApproved?: boolean | undefined, inAuction?: boolean | undefined, auctionRound?: AuctionRoundFilter[] | undefined, hasElevator?: boolean | undefined, hasAlarm?: boolean | undefined, isAiry?: boolean | undefined, sieves?: boolean | undefined, hasSolarWaterHeating?: boolean | undefined, hasBoiler?: boolean | undefined, suitableForProfessionalUse?: boolean | undefined, suitableForTouristUse?: boolean | undefined, hasNightElectricCurrent?: boolean | undefined, hasSafetyDoor?: boolean | undefined, isBright?: boolean | undefined, accessibilityForDisabled?: boolean | undefined, hasPlayroom?: boolean | undefined, isPenthouse?: boolean | undefined, hasGarden?: boolean | undefined, hasPool?: boolean | undefined, hasStorageRoom?: boolean | undefined, petsAreAllowed?: boolean | undefined, hasTents?: boolean | undefined, isFloorApartment?: boolean | undefined, internalStaircase?: boolean | undefined, view?: string | undefined, numberOfRooms?: string | undefined, numberOfBathRooms?: string | undefined, hasGym?: boolean | undefined, hasSeaView?: boolean | undefined, hasGreatView?: boolean | undefined, hasAirconditioning?: boolean | undefined, hasFirePlace?: boolean | undefined, heatingType?: HeatingType[] | undefined, heatingControl?: HeatingControl[] | undefined, area?: string | undefined, clauses?: string | undefined, isREO?: boolean | undefined, isSold?: boolean | undefined, tag?: string[] | undefined, searchFromMap?: boolean | undefined, propertyIds?: string[] | undefined): Observable<PropertyListResponse> {
        let url_ = this.baseUrl + "/properties?";
        if (includeDetails === undefined || includeDetails === null)
            throw new Error("The parameter 'includeDetails' must be defined and cannot be null.");
        else
            url_ += "IncludeDetails=" + encodeURIComponent("" + includeDetails) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (searchTerm === null)
            throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (minPrice === null)
            throw new Error("The parameter 'minPrice' cannot be null.");
        else if (minPrice !== undefined)
            url_ += "MinPrice=" + encodeURIComponent("" + minPrice) + "&";
        if (maxPrice === null)
            throw new Error("The parameter 'maxPrice' cannot be null.");
        else if (maxPrice !== undefined)
            url_ += "MaxPrice=" + encodeURIComponent("" + maxPrice) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            type && type.forEach(item => { url_ += "Type=" + encodeURIComponent("" + item) + "&"; });
        if (minSqMeters === null)
            throw new Error("The parameter 'minSqMeters' cannot be null.");
        else if (minSqMeters !== undefined)
            url_ += "MinSqMeters=" + encodeURIComponent("" + minSqMeters) + "&";
        if (maxSqMeters === null)
            throw new Error("The parameter 'maxSqMeters' cannot be null.");
        else if (maxSqMeters !== undefined)
            url_ += "MaxSqMeters=" + encodeURIComponent("" + maxSqMeters) + "&";
        if (floor === null)
            throw new Error("The parameter 'floor' cannot be null.");
        else if (floor !== undefined)
            floor && floor.forEach(item => { url_ += "Floor=" + encodeURIComponent("" + item) + "&"; });
        if (hasParking === null)
            throw new Error("The parameter 'hasParking' cannot be null.");
        else if (hasParking !== undefined)
            url_ += "HasParking=" + encodeURIComponent("" + hasParking) + "&";
        if (parkingSpace === null)
            throw new Error("The parameter 'parkingSpace' cannot be null.");
        else if (parkingSpace !== undefined)
            parkingSpace && parkingSpace.forEach(item => { url_ += "ParkingSpace=" + encodeURIComponent("" + item) + "&"; });
        if (bedrooms === null)
            throw new Error("The parameter 'bedrooms' cannot be null.");
        else if (bedrooms !== undefined)
            bedrooms && bedrooms.forEach(item => { url_ += "Bedrooms=" + encodeURIComponent("" + item) + "&"; });
        if (bathrooms === null)
            throw new Error("The parameter 'bathrooms' cannot be null.");
        else if (bathrooms !== undefined)
            bathrooms && bathrooms.forEach(item => { url_ += "Bathrooms=" + encodeURIComponent("" + item) + "&"; });
        if (minConstructionYear === null)
            throw new Error("The parameter 'minConstructionYear' cannot be null.");
        else if (minConstructionYear !== undefined)
            url_ += "MinConstructionYear=" + encodeURIComponent("" + minConstructionYear) + "&";
        if (maxConstructionYear === null)
            throw new Error("The parameter 'maxConstructionYear' cannot be null.");
        else if (maxConstructionYear !== undefined)
            url_ += "MaxConstructionYear=" + encodeURIComponent("" + maxConstructionYear) + "&";
        if (preApproved === null)
            throw new Error("The parameter 'preApproved' cannot be null.");
        else if (preApproved !== undefined)
            url_ += "PreApproved=" + encodeURIComponent("" + preApproved) + "&";
        if (inAuction === null)
            throw new Error("The parameter 'inAuction' cannot be null.");
        else if (inAuction !== undefined)
            url_ += "InAuction=" + encodeURIComponent("" + inAuction) + "&";
        if (auctionRound === null)
            throw new Error("The parameter 'auctionRound' cannot be null.");
        else if (auctionRound !== undefined)
            auctionRound && auctionRound.forEach(item => { url_ += "AuctionRound=" + encodeURIComponent("" + item) + "&"; });
        if (hasElevator === null)
            throw new Error("The parameter 'hasElevator' cannot be null.");
        else if (hasElevator !== undefined)
            url_ += "HasElevator=" + encodeURIComponent("" + hasElevator) + "&";
        if (hasAlarm === null)
            throw new Error("The parameter 'hasAlarm' cannot be null.");
        else if (hasAlarm !== undefined)
            url_ += "HasAlarm=" + encodeURIComponent("" + hasAlarm) + "&";
        if (isAiry === null)
            throw new Error("The parameter 'isAiry' cannot be null.");
        else if (isAiry !== undefined)
            url_ += "IsAiry=" + encodeURIComponent("" + isAiry) + "&";
        if (sieves === null)
            throw new Error("The parameter 'sieves' cannot be null.");
        else if (sieves !== undefined)
            url_ += "Sieves=" + encodeURIComponent("" + sieves) + "&";
        if (hasSolarWaterHeating === null)
            throw new Error("The parameter 'hasSolarWaterHeating' cannot be null.");
        else if (hasSolarWaterHeating !== undefined)
            url_ += "HasSolarWaterHeating=" + encodeURIComponent("" + hasSolarWaterHeating) + "&";
        if (hasBoiler === null)
            throw new Error("The parameter 'hasBoiler' cannot be null.");
        else if (hasBoiler !== undefined)
            url_ += "HasBoiler=" + encodeURIComponent("" + hasBoiler) + "&";
        if (suitableForProfessionalUse === null)
            throw new Error("The parameter 'suitableForProfessionalUse' cannot be null.");
        else if (suitableForProfessionalUse !== undefined)
            url_ += "SuitableForProfessionalUse=" + encodeURIComponent("" + suitableForProfessionalUse) + "&";
        if (suitableForTouristUse === null)
            throw new Error("The parameter 'suitableForTouristUse' cannot be null.");
        else if (suitableForTouristUse !== undefined)
            url_ += "SuitableForTouristUse=" + encodeURIComponent("" + suitableForTouristUse) + "&";
        if (hasNightElectricCurrent === null)
            throw new Error("The parameter 'hasNightElectricCurrent' cannot be null.");
        else if (hasNightElectricCurrent !== undefined)
            url_ += "HasNightElectricCurrent=" + encodeURIComponent("" + hasNightElectricCurrent) + "&";
        if (hasSafetyDoor === null)
            throw new Error("The parameter 'hasSafetyDoor' cannot be null.");
        else if (hasSafetyDoor !== undefined)
            url_ += "HasSafetyDoor=" + encodeURIComponent("" + hasSafetyDoor) + "&";
        if (isBright === null)
            throw new Error("The parameter 'isBright' cannot be null.");
        else if (isBright !== undefined)
            url_ += "IsBright=" + encodeURIComponent("" + isBright) + "&";
        if (accessibilityForDisabled === null)
            throw new Error("The parameter 'accessibilityForDisabled' cannot be null.");
        else if (accessibilityForDisabled !== undefined)
            url_ += "AccessibilityForDisabled=" + encodeURIComponent("" + accessibilityForDisabled) + "&";
        if (hasPlayroom === null)
            throw new Error("The parameter 'hasPlayroom' cannot be null.");
        else if (hasPlayroom !== undefined)
            url_ += "HasPlayroom=" + encodeURIComponent("" + hasPlayroom) + "&";
        if (isPenthouse === null)
            throw new Error("The parameter 'isPenthouse' cannot be null.");
        else if (isPenthouse !== undefined)
            url_ += "IsPenthouse=" + encodeURIComponent("" + isPenthouse) + "&";
        if (hasGarden === null)
            throw new Error("The parameter 'hasGarden' cannot be null.");
        else if (hasGarden !== undefined)
            url_ += "HasGarden=" + encodeURIComponent("" + hasGarden) + "&";
        if (hasPool === null)
            throw new Error("The parameter 'hasPool' cannot be null.");
        else if (hasPool !== undefined)
            url_ += "HasPool=" + encodeURIComponent("" + hasPool) + "&";
        if (hasStorageRoom === null)
            throw new Error("The parameter 'hasStorageRoom' cannot be null.");
        else if (hasStorageRoom !== undefined)
            url_ += "HasStorageRoom=" + encodeURIComponent("" + hasStorageRoom) + "&";
        if (petsAreAllowed === null)
            throw new Error("The parameter 'petsAreAllowed' cannot be null.");
        else if (petsAreAllowed !== undefined)
            url_ += "PetsAreAllowed=" + encodeURIComponent("" + petsAreAllowed) + "&";
        if (hasTents === null)
            throw new Error("The parameter 'hasTents' cannot be null.");
        else if (hasTents !== undefined)
            url_ += "HasTents=" + encodeURIComponent("" + hasTents) + "&";
        if (isFloorApartment === null)
            throw new Error("The parameter 'isFloorApartment' cannot be null.");
        else if (isFloorApartment !== undefined)
            url_ += "IsFloorApartment=" + encodeURIComponent("" + isFloorApartment) + "&";
        if (internalStaircase === null)
            throw new Error("The parameter 'internalStaircase' cannot be null.");
        else if (internalStaircase !== undefined)
            url_ += "InternalStaircase=" + encodeURIComponent("" + internalStaircase) + "&";
        if (view === null)
            throw new Error("The parameter 'view' cannot be null.");
        else if (view !== undefined)
            url_ += "View=" + encodeURIComponent("" + view) + "&";
        if (numberOfRooms === null)
            throw new Error("The parameter 'numberOfRooms' cannot be null.");
        else if (numberOfRooms !== undefined)
            url_ += "NumberOfRooms=" + encodeURIComponent("" + numberOfRooms) + "&";
        if (numberOfBathRooms === null)
            throw new Error("The parameter 'numberOfBathRooms' cannot be null.");
        else if (numberOfBathRooms !== undefined)
            url_ += "NumberOfBathRooms=" + encodeURIComponent("" + numberOfBathRooms) + "&";
        if (hasGym === null)
            throw new Error("The parameter 'hasGym' cannot be null.");
        else if (hasGym !== undefined)
            url_ += "HasGym=" + encodeURIComponent("" + hasGym) + "&";
        if (hasSeaView === null)
            throw new Error("The parameter 'hasSeaView' cannot be null.");
        else if (hasSeaView !== undefined)
            url_ += "HasSeaView=" + encodeURIComponent("" + hasSeaView) + "&";
        if (hasGreatView === null)
            throw new Error("The parameter 'hasGreatView' cannot be null.");
        else if (hasGreatView !== undefined)
            url_ += "HasGreatView=" + encodeURIComponent("" + hasGreatView) + "&";
        if (hasAirconditioning === null)
            throw new Error("The parameter 'hasAirconditioning' cannot be null.");
        else if (hasAirconditioning !== undefined)
            url_ += "HasAirconditioning=" + encodeURIComponent("" + hasAirconditioning) + "&";
        if (hasFirePlace === null)
            throw new Error("The parameter 'hasFirePlace' cannot be null.");
        else if (hasFirePlace !== undefined)
            url_ += "HasFirePlace=" + encodeURIComponent("" + hasFirePlace) + "&";
        if (heatingType === null)
            throw new Error("The parameter 'heatingType' cannot be null.");
        else if (heatingType !== undefined)
            heatingType && heatingType.forEach(item => { url_ += "HeatingType=" + encodeURIComponent("" + item) + "&"; });
        if (heatingControl === null)
            throw new Error("The parameter 'heatingControl' cannot be null.");
        else if (heatingControl !== undefined)
            heatingControl && heatingControl.forEach(item => { url_ += "HeatingControl=" + encodeURIComponent("" + item) + "&"; });
        if (area === null)
            throw new Error("The parameter 'area' cannot be null.");
        else if (area !== undefined)
            url_ += "Area=" + encodeURIComponent("" + area) + "&";
        if (clauses === null)
            throw new Error("The parameter 'clauses' cannot be null.");
        else if (clauses !== undefined)
            url_ += "Clauses=" + encodeURIComponent("" + clauses) + "&";
        if (isREO === null)
            throw new Error("The parameter 'isREO' cannot be null.");
        else if (isREO !== undefined)
            url_ += "IsREO=" + encodeURIComponent("" + isREO) + "&";
        if (isSold === null)
            throw new Error("The parameter 'isSold' cannot be null.");
        else if (isSold !== undefined)
            url_ += "IsSold=" + encodeURIComponent("" + isSold) + "&";
        if (tag === null)
            throw new Error("The parameter 'tag' cannot be null.");
        else if (tag !== undefined)
            tag && tag.forEach(item => { url_ += "Tag=" + encodeURIComponent("" + item) + "&"; });
        if (searchFromMap === null)
            throw new Error("The parameter 'searchFromMap' cannot be null.");
        else if (searchFromMap !== undefined)
            url_ += "SearchFromMap=" + encodeURIComponent("" + searchFromMap) + "&";
        if (propertyIds === null)
            throw new Error("The parameter 'propertyIds' cannot be null.");
        else if (propertyIds !== undefined)
            propertyIds && propertyIds.forEach(item => { url_ += "PropertyIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPropertyList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPropertyList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyListResponse>;
        }));
    }

    protected processGetPropertyList(response: HttpResponseBase): Observable<PropertyListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Verify the Postal Code is allowed
     * @return OK
     */
    postalCodeIsAllowed(postalCode: string): Observable<void> {
        let url_ = this.baseUrl + "/properties/{postal-code}/allowed?";
        if (postalCode === undefined || postalCode === null)
            throw new Error("The parameter 'postalCode' must be defined and cannot be null.");
        else
            url_ += "postalCode=" + encodeURIComponent("" + postalCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostalCodeIsAllowed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostalCodeIsAllowed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostalCodeIsAllowed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get buying property's listing details
     * @return OK
     */
    getBuyingListingDetails(propertyCode: string): Observable<PropertyListingDetails> {
        let url_ = this.baseUrl + "/properties/{propertyCode}/buying-listing-details";
        if (propertyCode === undefined || propertyCode === null)
            throw new Error("The parameter 'propertyCode' must be defined.");
        url_ = url_.replace("{propertyCode}", encodeURIComponent("" + propertyCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBuyingListingDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBuyingListingDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyListingDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyListingDetails>;
        }));
    }

    protected processGetBuyingListingDetails(response: HttpResponseBase): Observable<PropertyListingDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyListingDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get property's listing details
     * @return OK
     */
    getListingDetails(propertyCode: string): Observable<PropertyListingDetails> {
        let url_ = this.baseUrl + "/properties/{propertyCode}/listing-details";
        if (propertyCode === undefined || propertyCode === null)
            throw new Error("The parameter 'propertyCode' must be defined.");
        url_ = url_.replace("{propertyCode}", encodeURIComponent("" + propertyCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListingDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListingDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyListingDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyListingDetails>;
        }));
    }

    protected processGetListingDetails(response: HttpResponseBase): Observable<PropertyListingDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyListingDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the analytics for the requested property
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @return OK
     */
    getAnalytics(propertyId: string, lastDays: number, page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined): Observable<PropertyAnalytics> {
        let url_ = this.baseUrl + "/properties/{propertyId}/analytics?";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        if (lastDays === undefined || lastDays === null)
            throw new Error("The parameter 'lastDays' must be defined and cannot be null.");
        else
            url_ += "LastDays=" + encodeURIComponent("" + lastDays) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnalytics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnalytics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyAnalytics>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyAnalytics>;
        }));
    }

    protected processGetAnalytics(response: HttpResponseBase): Observable<PropertyAnalytics> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyAnalytics.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Toggle a property as favorite for the logged in user
     * @return No Content
     */
    togglePropertyFavorite(propertyId: string): Observable<void> {
        let url_ = this.baseUrl + "/properties/{propertyId}/favorite";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTogglePropertyFavorite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTogglePropertyFavorite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTogglePropertyFavorite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the list of offers the user made for the requested property
     * @param includeExpired (optional) 
     * @return OK
     */
    getMyOffersForProperty(propertyId: string, includeExpired?: boolean | undefined): Observable<PropertyOffersBuyerResponse> {
        let url_ = this.baseUrl + "/properties/{propertyId}/my-offers?";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        if (includeExpired === null)
            throw new Error("The parameter 'includeExpired' cannot be null.");
        else if (includeExpired !== undefined)
            url_ += "includeExpired=" + encodeURIComponent("" + includeExpired) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyOffersForProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyOffersForProperty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyOffersBuyerResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyOffersBuyerResponse>;
        }));
    }

    protected processGetMyOffersForProperty(response: HttpResponseBase): Observable<PropertyOffersBuyerResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyOffersBuyerResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Accepts or rejects an offer for a specific property
     * @return No Content
     */
    submitOfferResult(propertyId: string, offerId: string, body: SubmitOfferResultRequest): Observable<void> {
        let url_ = this.baseUrl + "/properties/{propertyId}/offers/{offerId}/submit-result";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        if (offerId === undefined || offerId === null)
            throw new Error("The parameter 'offerId' must be defined.");
        url_ = url_.replace("{offerId}", encodeURIComponent("" + offerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitOfferResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitOfferResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSubmitOfferResult(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets property's photos
     * @param isDraft (optional) 
     * @return OK
     */
    getPhotos(propertyId: string, isDraft?: boolean | undefined): Observable<PhotoResultSet> {
        let url_ = this.baseUrl + "/properties/{propertyId}/photos?";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        if (isDraft === null)
            throw new Error("The parameter 'isDraft' cannot be null.");
        else if (isDraft !== undefined)
            url_ += "isDraft=" + encodeURIComponent("" + isDraft) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPhotos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPhotos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhotoResultSet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhotoResultSet>;
        }));
    }

    protected processGetPhotos(response: HttpResponseBase): Observable<PhotoResultSet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhotoResultSet.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Uploads property's photo
     * @param file (optional) 
     * @param fileName (optional) 
     * @param length (optional) 
     * @param isDefault (optional) 
     * @param order (optional) 
     * @return OK
     */
    uploadPhoto(propertyId: string, file?: FileParameter | null | undefined, fileName?: string | null | undefined, length?: number | null | undefined, isDefault?: boolean | undefined, order?: number | null | undefined): Observable<Photo> {
        let url_ = this.baseUrl + "/properties/{propertyId}/photos";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (fileName !== null && fileName !== undefined)
            content_.append("fileName", fileName.toString());
        if (length !== null && length !== undefined)
            content_.append("length", length.toString());
        if (isDefault === null || isDefault === undefined)
            throw new Error("The parameter 'isDefault' cannot be null.");
        else
            content_.append("isDefault", isDefault.toString());
        if (order !== null && order !== undefined)
            content_.append("order", order.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadPhoto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadPhoto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Photo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Photo>;
        }));
    }

    protected processUploadPhoto(response: HttpResponseBase): Observable<Photo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Photo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes property's photo
     * @return No Content
     */
    deletePhoto(propertyId: string, mediaGuid: string): Observable<void> {
        let url_ = this.baseUrl + "/properties/{propertyId}/photos/{mediaGuid}";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        if (mediaGuid === undefined || mediaGuid === null)
            throw new Error("The parameter 'mediaGuid' must be defined.");
        url_ = url_.replace("{mediaGuid}", encodeURIComponent("" + mediaGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePhoto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePhoto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePhoto(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sets property photo's tag
     * @param body (optional) 
     * @return No Content
     */
    updateMediaTag(propertyId: string, mediaGuid: string, body?: MediaTag | undefined): Observable<void> {
        let url_ = this.baseUrl + "/properties/{propertyId}/photos/{mediaGuid}/tag";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        if (mediaGuid === undefined || mediaGuid === null)
            throw new Error("The parameter 'mediaGuid' must be defined.");
        url_ = url_.replace("{mediaGuid}", encodeURIComponent("" + mediaGuid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMediaTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMediaTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMediaTag(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Orders property's photos
     * @return No Content
     */
    updateMediaOrder(propertyId: string, body: MediaOrderRequest): Observable<void> {
        let url_ = this.baseUrl + "/properties/{propertyId}/photos/order";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMediaOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMediaOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMediaOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all the offers for this property
     * @param includeExpired (optional) 
     * @return OK
     */
    getOffersForProperty(propertyId: string, includeExpired?: boolean | undefined): Observable<PropertyOffersSellerResponse> {
        let url_ = this.baseUrl + "/properties/{propertyId}/property-offers?";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        if (includeExpired === null)
            throw new Error("The parameter 'includeExpired' cannot be null.");
        else if (includeExpired !== undefined)
            url_ += "includeExpired=" + encodeURIComponent("" + includeExpired) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOffersForProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOffersForProperty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyOffersSellerResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyOffersSellerResponse>;
        }));
    }

    protected processGetOffersForProperty(response: HttpResponseBase): Observable<PropertyOffersSellerResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyOffersSellerResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get related properties based on the property selected
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @return OK
     */
    getRelatedProperties(propertyId: string, page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined): Observable<PropertySummaryResultSet> {
        let url_ = this.baseUrl + "/properties/{propertyId}/related?";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelatedProperties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelatedProperties(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertySummaryResultSet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertySummaryResultSet>;
        }));
    }

    protected processGetRelatedProperties(response: HttpResponseBase): Observable<PropertySummaryResultSet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertySummaryResultSet.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @param caseTypeCodes (optional) 
     * @return OK
     */
    listPropertyRequests(propertyId: string, page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined, caseTypeCodes?: string[] | undefined): Observable<CasePartialResultSet> {
        let url_ = this.baseUrl + "/properties/{propertyId}/requests?";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (caseTypeCodes === null)
            throw new Error("The parameter 'caseTypeCodes' cannot be null.");
        else if (caseTypeCodes !== undefined)
            caseTypeCodes && caseTypeCodes.forEach(item => { url_ += "CaseTypeCodes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListPropertyRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListPropertyRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CasePartialResultSet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CasePartialResultSet>;
        }));
    }

    protected processListPropertyRequests(response: HttpResponseBase): Observable<CasePartialResultSet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CasePartialResultSet.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getThreeDCode(propertyId: string): Observable<ThreeDTourMedia> {
        let url_ = this.baseUrl + "/properties/{propertyId}/three-d-code";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetThreeDCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetThreeDCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ThreeDTourMedia>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ThreeDTourMedia>;
        }));
    }

    protected processGetThreeDCode(response: HttpResponseBase): Observable<ThreeDTourMedia> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ThreeDTourMedia.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds a property to recently viewed. Max 10 entries
     * @return No Content
     */
    addRecentlyViewed(propertyId: string): Observable<void> {
        let url_ = this.baseUrl + "/properties/{propertyId}/viewed";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRecentlyViewed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRecentlyViewed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddRecentlyViewed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get property details by property Id or code
     * @return OK
     */
    getPropertyById(propertyIdOrCode: string): Observable<PropertyDetails> {
        let url_ = this.baseUrl + "/properties/{propertyIdOrCode}";
        if (propertyIdOrCode === undefined || propertyIdOrCode === null)
            throw new Error("The parameter 'propertyIdOrCode' must be defined.");
        url_ = url_.replace("{propertyIdOrCode}", encodeURIComponent("" + propertyIdOrCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPropertyById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPropertyById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyDetails>;
        }));
    }

    protected processGetPropertyById(response: HttpResponseBase): Observable<PropertyDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get property details by property Id or code
     * @return OK
     */
    getPropertyByIdUnmasked(propertyIdOrCode: string): Observable<PropertyDetails> {
        let url_ = this.baseUrl + "/properties/{propertyIdOrCode}/unmasked";
        if (propertyIdOrCode === undefined || propertyIdOrCode === null)
            throw new Error("The parameter 'propertyIdOrCode' must be defined.");
        url_ = url_.replace("{propertyIdOrCode}", encodeURIComponent("" + propertyIdOrCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPropertyByIdUnmasked(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPropertyByIdUnmasked(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyDetails>;
        }));
    }

    protected processGetPropertyByIdUnmasked(response: HttpResponseBase): Observable<PropertyDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a list with properties containing the address info
     * @param propertyIds (optional) 
     * @return OK
     */
    getPropertyAddressInfo(propertyIds?: string[] | undefined): Observable<PropertyAddressInfo[]> {
        let url_ = this.baseUrl + "/properties/addresses?";
        if (propertyIds === null)
            throw new Error("The parameter 'propertyIds' cannot be null.");
        else if (propertyIds !== undefined)
            propertyIds && propertyIds.forEach(item => { url_ += "PropertyIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPropertyAddressInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPropertyAddressInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyAddressInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyAddressInfo[]>;
        }));
    }

    protected processGetPropertyAddressInfo(response: HttpResponseBase): Observable<PropertyAddressInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PropertyAddressInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get property details by property Id or code, independent of the property status
     * @return OK
     */
    getPropertyByIdOrCode(propertyIdOrCode: string): Observable<PropertyDetails> {
        let url_ = this.baseUrl + "/properties/all/{propertyIdOrCode}";
        if (propertyIdOrCode === undefined || propertyIdOrCode === null)
            throw new Error("The parameter 'propertyIdOrCode' must be defined.");
        url_ = url_.replace("{propertyIdOrCode}", encodeURIComponent("" + propertyIdOrCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPropertyByIdOrCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPropertyByIdOrCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyDetails>;
        }));
    }

    protected processGetPropertyByIdOrCode(response: HttpResponseBase): Observable<PropertyDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets buying properties
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @return OK
     */
    getMyBuyingProperties(page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined): Observable<PropertySummaryBuyingResultSet> {
        let url_ = this.baseUrl + "/properties/buying?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyBuyingProperties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyBuyingProperties(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertySummaryBuyingResultSet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertySummaryBuyingResultSet>;
        }));
    }

    protected processGetMyBuyingProperties(response: HttpResponseBase): Observable<PropertySummaryBuyingResultSet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertySummaryBuyingResultSet.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get property details by property Id or code only if the property is in draft status
     * @return OK
     */
    getDraftPropertyById(propertyIdOrCode: string): Observable<PropertyDetails> {
        let url_ = this.baseUrl + "/properties/draft/{propertyIdOrCode}";
        if (propertyIdOrCode === undefined || propertyIdOrCode === null)
            throw new Error("The parameter 'propertyIdOrCode' must be defined.");
        url_ = url_.replace("{propertyIdOrCode}", encodeURIComponent("" + propertyIdOrCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDraftPropertyById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDraftPropertyById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyDetails>;
        }));
    }

    protected processGetDraftPropertyById(response: HttpResponseBase): Observable<PropertyDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Resolves property ownership
     * @param code (optional) 
     * @param id (optional) 
     * @return OK
     */
    resolveOwnership(code?: string | undefined, id?: string | undefined): Observable<PropertyOwnershipResponse> {
        let url_ = this.baseUrl + "/properties/is-mine?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveOwnership(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveOwnership(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyOwnershipResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyOwnershipResponse>;
        }));
    }

    protected processResolveOwnership(response: HttpResponseBase): Observable<PropertyOwnershipResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyOwnershipResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Post a new property listing and returns the created property Id & Code
     * @return OK
     */
    postListing(body: ListingUploadInfo): Observable<CreateListingResponse> {
        let url_ = this.baseUrl + "/properties/listing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostListing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostListing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateListingResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateListingResponse>;
        }));
    }

    protected processPostListing(response: HttpResponseBase): Observable<CreateListingResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateListingResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update property's listing details
     * @return No Content
     */
    updateListingDetails(body: PropertyListingDetailsUpsertRequest): Observable<void> {
        let url_ = this.baseUrl + "/properties/listing-details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateListingDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateListingDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateListingDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get property listing for map (index)
     * @param searchTerm (optional) 
     * @param minPrice (optional) 
     * @param maxPrice (optional) 
     * @param type (optional) 
     * @param minSqMeters (optional) 
     * @param maxSqMeters (optional) 
     * @param floor (optional) 
     * @param hasParking (optional) 
     * @param parkingSpace (optional) 
     * @param bedrooms (optional) 
     * @param bathrooms (optional) 
     * @param minConstructionYear (optional) 
     * @param maxConstructionYear (optional) 
     * @param preApproved (optional) 
     * @param inAuction (optional) 
     * @param auctionRound (optional) 
     * @param hasElevator (optional) 
     * @param hasAlarm (optional) 
     * @param isAiry (optional) 
     * @param sieves (optional) 
     * @param hasSolarWaterHeating (optional) 
     * @param hasBoiler (optional) 
     * @param suitableForProfessionalUse (optional) 
     * @param suitableForTouristUse (optional) 
     * @param hasNightElectricCurrent (optional) 
     * @param hasSafetyDoor (optional) 
     * @param isBright (optional) 
     * @param accessibilityForDisabled (optional) 
     * @param hasPlayroom (optional) 
     * @param isPenthouse (optional) 
     * @param hasGarden (optional) 
     * @param hasPool (optional) 
     * @param hasStorageRoom (optional) 
     * @param petsAreAllowed (optional) 
     * @param hasTents (optional) 
     * @param isFloorApartment (optional) 
     * @param internalStaircase (optional) 
     * @param view (optional) 
     * @param numberOfRooms (optional) 
     * @param numberOfBathRooms (optional) 
     * @param hasGym (optional) 
     * @param hasSeaView (optional) 
     * @param hasGreatView (optional) 
     * @param hasAirconditioning (optional) 
     * @param hasFirePlace (optional) 
     * @param heatingType (optional) 
     * @param heatingControl (optional) 
     * @param area (optional) 
     * @param clauses (optional) 
     * @param isREO (optional) 
     * @param isSold (optional) 
     * @param tag (optional) 
     * @param searchFromMap (optional) 
     * @param propertyIds (optional) 
     * @return OK
     */
    getPropertyListForMap(includeDetails: boolean, searchTerm?: string | undefined, minPrice?: number | undefined, maxPrice?: number | undefined, type?: PropertyType[] | undefined, minSqMeters?: number | undefined, maxSqMeters?: number | undefined, floor?: FloorFilter[] | undefined, hasParking?: boolean | undefined, parkingSpace?: BedroomFilter[] | undefined, bedrooms?: BedroomFilter[] | undefined, bathrooms?: BedroomFilter[] | undefined, minConstructionYear?: number | undefined, maxConstructionYear?: number | undefined, preApproved?: boolean | undefined, inAuction?: boolean | undefined, auctionRound?: AuctionRoundFilter[] | undefined, hasElevator?: boolean | undefined, hasAlarm?: boolean | undefined, isAiry?: boolean | undefined, sieves?: boolean | undefined, hasSolarWaterHeating?: boolean | undefined, hasBoiler?: boolean | undefined, suitableForProfessionalUse?: boolean | undefined, suitableForTouristUse?: boolean | undefined, hasNightElectricCurrent?: boolean | undefined, hasSafetyDoor?: boolean | undefined, isBright?: boolean | undefined, accessibilityForDisabled?: boolean | undefined, hasPlayroom?: boolean | undefined, isPenthouse?: boolean | undefined, hasGarden?: boolean | undefined, hasPool?: boolean | undefined, hasStorageRoom?: boolean | undefined, petsAreAllowed?: boolean | undefined, hasTents?: boolean | undefined, isFloorApartment?: boolean | undefined, internalStaircase?: boolean | undefined, view?: string | undefined, numberOfRooms?: string | undefined, numberOfBathRooms?: string | undefined, hasGym?: boolean | undefined, hasSeaView?: boolean | undefined, hasGreatView?: boolean | undefined, hasAirconditioning?: boolean | undefined, hasFirePlace?: boolean | undefined, heatingType?: HeatingType[] | undefined, heatingControl?: HeatingControl[] | undefined, area?: string | undefined, clauses?: string | undefined, isREO?: boolean | undefined, isSold?: boolean | undefined, tag?: string[] | undefined, searchFromMap?: boolean | undefined, propertyIds?: string[] | undefined): Observable<PropertyListForMapResponse> {
        let url_ = this.baseUrl + "/properties/map?";
        if (includeDetails === undefined || includeDetails === null)
            throw new Error("The parameter 'includeDetails' must be defined and cannot be null.");
        else
            url_ += "IncludeDetails=" + encodeURIComponent("" + includeDetails) + "&";
        if (searchTerm === null)
            throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (minPrice === null)
            throw new Error("The parameter 'minPrice' cannot be null.");
        else if (minPrice !== undefined)
            url_ += "MinPrice=" + encodeURIComponent("" + minPrice) + "&";
        if (maxPrice === null)
            throw new Error("The parameter 'maxPrice' cannot be null.");
        else if (maxPrice !== undefined)
            url_ += "MaxPrice=" + encodeURIComponent("" + maxPrice) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            type && type.forEach(item => { url_ += "Type=" + encodeURIComponent("" + item) + "&"; });
        if (minSqMeters === null)
            throw new Error("The parameter 'minSqMeters' cannot be null.");
        else if (minSqMeters !== undefined)
            url_ += "MinSqMeters=" + encodeURIComponent("" + minSqMeters) + "&";
        if (maxSqMeters === null)
            throw new Error("The parameter 'maxSqMeters' cannot be null.");
        else if (maxSqMeters !== undefined)
            url_ += "MaxSqMeters=" + encodeURIComponent("" + maxSqMeters) + "&";
        if (floor === null)
            throw new Error("The parameter 'floor' cannot be null.");
        else if (floor !== undefined)
            floor && floor.forEach(item => { url_ += "Floor=" + encodeURIComponent("" + item) + "&"; });
        if (hasParking === null)
            throw new Error("The parameter 'hasParking' cannot be null.");
        else if (hasParking !== undefined)
            url_ += "HasParking=" + encodeURIComponent("" + hasParking) + "&";
        if (parkingSpace === null)
            throw new Error("The parameter 'parkingSpace' cannot be null.");
        else if (parkingSpace !== undefined)
            parkingSpace && parkingSpace.forEach(item => { url_ += "ParkingSpace=" + encodeURIComponent("" + item) + "&"; });
        if (bedrooms === null)
            throw new Error("The parameter 'bedrooms' cannot be null.");
        else if (bedrooms !== undefined)
            bedrooms && bedrooms.forEach(item => { url_ += "Bedrooms=" + encodeURIComponent("" + item) + "&"; });
        if (bathrooms === null)
            throw new Error("The parameter 'bathrooms' cannot be null.");
        else if (bathrooms !== undefined)
            bathrooms && bathrooms.forEach(item => { url_ += "Bathrooms=" + encodeURIComponent("" + item) + "&"; });
        if (minConstructionYear === null)
            throw new Error("The parameter 'minConstructionYear' cannot be null.");
        else if (minConstructionYear !== undefined)
            url_ += "MinConstructionYear=" + encodeURIComponent("" + minConstructionYear) + "&";
        if (maxConstructionYear === null)
            throw new Error("The parameter 'maxConstructionYear' cannot be null.");
        else if (maxConstructionYear !== undefined)
            url_ += "MaxConstructionYear=" + encodeURIComponent("" + maxConstructionYear) + "&";
        if (preApproved === null)
            throw new Error("The parameter 'preApproved' cannot be null.");
        else if (preApproved !== undefined)
            url_ += "PreApproved=" + encodeURIComponent("" + preApproved) + "&";
        if (inAuction === null)
            throw new Error("The parameter 'inAuction' cannot be null.");
        else if (inAuction !== undefined)
            url_ += "InAuction=" + encodeURIComponent("" + inAuction) + "&";
        if (auctionRound === null)
            throw new Error("The parameter 'auctionRound' cannot be null.");
        else if (auctionRound !== undefined)
            auctionRound && auctionRound.forEach(item => { url_ += "AuctionRound=" + encodeURIComponent("" + item) + "&"; });
        if (hasElevator === null)
            throw new Error("The parameter 'hasElevator' cannot be null.");
        else if (hasElevator !== undefined)
            url_ += "HasElevator=" + encodeURIComponent("" + hasElevator) + "&";
        if (hasAlarm === null)
            throw new Error("The parameter 'hasAlarm' cannot be null.");
        else if (hasAlarm !== undefined)
            url_ += "HasAlarm=" + encodeURIComponent("" + hasAlarm) + "&";
        if (isAiry === null)
            throw new Error("The parameter 'isAiry' cannot be null.");
        else if (isAiry !== undefined)
            url_ += "IsAiry=" + encodeURIComponent("" + isAiry) + "&";
        if (sieves === null)
            throw new Error("The parameter 'sieves' cannot be null.");
        else if (sieves !== undefined)
            url_ += "Sieves=" + encodeURIComponent("" + sieves) + "&";
        if (hasSolarWaterHeating === null)
            throw new Error("The parameter 'hasSolarWaterHeating' cannot be null.");
        else if (hasSolarWaterHeating !== undefined)
            url_ += "HasSolarWaterHeating=" + encodeURIComponent("" + hasSolarWaterHeating) + "&";
        if (hasBoiler === null)
            throw new Error("The parameter 'hasBoiler' cannot be null.");
        else if (hasBoiler !== undefined)
            url_ += "HasBoiler=" + encodeURIComponent("" + hasBoiler) + "&";
        if (suitableForProfessionalUse === null)
            throw new Error("The parameter 'suitableForProfessionalUse' cannot be null.");
        else if (suitableForProfessionalUse !== undefined)
            url_ += "SuitableForProfessionalUse=" + encodeURIComponent("" + suitableForProfessionalUse) + "&";
        if (suitableForTouristUse === null)
            throw new Error("The parameter 'suitableForTouristUse' cannot be null.");
        else if (suitableForTouristUse !== undefined)
            url_ += "SuitableForTouristUse=" + encodeURIComponent("" + suitableForTouristUse) + "&";
        if (hasNightElectricCurrent === null)
            throw new Error("The parameter 'hasNightElectricCurrent' cannot be null.");
        else if (hasNightElectricCurrent !== undefined)
            url_ += "HasNightElectricCurrent=" + encodeURIComponent("" + hasNightElectricCurrent) + "&";
        if (hasSafetyDoor === null)
            throw new Error("The parameter 'hasSafetyDoor' cannot be null.");
        else if (hasSafetyDoor !== undefined)
            url_ += "HasSafetyDoor=" + encodeURIComponent("" + hasSafetyDoor) + "&";
        if (isBright === null)
            throw new Error("The parameter 'isBright' cannot be null.");
        else if (isBright !== undefined)
            url_ += "IsBright=" + encodeURIComponent("" + isBright) + "&";
        if (accessibilityForDisabled === null)
            throw new Error("The parameter 'accessibilityForDisabled' cannot be null.");
        else if (accessibilityForDisabled !== undefined)
            url_ += "AccessibilityForDisabled=" + encodeURIComponent("" + accessibilityForDisabled) + "&";
        if (hasPlayroom === null)
            throw new Error("The parameter 'hasPlayroom' cannot be null.");
        else if (hasPlayroom !== undefined)
            url_ += "HasPlayroom=" + encodeURIComponent("" + hasPlayroom) + "&";
        if (isPenthouse === null)
            throw new Error("The parameter 'isPenthouse' cannot be null.");
        else if (isPenthouse !== undefined)
            url_ += "IsPenthouse=" + encodeURIComponent("" + isPenthouse) + "&";
        if (hasGarden === null)
            throw new Error("The parameter 'hasGarden' cannot be null.");
        else if (hasGarden !== undefined)
            url_ += "HasGarden=" + encodeURIComponent("" + hasGarden) + "&";
        if (hasPool === null)
            throw new Error("The parameter 'hasPool' cannot be null.");
        else if (hasPool !== undefined)
            url_ += "HasPool=" + encodeURIComponent("" + hasPool) + "&";
        if (hasStorageRoom === null)
            throw new Error("The parameter 'hasStorageRoom' cannot be null.");
        else if (hasStorageRoom !== undefined)
            url_ += "HasStorageRoom=" + encodeURIComponent("" + hasStorageRoom) + "&";
        if (petsAreAllowed === null)
            throw new Error("The parameter 'petsAreAllowed' cannot be null.");
        else if (petsAreAllowed !== undefined)
            url_ += "PetsAreAllowed=" + encodeURIComponent("" + petsAreAllowed) + "&";
        if (hasTents === null)
            throw new Error("The parameter 'hasTents' cannot be null.");
        else if (hasTents !== undefined)
            url_ += "HasTents=" + encodeURIComponent("" + hasTents) + "&";
        if (isFloorApartment === null)
            throw new Error("The parameter 'isFloorApartment' cannot be null.");
        else if (isFloorApartment !== undefined)
            url_ += "IsFloorApartment=" + encodeURIComponent("" + isFloorApartment) + "&";
        if (internalStaircase === null)
            throw new Error("The parameter 'internalStaircase' cannot be null.");
        else if (internalStaircase !== undefined)
            url_ += "InternalStaircase=" + encodeURIComponent("" + internalStaircase) + "&";
        if (view === null)
            throw new Error("The parameter 'view' cannot be null.");
        else if (view !== undefined)
            url_ += "View=" + encodeURIComponent("" + view) + "&";
        if (numberOfRooms === null)
            throw new Error("The parameter 'numberOfRooms' cannot be null.");
        else if (numberOfRooms !== undefined)
            url_ += "NumberOfRooms=" + encodeURIComponent("" + numberOfRooms) + "&";
        if (numberOfBathRooms === null)
            throw new Error("The parameter 'numberOfBathRooms' cannot be null.");
        else if (numberOfBathRooms !== undefined)
            url_ += "NumberOfBathRooms=" + encodeURIComponent("" + numberOfBathRooms) + "&";
        if (hasGym === null)
            throw new Error("The parameter 'hasGym' cannot be null.");
        else if (hasGym !== undefined)
            url_ += "HasGym=" + encodeURIComponent("" + hasGym) + "&";
        if (hasSeaView === null)
            throw new Error("The parameter 'hasSeaView' cannot be null.");
        else if (hasSeaView !== undefined)
            url_ += "HasSeaView=" + encodeURIComponent("" + hasSeaView) + "&";
        if (hasGreatView === null)
            throw new Error("The parameter 'hasGreatView' cannot be null.");
        else if (hasGreatView !== undefined)
            url_ += "HasGreatView=" + encodeURIComponent("" + hasGreatView) + "&";
        if (hasAirconditioning === null)
            throw new Error("The parameter 'hasAirconditioning' cannot be null.");
        else if (hasAirconditioning !== undefined)
            url_ += "HasAirconditioning=" + encodeURIComponent("" + hasAirconditioning) + "&";
        if (hasFirePlace === null)
            throw new Error("The parameter 'hasFirePlace' cannot be null.");
        else if (hasFirePlace !== undefined)
            url_ += "HasFirePlace=" + encodeURIComponent("" + hasFirePlace) + "&";
        if (heatingType === null)
            throw new Error("The parameter 'heatingType' cannot be null.");
        else if (heatingType !== undefined)
            heatingType && heatingType.forEach(item => { url_ += "HeatingType=" + encodeURIComponent("" + item) + "&"; });
        if (heatingControl === null)
            throw new Error("The parameter 'heatingControl' cannot be null.");
        else if (heatingControl !== undefined)
            heatingControl && heatingControl.forEach(item => { url_ += "HeatingControl=" + encodeURIComponent("" + item) + "&"; });
        if (area === null)
            throw new Error("The parameter 'area' cannot be null.");
        else if (area !== undefined)
            url_ += "Area=" + encodeURIComponent("" + area) + "&";
        if (clauses === null)
            throw new Error("The parameter 'clauses' cannot be null.");
        else if (clauses !== undefined)
            url_ += "Clauses=" + encodeURIComponent("" + clauses) + "&";
        if (isREO === null)
            throw new Error("The parameter 'isREO' cannot be null.");
        else if (isREO !== undefined)
            url_ += "IsREO=" + encodeURIComponent("" + isREO) + "&";
        if (isSold === null)
            throw new Error("The parameter 'isSold' cannot be null.");
        else if (isSold !== undefined)
            url_ += "IsSold=" + encodeURIComponent("" + isSold) + "&";
        if (tag === null)
            throw new Error("The parameter 'tag' cannot be null.");
        else if (tag !== undefined)
            tag && tag.forEach(item => { url_ += "Tag=" + encodeURIComponent("" + item) + "&"; });
        if (searchFromMap === null)
            throw new Error("The parameter 'searchFromMap' cannot be null.");
        else if (searchFromMap !== undefined)
            url_ += "SearchFromMap=" + encodeURIComponent("" + searchFromMap) + "&";
        if (propertyIds === null)
            throw new Error("The parameter 'propertyIds' cannot be null.");
        else if (propertyIds !== undefined)
            propertyIds && propertyIds.forEach(item => { url_ += "PropertyIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPropertyListForMap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPropertyListForMap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyListForMapResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyListForMapResponse>;
        }));
    }

    protected processGetPropertyListForMap(response: HttpResponseBase): Observable<PropertyListForMapResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyListForMapResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get's a list of user's favorite properties
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @return OK
     */
    getMyFavorites(page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined): Observable<PropertySummaryResultSet> {
        let url_ = this.baseUrl + "/properties/my/favorites?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyFavorites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyFavorites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertySummaryResultSet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertySummaryResultSet>;
        }));
    }

    protected processGetMyFavorites(response: HttpResponseBase): Observable<PropertySummaryResultSet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertySummaryResultSet.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get's a list of user's recently viewed properties
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @return OK
     */
    getMyRecentlyViewed(page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined): Observable<PropertySummaryResultSet> {
        let url_ = this.baseUrl + "/properties/my/recently-viewed?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyRecentlyViewed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyRecentlyViewed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertySummaryResultSet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertySummaryResultSet>;
        }));
    }

    protected processGetMyRecentlyViewed(response: HttpResponseBase): Observable<PropertySummaryResultSet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertySummaryResultSet.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get user specific property suggestions
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @return OK
     */
    getMySuggestions(page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined): Observable<PropertySummaryResultSet> {
        let url_ = this.baseUrl + "/properties/my/suggestions?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMySuggestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMySuggestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertySummaryResultSet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertySummaryResultSet>;
        }));
    }

    protected processGetMySuggestions(response: HttpResponseBase): Observable<PropertySummaryResultSet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertySummaryResultSet.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get property listing (db)
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @param minPrice (optional) 
     * @param maxPrice (optional) 
     * @param minSqMeters (optional) 
     * @param maxSqMeters (optional) 
     * @param minYear (optional) 
     * @param maxYear (optional) 
     * @param propertyType (optional) 
     * @param isSold (optional) 
     * @param hasParking (optional) 
     * @param hasStorage (optional) 
     * @param hasGarden (optional) 
     * @param view (optional) 
     * @param floor (optional) 
     * @param roomNumber (optional) 
     * @param bathroomNumber (optional) 
     * @param auctionRound (optional) 
     * @param preApproved (optional) 
     * @param isReo (optional) 
     * @param searchFromMap (optional) 
     * @param ids (optional) 
     * @return OK
     */
    getPropertySearch(page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined, minPrice?: number | undefined, maxPrice?: number | undefined, minSqMeters?: number | undefined, maxSqMeters?: number | undefined, minYear?: number | undefined, maxYear?: number | undefined, propertyType?: string | undefined, isSold?: boolean | undefined, hasParking?: boolean | undefined, hasStorage?: boolean | undefined, hasGarden?: boolean | undefined, view?: View[] | undefined, floor?: string | undefined, roomNumber?: string | undefined, bathroomNumber?: string | undefined, auctionRound?: string | undefined, preApproved?: boolean | undefined, isReo?: boolean | undefined, searchFromMap?: boolean | undefined, ids?: string[] | undefined): Observable<PropertySummaryResultSet> {
        let url_ = this.baseUrl + "/properties/search?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (minPrice === null)
            throw new Error("The parameter 'minPrice' cannot be null.");
        else if (minPrice !== undefined)
            url_ += "MinPrice=" + encodeURIComponent("" + minPrice) + "&";
        if (maxPrice === null)
            throw new Error("The parameter 'maxPrice' cannot be null.");
        else if (maxPrice !== undefined)
            url_ += "MaxPrice=" + encodeURIComponent("" + maxPrice) + "&";
        if (minSqMeters === null)
            throw new Error("The parameter 'minSqMeters' cannot be null.");
        else if (minSqMeters !== undefined)
            url_ += "MinSqMeters=" + encodeURIComponent("" + minSqMeters) + "&";
        if (maxSqMeters === null)
            throw new Error("The parameter 'maxSqMeters' cannot be null.");
        else if (maxSqMeters !== undefined)
            url_ += "MaxSqMeters=" + encodeURIComponent("" + maxSqMeters) + "&";
        if (minYear === null)
            throw new Error("The parameter 'minYear' cannot be null.");
        else if (minYear !== undefined)
            url_ += "MinYear=" + encodeURIComponent("" + minYear) + "&";
        if (maxYear === null)
            throw new Error("The parameter 'maxYear' cannot be null.");
        else if (maxYear !== undefined)
            url_ += "MaxYear=" + encodeURIComponent("" + maxYear) + "&";
        if (propertyType === null)
            throw new Error("The parameter 'propertyType' cannot be null.");
        else if (propertyType !== undefined)
            url_ += "PropertyType=" + encodeURIComponent("" + propertyType) + "&";
        if (isSold === null)
            throw new Error("The parameter 'isSold' cannot be null.");
        else if (isSold !== undefined)
            url_ += "IsSold=" + encodeURIComponent("" + isSold) + "&";
        if (hasParking === null)
            throw new Error("The parameter 'hasParking' cannot be null.");
        else if (hasParking !== undefined)
            url_ += "HasParking=" + encodeURIComponent("" + hasParking) + "&";
        if (hasStorage === null)
            throw new Error("The parameter 'hasStorage' cannot be null.");
        else if (hasStorage !== undefined)
            url_ += "HasStorage=" + encodeURIComponent("" + hasStorage) + "&";
        if (hasGarden === null)
            throw new Error("The parameter 'hasGarden' cannot be null.");
        else if (hasGarden !== undefined)
            url_ += "HasGarden=" + encodeURIComponent("" + hasGarden) + "&";
        if (view === null)
            throw new Error("The parameter 'view' cannot be null.");
        else if (view !== undefined)
            view && view.forEach(item => { url_ += "View=" + encodeURIComponent("" + item) + "&"; });
        if (floor === null)
            throw new Error("The parameter 'floor' cannot be null.");
        else if (floor !== undefined)
            url_ += "Floor=" + encodeURIComponent("" + floor) + "&";
        if (roomNumber === null)
            throw new Error("The parameter 'roomNumber' cannot be null.");
        else if (roomNumber !== undefined)
            url_ += "RoomNumber=" + encodeURIComponent("" + roomNumber) + "&";
        if (bathroomNumber === null)
            throw new Error("The parameter 'bathroomNumber' cannot be null.");
        else if (bathroomNumber !== undefined)
            url_ += "BathroomNumber=" + encodeURIComponent("" + bathroomNumber) + "&";
        if (auctionRound === null)
            throw new Error("The parameter 'auctionRound' cannot be null.");
        else if (auctionRound !== undefined)
            url_ += "AuctionRound=" + encodeURIComponent("" + auctionRound) + "&";
        if (preApproved === null)
            throw new Error("The parameter 'preApproved' cannot be null.");
        else if (preApproved !== undefined)
            url_ += "PreApproved=" + encodeURIComponent("" + preApproved) + "&";
        if (isReo === null)
            throw new Error("The parameter 'isReo' cannot be null.");
        else if (isReo !== undefined)
            url_ += "IsReo=" + encodeURIComponent("" + isReo) + "&";
        if (searchFromMap === null)
            throw new Error("The parameter 'searchFromMap' cannot be null.");
        else if (searchFromMap !== undefined)
            url_ += "SearchFromMap=" + encodeURIComponent("" + searchFromMap) + "&";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPropertySearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPropertySearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertySummaryResultSet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertySummaryResultSet>;
        }));
    }

    protected processGetPropertySearch(response: HttpResponseBase): Observable<PropertySummaryResultSet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertySummaryResultSet.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets selling properties
     * @param caseTypeCode (optional) 
     * @return OK
     */
    getMySellingProperties(caseTypeCode?: string | undefined): Observable<PropertySummaryWithCountsResultSet> {
        let url_ = this.baseUrl + "/properties/selling?";
        if (caseTypeCode === null)
            throw new Error("The parameter 'caseTypeCode' cannot be null.");
        else if (caseTypeCode !== undefined)
            url_ += "caseTypeCode=" + encodeURIComponent("" + caseTypeCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMySellingProperties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMySellingProperties(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertySummaryWithCountsResultSet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertySummaryWithCountsResultSet>;
        }));
    }

    protected processGetMySellingProperties(response: HttpResponseBase): Observable<PropertySummaryWithCountsResultSet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertySummaryWithCountsResultSet.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sets property photo's tag
     * @return OK
     */
    getPropertyTags(): Observable<PropertyTag[]> {
        let url_ = this.baseUrl + "/properties/tags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPropertyTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPropertyTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyTag[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyTag[]>;
        }));
    }

    protected processGetPropertyTags(response: HttpResponseBase): Observable<PropertyTag[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PropertyTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    anonymous(lang: string): Observable<{ [key: string]: any; }> {
        let url_ = this.baseUrl + "/translations.{lang}.json";
        if (lang === undefined || lang === null)
            throw new Error("The parameter 'lang' must be defined.");
        url_ = url_.replace("{lang}", encodeURIComponent("" + lang));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAnonymous(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAnonymous(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: any; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: any; }>;
        }));
    }

    protected processAnonymous(response: HttpResponseBase): Observable<{ [key: string]: any; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    initiateWorkflow(body: InitiateWorkflowRequest): Observable<string> {
        let url_ = this.baseUrl + "/workflows";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInitiateWorkflow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInitiateWorkflow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processInitiateWorkflow(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    submitWorkflow(requestId: string): Observable<void> {
        let url_ = this.baseUrl + "/workflows/{requestId}/submit";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitWorkflow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitWorkflow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSubmitWorkflow(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    assetOnboardGetWorkflowForReview(propertyId: string): Observable<GetWorkflowForPropertyResponse> {
        let url_ = this.baseUrl + "/workflows/review-property/{propertyId}";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssetOnboardGetWorkflowForReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssetOnboardGetWorkflowForReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWorkflowForPropertyResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWorkflowForPropertyResponse>;
        }));
    }

    protected processAssetOnboardGetWorkflowForReview(response: HttpResponseBase): Observable<GetWorkflowForPropertyResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWorkflowForPropertyResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    assetOnboardSendForReview(propertyId: string): Observable<SendForReviewResponse> {
        let url_ = this.baseUrl + "/workflows/review-property/{propertyId}";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssetOnboardSendForReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssetOnboardSendForReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendForReviewResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendForReviewResponse>;
        }));
    }

    protected processAssetOnboardSendForReview(response: HttpResponseBase): Observable<SendForReviewResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendForReviewResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AcceptTnCRequest implements IAcceptTnCRequest {
    propertyId!: string;
    content?: string | undefined;

    constructor(data?: IAcceptTnCRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyId = _data["propertyId"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): AcceptTnCRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptTnCRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyId"] = this.propertyId;
        data["content"] = this.content;
        return data;
    }
}

export interface IAcceptTnCRequest {
    propertyId: string;
    content?: string | undefined;
}

export class AccountOwner implements IAccountOwner {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    mobileNumber?: string | undefined;
    existedAnonymousId?: string | undefined;
    tnCConsentDate?: Date | undefined;
    marketingInfoConsentDate?: Date | undefined;
    legalRepresentativeFullName?: string | undefined;
    taxNumber?: string | undefined;
    locale?: string | undefined;
    intent?: AccountOwnerIntent;
    profilingAnswers?: AccountOwnerProfilingAnswers;
    communicationPreference?: CommunicationPreference;
    readonly isCompany?: boolean;

    constructor(data?: IAccountOwner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.mobileNumber = _data["mobileNumber"];
            this.existedAnonymousId = _data["existedAnonymousId"];
            this.tnCConsentDate = _data["tnCConsentDate"] ? new Date(_data["tnCConsentDate"].toString()) : <any>undefined;
            this.marketingInfoConsentDate = _data["marketingInfoConsentDate"] ? new Date(_data["marketingInfoConsentDate"].toString()) : <any>undefined;
            this.legalRepresentativeFullName = _data["legalRepresentativeFullName"];
            this.taxNumber = _data["taxNumber"];
            this.locale = _data["locale"];
            this.intent = _data["intent"];
            this.profilingAnswers = _data["profilingAnswers"] ? AccountOwnerProfilingAnswers.fromJS(_data["profilingAnswers"]) : <any>undefined;
            this.communicationPreference = _data["communicationPreference"];
            (<any>this).isCompany = _data["isCompany"];
        }
    }

    static fromJS(data: any): AccountOwner {
        data = typeof data === 'object' ? data : {};
        let result = new AccountOwner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["mobileNumber"] = this.mobileNumber;
        data["existedAnonymousId"] = this.existedAnonymousId;
        data["tnCConsentDate"] = this.tnCConsentDate ? this.tnCConsentDate.toISOString() : <any>undefined;
        data["marketingInfoConsentDate"] = this.marketingInfoConsentDate ? this.marketingInfoConsentDate.toISOString() : <any>undefined;
        data["legalRepresentativeFullName"] = this.legalRepresentativeFullName;
        data["taxNumber"] = this.taxNumber;
        data["locale"] = this.locale;
        data["intent"] = this.intent;
        data["profilingAnswers"] = this.profilingAnswers ? this.profilingAnswers.toJSON() : <any>undefined;
        data["communicationPreference"] = this.communicationPreference;
        data["isCompany"] = this.isCompany;
        return data;
    }
}

export interface IAccountOwner {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    mobileNumber?: string | undefined;
    existedAnonymousId?: string | undefined;
    tnCConsentDate?: Date | undefined;
    marketingInfoConsentDate?: Date | undefined;
    legalRepresentativeFullName?: string | undefined;
    taxNumber?: string | undefined;
    locale?: string | undefined;
    intent?: AccountOwnerIntent;
    profilingAnswers?: AccountOwnerProfilingAnswers;
    communicationPreference?: CommunicationPreference;
    isCompany?: boolean;
}

export enum AccountOwnerIntent {
    Unknown = "Unknown",
    Buyer = "Buyer",
    Seller = "Seller",
}

export class AccountOwnerProfilingAnswers implements IAccountOwnerProfilingAnswers {
    sellerProtertyType?: LookingForPropertyOfType;
    buyerHistoryRange?: SearchHistoryDateRange;
    sellerKindOfSupportPreference?: KindOfSupportPreference[] | undefined;
    buyerPropertyTypes?: LookingForPropertyOfType[] | undefined;
    buyerPropertyPriceMin?: number | undefined;
    buyerPropertyPriceMax?: number | undefined;
    buyerPropertyLocations?: Address[] | undefined;

    constructor(data?: IAccountOwnerProfilingAnswers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sellerProtertyType = _data["sellerProtertyType"];
            this.buyerHistoryRange = _data["buyerHistoryRange"];
            if (Array.isArray(_data["sellerKindOfSupportPreference"])) {
                this.sellerKindOfSupportPreference = [] as any;
                for (let item of _data["sellerKindOfSupportPreference"])
                    this.sellerKindOfSupportPreference!.push(item);
            }
            if (Array.isArray(_data["buyerPropertyTypes"])) {
                this.buyerPropertyTypes = [] as any;
                for (let item of _data["buyerPropertyTypes"])
                    this.buyerPropertyTypes!.push(item);
            }
            this.buyerPropertyPriceMin = _data["buyerPropertyPriceMin"];
            this.buyerPropertyPriceMax = _data["buyerPropertyPriceMax"];
            if (Array.isArray(_data["buyerPropertyLocations"])) {
                this.buyerPropertyLocations = [] as any;
                for (let item of _data["buyerPropertyLocations"])
                    this.buyerPropertyLocations!.push(Address.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountOwnerProfilingAnswers {
        data = typeof data === 'object' ? data : {};
        let result = new AccountOwnerProfilingAnswers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sellerProtertyType"] = this.sellerProtertyType;
        data["buyerHistoryRange"] = this.buyerHistoryRange;
        if (Array.isArray(this.sellerKindOfSupportPreference)) {
            data["sellerKindOfSupportPreference"] = [];
            for (let item of this.sellerKindOfSupportPreference)
                data["sellerKindOfSupportPreference"].push(item);
        }
        if (Array.isArray(this.buyerPropertyTypes)) {
            data["buyerPropertyTypes"] = [];
            for (let item of this.buyerPropertyTypes)
                data["buyerPropertyTypes"].push(item);
        }
        data["buyerPropertyPriceMin"] = this.buyerPropertyPriceMin;
        data["buyerPropertyPriceMax"] = this.buyerPropertyPriceMax;
        if (Array.isArray(this.buyerPropertyLocations)) {
            data["buyerPropertyLocations"] = [];
            for (let item of this.buyerPropertyLocations)
                data["buyerPropertyLocations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAccountOwnerProfilingAnswers {
    sellerProtertyType?: LookingForPropertyOfType;
    buyerHistoryRange?: SearchHistoryDateRange;
    sellerKindOfSupportPreference?: KindOfSupportPreference[] | undefined;
    buyerPropertyTypes?: LookingForPropertyOfType[] | undefined;
    buyerPropertyPriceMin?: number | undefined;
    buyerPropertyPriceMax?: number | undefined;
    buyerPropertyLocations?: Address[] | undefined;
}

export class Address implements IAddress {
    country?: string | undefined;
    prefecture?: string | undefined;
    administrativeAreas?: string | undefined;
    streetName?: string | undefined;
    streetNumber?: string | undefined;
    postalCode?: string | undefined;
    geoPoint?: string | undefined;
    bounds?: number[][] | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"];
            this.prefecture = _data["prefecture"];
            this.administrativeAreas = _data["administrativeAreas"];
            this.streetName = _data["streetName"];
            this.streetNumber = _data["streetNumber"];
            this.postalCode = _data["postalCode"];
            this.geoPoint = _data["geoPoint"];
            if (Array.isArray(_data["bounds"])) {
                this.bounds = [] as any;
                for (let item of _data["bounds"])
                    this.bounds!.push(item);
            }
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["prefecture"] = this.prefecture;
        data["administrativeAreas"] = this.administrativeAreas;
        data["streetName"] = this.streetName;
        data["streetNumber"] = this.streetNumber;
        data["postalCode"] = this.postalCode;
        data["geoPoint"] = this.geoPoint;
        if (Array.isArray(this.bounds)) {
            data["bounds"] = [];
            for (let item of this.bounds)
                data["bounds"].push(item);
        }
        return data;
    }
}

export interface IAddress {
    country?: string | undefined;
    prefecture?: string | undefined;
    administrativeAreas?: string | undefined;
    streetName?: string | undefined;
    streetNumber?: string | undefined;
    postalCode?: string | undefined;
    geoPoint?: string | undefined;
    bounds?: number[][] | undefined;
}

export class Advisor implements IAdvisor {
    fullName?: string | undefined;
    email?: string | undefined;

    constructor(data?: IAdvisor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): Advisor {
        data = typeof data === 'object' ? data : {};
        let result = new Advisor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        return data;
    }
}

export interface IAdvisor {
    fullName?: string | undefined;
    email?: string | undefined;
}

export enum ArticleStatus {
    Processing = "Processing",
    Unpublished = "Unpublished",
    Published = "Published",
    Draft = "Draft",
    UserProcessing = "UserProcessing",
}

export class AuctionDetails implements IAuctionDetails {
    rounds?: AuctionRound[] | undefined;
    appliesToAuction?: boolean;
    code?: string | undefined;
    auctionLink?: string | undefined;
    relatedAuctions?: RelatedAuction[] | undefined;

    constructor(data?: IAuctionDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rounds"])) {
                this.rounds = [] as any;
                for (let item of _data["rounds"])
                    this.rounds!.push(AuctionRound.fromJS(item));
            }
            this.appliesToAuction = _data["appliesToAuction"];
            this.code = _data["code"];
            this.auctionLink = _data["auctionLink"];
            if (Array.isArray(_data["relatedAuctions"])) {
                this.relatedAuctions = [] as any;
                for (let item of _data["relatedAuctions"])
                    this.relatedAuctions!.push(RelatedAuction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuctionDetails {
        data = typeof data === 'object' ? data : {};
        let result = new AuctionDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rounds)) {
            data["rounds"] = [];
            for (let item of this.rounds)
                data["rounds"].push(item.toJSON());
        }
        data["appliesToAuction"] = this.appliesToAuction;
        data["code"] = this.code;
        data["auctionLink"] = this.auctionLink;
        if (Array.isArray(this.relatedAuctions)) {
            data["relatedAuctions"] = [];
            for (let item of this.relatedAuctions)
                data["relatedAuctions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAuctionDetails {
    rounds?: AuctionRound[] | undefined;
    appliesToAuction?: boolean;
    code?: string | undefined;
    auctionLink?: string | undefined;
    relatedAuctions?: RelatedAuction[] | undefined;
}

export class AuctionRound implements IAuctionRound {
    roundNumber?: number;
    roundDate?: Date | undefined;
    startingPrice?: number;
    pricePerSquareMeter?: number;

    constructor(data?: IAuctionRound) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roundNumber = _data["roundNumber"];
            this.roundDate = _data["roundDate"] ? new Date(_data["roundDate"].toString()) : <any>undefined;
            this.startingPrice = _data["startingPrice"];
            this.pricePerSquareMeter = _data["pricePerSquareMeter"];
        }
    }

    static fromJS(data: any): AuctionRound {
        data = typeof data === 'object' ? data : {};
        let result = new AuctionRound();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roundNumber"] = this.roundNumber;
        data["roundDate"] = this.roundDate ? this.roundDate.toISOString() : <any>undefined;
        data["startingPrice"] = this.startingPrice;
        data["pricePerSquareMeter"] = this.pricePerSquareMeter;
        return data;
    }
}

export interface IAuctionRound {
    roundNumber?: number;
    roundDate?: Date | undefined;
    startingPrice?: number;
    pricePerSquareMeter?: number;
}

export enum AuctionRoundFilter {
    First = "First",
    Second = "Second",
    Third = "Third",
    Fourth = "Fourth",
}

export class BasicInfo implements IBasicInfo {
    askingPrice?: number | undefined;
    lowestPrice?: number | undefined;
    type?: PropertyType;
    area?: number | undefined;
    constructionYear?: number | undefined;
    isExclusive?: boolean;
    address?: Address;

    constructor(data?: IBasicInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.askingPrice = _data["askingPrice"];
            this.lowestPrice = _data["lowestPrice"];
            this.type = _data["type"];
            this.area = _data["area"];
            this.constructionYear = _data["constructionYear"];
            this.isExclusive = _data["isExclusive"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BasicInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BasicInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["askingPrice"] = this.askingPrice;
        data["lowestPrice"] = this.lowestPrice;
        data["type"] = this.type;
        data["area"] = this.area;
        data["constructionYear"] = this.constructionYear;
        data["isExclusive"] = this.isExclusive;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBasicInfo {
    askingPrice?: number | undefined;
    lowestPrice?: number | undefined;
    type?: PropertyType;
    area?: number | undefined;
    constructionYear?: number | undefined;
    isExclusive?: boolean;
    address?: Address;
}

export enum BedroomFilter {
    One = "One",
    Two = "Two",
    Three = "Three",
    Four = "Four",
    FivePlus = "FivePlus",
}

export class BuyerFeedbackForm implements IBuyerFeedbackForm {
    isPending?: boolean;
    propertyId?: string | undefined;
    questions?: FeedbackQuestion[] | undefined;

    constructor(data?: IBuyerFeedbackForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isPending = _data["isPending"];
            this.propertyId = _data["propertyId"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(FeedbackQuestion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BuyerFeedbackForm {
        data = typeof data === 'object' ? data : {};
        let result = new BuyerFeedbackForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPending"] = this.isPending;
        data["propertyId"] = this.propertyId;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBuyerFeedbackForm {
    isPending?: boolean;
    propertyId?: string | undefined;
    questions?: FeedbackQuestion[] | undefined;
}

export class CasePartial implements ICasePartial {
    id?: string;
    referenceNumber?: number | undefined;
    ownerId?: string | undefined;
    ownerName?: string | undefined;
    ownerTin?: string | undefined;
    userId?: string | undefined;
    createdByWhen?: Date | undefined;
    createdById?: string | undefined;
    createdByEmail?: string | undefined;
    createdByName?: string | undefined;
    caseType?: CaseTypePartial;
    metadata?: { [key: string]: string; } | undefined;
    groupId?: string | undefined;
    checkpointType?: CheckpointType;
    data?: any | undefined;
    assignedToName?: string | undefined;
    channel?: string | undefined;
    draft?: boolean;
    accessLevel?: number;

    constructor(data?: ICasePartial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.referenceNumber = _data["referenceNumber"];
            this.ownerId = _data["ownerId"];
            this.ownerName = _data["ownerName"];
            this.ownerTin = _data["ownerTin"];
            this.userId = _data["userId"];
            this.createdByWhen = _data["createdByWhen"] ? new Date(_data["createdByWhen"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.createdByEmail = _data["createdByEmail"];
            this.createdByName = _data["createdByName"];
            this.caseType = _data["caseType"] ? CaseTypePartial.fromJS(_data["caseType"]) : <any>undefined;
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (<any>this.metadata)![key] = _data["metadata"][key];
                }
            }
            this.groupId = _data["groupId"];
            this.checkpointType = _data["checkpointType"] ? CheckpointType.fromJS(_data["checkpointType"]) : <any>undefined;
            this.data = _data["data"];
            this.assignedToName = _data["assignedToName"];
            this.channel = _data["channel"];
            this.draft = _data["draft"];
            this.accessLevel = _data["accessLevel"];
        }
    }

    static fromJS(data: any): CasePartial {
        data = typeof data === 'object' ? data : {};
        let result = new CasePartial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["referenceNumber"] = this.referenceNumber;
        data["ownerId"] = this.ownerId;
        data["ownerName"] = this.ownerName;
        data["ownerTin"] = this.ownerTin;
        data["userId"] = this.userId;
        data["createdByWhen"] = this.createdByWhen ? this.createdByWhen.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["createdByEmail"] = this.createdByEmail;
        data["createdByName"] = this.createdByName;
        data["caseType"] = this.caseType ? this.caseType.toJSON() : <any>undefined;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (<any>data["metadata"])[key] = (<any>this.metadata)[key];
            }
        }
        data["groupId"] = this.groupId;
        data["checkpointType"] = this.checkpointType ? this.checkpointType.toJSON() : <any>undefined;
        data["data"] = this.data;
        data["assignedToName"] = this.assignedToName;
        data["channel"] = this.channel;
        data["draft"] = this.draft;
        data["accessLevel"] = this.accessLevel;
        return data;
    }
}

export interface ICasePartial {
    id?: string;
    referenceNumber?: number | undefined;
    ownerId?: string | undefined;
    ownerName?: string | undefined;
    ownerTin?: string | undefined;
    userId?: string | undefined;
    createdByWhen?: Date | undefined;
    createdById?: string | undefined;
    createdByEmail?: string | undefined;
    createdByName?: string | undefined;
    caseType?: CaseTypePartial;
    metadata?: { [key: string]: string; } | undefined;
    groupId?: string | undefined;
    checkpointType?: CheckpointType;
    data?: any | undefined;
    assignedToName?: string | undefined;
    channel?: string | undefined;
    draft?: boolean;
    accessLevel?: number;
}

export class CasePartialResultSet implements ICasePartialResultSet {
    count?: number;
    items?: CasePartial[] | undefined;

    constructor(data?: ICasePartialResultSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CasePartial.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CasePartialResultSet {
        data = typeof data === 'object' ? data : {};
        let result = new CasePartialResultSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICasePartialResultSet {
    count?: number;
    items?: CasePartial[] | undefined;
}

export enum CaseStatus {
    Submitted = "Submitted",
    InProgress = "InProgress",
    Completed = "Completed",
    Deleted = "Deleted",
}

export class CaseTypePartial implements ICaseTypePartial {
    id?: string;
    code?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    dataSchema?: any | undefined;
    layout?: any | undefined;
    layoutTranslations?: { [key: string]: string; } | undefined;
    tags?: string | undefined;
    config?: any | undefined;
    order?: number | undefined;
    canCreateRoles?: string[] | undefined;
    category?: Category;
    translations?: { [key: string]: CaseTypeTranslation; } | undefined;
    isMenuItem?: boolean;
    gridFilterConfig?: any | undefined;
    gridColumnConfig?: any | undefined;

    constructor(data?: ICaseTypePartial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.dataSchema = _data["dataSchema"];
            this.layout = _data["layout"];
            if (_data["layoutTranslations"]) {
                this.layoutTranslations = {} as any;
                for (let key in _data["layoutTranslations"]) {
                    if (_data["layoutTranslations"].hasOwnProperty(key))
                        (<any>this.layoutTranslations)![key] = _data["layoutTranslations"][key];
                }
            }
            this.tags = _data["tags"];
            this.config = _data["config"];
            this.order = _data["order"];
            if (Array.isArray(_data["canCreateRoles"])) {
                this.canCreateRoles = [] as any;
                for (let item of _data["canCreateRoles"])
                    this.canCreateRoles!.push(item);
            }
            this.category = _data["category"] ? Category.fromJS(_data["category"]) : <any>undefined;
            if (_data["translations"]) {
                this.translations = {} as any;
                for (let key in _data["translations"]) {
                    if (_data["translations"].hasOwnProperty(key))
                        (<any>this.translations)![key] = _data["translations"][key] ? CaseTypeTranslation.fromJS(_data["translations"][key]) : new CaseTypeTranslation();
                }
            }
            this.isMenuItem = _data["isMenuItem"];
            this.gridFilterConfig = _data["gridFilterConfig"];
            this.gridColumnConfig = _data["gridColumnConfig"];
        }
    }

    static fromJS(data: any): CaseTypePartial {
        data = typeof data === 'object' ? data : {};
        let result = new CaseTypePartial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["title"] = this.title;
        data["description"] = this.description;
        data["dataSchema"] = this.dataSchema;
        data["layout"] = this.layout;
        if (this.layoutTranslations) {
            data["layoutTranslations"] = {};
            for (let key in this.layoutTranslations) {
                if (this.layoutTranslations.hasOwnProperty(key))
                    (<any>data["layoutTranslations"])[key] = (<any>this.layoutTranslations)[key];
            }
        }
        data["tags"] = this.tags;
        data["config"] = this.config;
        data["order"] = this.order;
        if (Array.isArray(this.canCreateRoles)) {
            data["canCreateRoles"] = [];
            for (let item of this.canCreateRoles)
                data["canCreateRoles"].push(item);
        }
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        if (this.translations) {
            data["translations"] = {};
            for (let key in this.translations) {
                if (this.translations.hasOwnProperty(key))
                    (<any>data["translations"])[key] = this.translations[key] ? this.translations[key].toJSON() : <any>undefined;
            }
        }
        data["isMenuItem"] = this.isMenuItem;
        data["gridFilterConfig"] = this.gridFilterConfig;
        data["gridColumnConfig"] = this.gridColumnConfig;
        return data;
    }
}

export interface ICaseTypePartial {
    id?: string;
    code?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    dataSchema?: any | undefined;
    layout?: any | undefined;
    layoutTranslations?: { [key: string]: string; } | undefined;
    tags?: string | undefined;
    config?: any | undefined;
    order?: number | undefined;
    canCreateRoles?: string[] | undefined;
    category?: Category;
    translations?: { [key: string]: CaseTypeTranslation; } | undefined;
    isMenuItem?: boolean;
    gridFilterConfig?: any | undefined;
    gridColumnConfig?: any | undefined;
}

export class CaseTypeTranslation implements ICaseTypeTranslation {
    title?: string | undefined;
    description?: string | undefined;

    constructor(data?: ICaseTypeTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CaseTypeTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new CaseTypeTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        return data;
    }
}

export interface ICaseTypeTranslation {
    title?: string | undefined;
    description?: string | undefined;
}

export class Category implements ICategory {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    order?: number | undefined;
    translations?: { [key: string]: CategoryTranslation; } | undefined;

    constructor(data?: ICategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.order = _data["order"];
            if (_data["translations"]) {
                this.translations = {} as any;
                for (let key in _data["translations"]) {
                    if (_data["translations"].hasOwnProperty(key))
                        (<any>this.translations)![key] = _data["translations"][key] ? CategoryTranslation.fromJS(_data["translations"][key]) : new CategoryTranslation();
                }
            }
        }
    }

    static fromJS(data: any): Category {
        data = typeof data === 'object' ? data : {};
        let result = new Category();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["order"] = this.order;
        if (this.translations) {
            data["translations"] = {};
            for (let key in this.translations) {
                if (this.translations.hasOwnProperty(key))
                    (<any>data["translations"])[key] = this.translations[key] ? this.translations[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface ICategory {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    order?: number | undefined;
    translations?: { [key: string]: CategoryTranslation; } | undefined;
}

export class CategoryTranslation implements ICategoryTranslation {
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: ICategoryTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CategoryTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface ICategoryTranslation {
    name?: string | undefined;
    description?: string | undefined;
}

export class ChartData implements IChartData {
    date?: Date;
    count?: number;

    constructor(data?: IChartData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): ChartData {
        data = typeof data === 'object' ? data : {};
        let result = new ChartData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["count"] = this.count;
        return data;
    }
}

export interface IChartData {
    date?: Date;
    count?: number;
}

export class CheckpointType implements ICheckpointType {
    id?: string;
    code?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    status?: CaseStatus;
    private?: boolean | undefined;
    translations?: { [key: string]: CheckpointTypeTranslation; } | undefined;

    constructor(data?: ICheckpointType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.private = _data["private"];
            if (_data["translations"]) {
                this.translations = {} as any;
                for (let key in _data["translations"]) {
                    if (_data["translations"].hasOwnProperty(key))
                        (<any>this.translations)![key] = _data["translations"][key] ? CheckpointTypeTranslation.fromJS(_data["translations"][key]) : new CheckpointTypeTranslation();
                }
            }
        }
    }

    static fromJS(data: any): CheckpointType {
        data = typeof data === 'object' ? data : {};
        let result = new CheckpointType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["title"] = this.title;
        data["description"] = this.description;
        data["status"] = this.status;
        data["private"] = this.private;
        if (this.translations) {
            data["translations"] = {};
            for (let key in this.translations) {
                if (this.translations.hasOwnProperty(key))
                    (<any>data["translations"])[key] = this.translations[key] ? this.translations[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface ICheckpointType {
    id?: string;
    code?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    status?: CaseStatus;
    private?: boolean | undefined;
    translations?: { [key: string]: CheckpointTypeTranslation; } | undefined;
}

export class CheckpointTypeTranslation implements ICheckpointTypeTranslation {
    title?: string | undefined;
    description?: string | undefined;

    constructor(data?: ICheckpointTypeTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CheckpointTypeTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new CheckpointTypeTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        return data;
    }
}

export interface ICheckpointTypeTranslation {
    title?: string | undefined;
    description?: string | undefined;
}

export enum CommunicationPreference {
    Any = "Any",
    Email = "Email",
    SMS = "SMS",
}

export class Construction implements IConstruction {
    heatingType?: HeatingType;
    heatingControl?: HeatingControl;
    energyClass?: EnergyClass;
    constructionYear?: number | undefined;
    constructionMaterial?: ConstructionMaterial[] | undefined;
    floorMaterial?: FloorMaterial[] | undefined;
    condition?: PropertyCondition;

    constructor(data?: IConstruction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.heatingType = _data["heatingType"];
            this.heatingControl = _data["heatingControl"];
            this.energyClass = _data["energyClass"];
            this.constructionYear = _data["constructionYear"];
            if (Array.isArray(_data["constructionMaterial"])) {
                this.constructionMaterial = [] as any;
                for (let item of _data["constructionMaterial"])
                    this.constructionMaterial!.push(item);
            }
            if (Array.isArray(_data["floorMaterial"])) {
                this.floorMaterial = [] as any;
                for (let item of _data["floorMaterial"])
                    this.floorMaterial!.push(item);
            }
            this.condition = _data["condition"];
        }
    }

    static fromJS(data: any): Construction {
        data = typeof data === 'object' ? data : {};
        let result = new Construction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["heatingType"] = this.heatingType;
        data["heatingControl"] = this.heatingControl;
        data["energyClass"] = this.energyClass;
        data["constructionYear"] = this.constructionYear;
        if (Array.isArray(this.constructionMaterial)) {
            data["constructionMaterial"] = [];
            for (let item of this.constructionMaterial)
                data["constructionMaterial"].push(item);
        }
        if (Array.isArray(this.floorMaterial)) {
            data["floorMaterial"] = [];
            for (let item of this.floorMaterial)
                data["floorMaterial"].push(item);
        }
        data["condition"] = this.condition;
        return data;
    }
}

export interface IConstruction {
    heatingType?: HeatingType;
    heatingControl?: HeatingControl;
    energyClass?: EnergyClass;
    constructionYear?: number | undefined;
    constructionMaterial?: ConstructionMaterial[] | undefined;
    floorMaterial?: FloorMaterial[] | undefined;
    condition?: PropertyCondition;
}

export enum ConstructionMaterial {
    Concrete = "Concrete",
    Brick = "Brick",
    Stone = "Stone",
    Wood = "Wood",
    Prefabricate = "Prefabricate",
}

export enum ContactSource {
    UnikoPortal = "UnikoPortal",
    CallCenter = "CallCenter",
    Spitogatos = "Spitogatos",
    XE = "XE",
    OtherThirdPartyPortals = "OtherThirdPartyPortals",
    MetaForms = "MetaForms",
    Referral = "Referral",
    NbgBranches = "NbgBranches",
    Broker = "Broker",
    Constructor = "Constructor",
    Other = "Other",
    Network = "Network",
    FBMarketplace = "FBMarketplace",
    GoogleForms = "GoogleForms",
    JotForms = "JotForms",
    Facebook = "Facebook",
}

export class ContactUsRequest implements IContactUsRequest {
    name!: string | undefined;
    email!: string | undefined;
    message!: string | undefined;

    constructor(data?: IContactUsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ContactUsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContactUsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["message"] = this.message;
        return data;
    }
}

export interface IContactUsRequest {
    name: string | undefined;
    email: string | undefined;
    message: string | undefined;
}

export class Content implements IContent {
    titleEl?: string | undefined;
    shortDescriptionEl?: string | undefined;
    titleEn?: string | undefined;
    shortDescriptionEn?: string | undefined;

    constructor(data?: IContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleEl = _data["titleEl"];
            this.shortDescriptionEl = _data["shortDescriptionEl"];
            this.titleEn = _data["titleEn"];
            this.shortDescriptionEn = _data["shortDescriptionEn"];
        }
    }

    static fromJS(data: any): Content {
        data = typeof data === 'object' ? data : {};
        let result = new Content();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleEl"] = this.titleEl;
        data["shortDescriptionEl"] = this.shortDescriptionEl;
        data["titleEn"] = this.titleEn;
        data["shortDescriptionEn"] = this.shortDescriptionEn;
        return data;
    }
}

export interface IContent {
    titleEl?: string | undefined;
    shortDescriptionEl?: string | undefined;
    titleEn?: string | undefined;
    shortDescriptionEn?: string | undefined;
}

export class CountryCode implements ICountryCode {
    name?: string | undefined;
    capital?: string | undefined;
    continentCode?: string | undefined;
    twoLetterCode?: string | undefined;
    threeLetterCode?: string | undefined;
    numericCode?: string | undefined;
    twoLetterLanguageCode?: string | undefined;
    callingCode?: string | undefined;

    constructor(data?: ICountryCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.capital = _data["capital"];
            this.continentCode = _data["continentCode"];
            this.twoLetterCode = _data["twoLetterCode"];
            this.threeLetterCode = _data["threeLetterCode"];
            this.numericCode = _data["numericCode"];
            this.twoLetterLanguageCode = _data["twoLetterLanguageCode"];
            this.callingCode = _data["callingCode"];
        }
    }

    static fromJS(data: any): CountryCode {
        data = typeof data === 'object' ? data : {};
        let result = new CountryCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["capital"] = this.capital;
        data["continentCode"] = this.continentCode;
        data["twoLetterCode"] = this.twoLetterCode;
        data["threeLetterCode"] = this.threeLetterCode;
        data["numericCode"] = this.numericCode;
        data["twoLetterLanguageCode"] = this.twoLetterLanguageCode;
        data["callingCode"] = this.callingCode;
        return data;
    }
}

export interface ICountryCode {
    name?: string | undefined;
    capital?: string | undefined;
    continentCode?: string | undefined;
    twoLetterCode?: string | undefined;
    threeLetterCode?: string | undefined;
    numericCode?: string | undefined;
    twoLetterLanguageCode?: string | undefined;
    callingCode?: string | undefined;
}

export class CreateListingResponse implements ICreateListingResponse {
    propertyId?: string | undefined;
    propertyCode?: string | undefined;

    constructor(data?: ICreateListingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyId = _data["propertyId"];
            this.propertyCode = _data["propertyCode"];
        }
    }

    static fromJS(data: any): CreateListingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateListingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyId"] = this.propertyId;
        data["propertyCode"] = this.propertyCode;
        return data;
    }
}

export interface ICreateListingResponse {
    propertyId?: string | undefined;
    propertyCode?: string | undefined;
}

export enum EnergyClass {
    APlus = "APlus",
    A = "A",
    BPlus = "BPlus",
    B = "B",
    C = "C",
    D = "D",
    E = "E",
    F = "F",
    G = "G",
}

export class Features implements IFeatures {
    numberOfRooms?: number | undefined;
    numberOfBathrooms?: number | undefined;
    numberOfWC?: number | undefined;
    amenities?: PropertyAmenities;
    parkingType?: ParkingType[] | undefined;
    parkingSpace?: number | undefined;
    storageAreaAmount?: number | undefined;
    storageArea?: number | undefined;
    storageType?: StorageType[] | undefined;
    floor?: number | undefined;
    floorType?: FloorType;

    constructor(data?: IFeatures) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfRooms = _data["numberOfRooms"];
            this.numberOfBathrooms = _data["numberOfBathrooms"];
            this.numberOfWC = _data["numberOfWC"];
            this.amenities = _data["amenities"] ? PropertyAmenities.fromJS(_data["amenities"]) : <any>undefined;
            if (Array.isArray(_data["parkingType"])) {
                this.parkingType = [] as any;
                for (let item of _data["parkingType"])
                    this.parkingType!.push(item);
            }
            this.parkingSpace = _data["parkingSpace"];
            this.storageAreaAmount = _data["storageAreaAmount"];
            this.storageArea = _data["storageArea"];
            if (Array.isArray(_data["storageType"])) {
                this.storageType = [] as any;
                for (let item of _data["storageType"])
                    this.storageType!.push(item);
            }
            this.floor = _data["floor"];
            this.floorType = _data["floorType"];
        }
    }

    static fromJS(data: any): Features {
        data = typeof data === 'object' ? data : {};
        let result = new Features();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfRooms"] = this.numberOfRooms;
        data["numberOfBathrooms"] = this.numberOfBathrooms;
        data["numberOfWC"] = this.numberOfWC;
        data["amenities"] = this.amenities ? this.amenities.toJSON() : <any>undefined;
        if (Array.isArray(this.parkingType)) {
            data["parkingType"] = [];
            for (let item of this.parkingType)
                data["parkingType"].push(item);
        }
        data["parkingSpace"] = this.parkingSpace;
        data["storageAreaAmount"] = this.storageAreaAmount;
        data["storageArea"] = this.storageArea;
        if (Array.isArray(this.storageType)) {
            data["storageType"] = [];
            for (let item of this.storageType)
                data["storageType"].push(item);
        }
        data["floor"] = this.floor;
        data["floorType"] = this.floorType;
        return data;
    }
}

export interface IFeatures {
    numberOfRooms?: number | undefined;
    numberOfBathrooms?: number | undefined;
    numberOfWC?: number | undefined;
    amenities?: PropertyAmenities;
    parkingType?: ParkingType[] | undefined;
    parkingSpace?: number | undefined;
    storageAreaAmount?: number | undefined;
    storageArea?: number | undefined;
    storageType?: StorageType[] | undefined;
    floor?: number | undefined;
    floorType?: FloorType;
}

export class FeedbackQuestion implements IFeedbackQuestion {
    code?: string | undefined;
    type?: QuestionType;
    group?: number | undefined;
    followup?: string | undefined;
    options?: string[] | undefined;
    value?: string | undefined;

    constructor(data?: IFeedbackQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.type = _data["type"];
            this.group = _data["group"];
            this.followup = _data["followup"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(item);
            }
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FeedbackQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["type"] = this.type;
        data["group"] = this.group;
        data["followup"] = this.followup;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        data["value"] = this.value;
        return data;
    }
}

export interface IFeedbackQuestion {
    code?: string | undefined;
    type?: QuestionType;
    group?: number | undefined;
    followup?: string | undefined;
    options?: string[] | undefined;
    value?: string | undefined;
}

export enum FloorFilter {
    Ground = "Ground",
    First = "First",
    Second = "Second",
    Third = "Third",
    FourthPlus = "FourthPlus",
    TopFloor = "TopFloor",
    Basement = "Basement",
}

export enum FloorMaterial {
    Tile = "Tile",
    Wooden = "Wooden",
    Laminate = "Laminate",
    Marble = "Marble",
    Carpet = "Carpet",
    Vinyl = "Vinyl",
}

export enum FloorType {
    SemiBasement = "SemiBasement",
    Basement = "Basement",
}

export class GetWorkflowForPropertyResponse implements IGetWorkflowForPropertyResponse {
    canSendForReview?: boolean;
    workflowId?: string | undefined;

    constructor(data?: IGetWorkflowForPropertyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canSendForReview = _data["canSendForReview"];
            this.workflowId = _data["workflowId"];
        }
    }

    static fromJS(data: any): GetWorkflowForPropertyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWorkflowForPropertyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canSendForReview"] = this.canSendForReview;
        data["workflowId"] = this.workflowId;
        return data;
    }
}

export interface IGetWorkflowForPropertyResponse {
    canSendForReview?: boolean;
    workflowId?: string | undefined;
}

export enum HeatingControl {
    Autonomous = "Autonomous",
    Central = "Central",
}

export enum HeatingType {
    None = "None",
    HeatingOil = "HeatingOil",
    NaturalGas = "NaturalGas",
    ElectricAirConditioning = "ElectricAirConditioning",
    ElectricHeatPump = "ElectricHeatPump",
    ElectricRadiators = "ElectricRadiators",
    ElectricHeatPumpWaterHeater = "ElectricHeatPumpWaterHeater",
    FireplaceSimple = "FireplaceSimple",
    EnergyEfficientFireplace = "EnergyEfficientFireplace",
    PelletStove = "PelletStove",
    HeatPump = "HeatPump",
    Geothermal = "Geothermal",
    OtherHeating = "OtherHeating",
    Other = "Other",
}

export class HttpValidationProblemDetails implements IHttpValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;

    constructor(data?: IHttpValidationProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): HttpValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HttpValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        return data;
    }
}

export interface IHttpValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;
}

export class InitiateWorkflowRequest implements IInitiateWorkflowRequest {
    propertyId?: string | undefined;
    asDraft?: boolean;
    caseTypeCode!: string | undefined;
    data!: any | undefined;

    constructor(data?: IInitiateWorkflowRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyId = _data["propertyId"];
            this.asDraft = _data["asDraft"];
            this.caseTypeCode = _data["caseTypeCode"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): InitiateWorkflowRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InitiateWorkflowRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyId"] = this.propertyId;
        data["asDraft"] = this.asDraft;
        data["caseTypeCode"] = this.caseTypeCode;
        data["data"] = this.data;
        return data;
    }
}

export interface IInitiateWorkflowRequest {
    propertyId?: string | undefined;
    asDraft?: boolean;
    caseTypeCode: string | undefined;
    data: any | undefined;
}

export enum KindOfSupportPreference {
    Unspecified = "Unspecified",
    LegalSupport = "LegalSupport",
    TechnicalDueDiligenceSupport = "TechnicalDueDiligenceSupport",
    DontNeedSupport = "DontNeedSupport",
}

export class ListingUploadInfo implements IListingUploadInfo {
    askingPrice?: number | undefined;
    lowestPrice?: number | undefined;
    type?: PropertyType;
    area?: number | undefined;
    constructionYear?: number | undefined;
    isExclusive?: boolean;
    address?: Address;
    floor?: number | undefined;
    floorType?: FloorType;
    numberOfFloors?: number | undefined;

    constructor(data?: IListingUploadInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.askingPrice = _data["askingPrice"];
            this.lowestPrice = _data["lowestPrice"];
            this.type = _data["type"];
            this.area = _data["area"];
            this.constructionYear = _data["constructionYear"];
            this.isExclusive = _data["isExclusive"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.floor = _data["floor"];
            this.floorType = _data["floorType"];
            this.numberOfFloors = _data["numberOfFloors"];
        }
    }

    static fromJS(data: any): ListingUploadInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ListingUploadInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["askingPrice"] = this.askingPrice;
        data["lowestPrice"] = this.lowestPrice;
        data["type"] = this.type;
        data["area"] = this.area;
        data["constructionYear"] = this.constructionYear;
        data["isExclusive"] = this.isExclusive;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["floor"] = this.floor;
        data["floorType"] = this.floorType;
        data["numberOfFloors"] = this.numberOfFloors;
        return data;
    }
}

export interface IListingUploadInfo {
    askingPrice?: number | undefined;
    lowestPrice?: number | undefined;
    type?: PropertyType;
    area?: number | undefined;
    constructionYear?: number | undefined;
    isExclusive?: boolean;
    address?: Address;
    floor?: number | undefined;
    floorType?: FloorType;
    numberOfFloors?: number | undefined;
}

export class LocalizedText implements ILocalizedText {
    en?: string | undefined;
    el?: string | undefined;

    constructor(data?: ILocalizedText) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.en = _data["en"];
            this.el = _data["el"];
        }
    }

    static fromJS(data: any): LocalizedText {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedText();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["en"] = this.en;
        data["el"] = this.el;
        return data;
    }
}

export interface ILocalizedText {
    en?: string | undefined;
    el?: string | undefined;
}

export enum LookingForPropertyOfType {
    Unspecified = "Unspecified",
    Villa = "Villa",
    Apartment = "Apartment",
    Maisonette = "Maisonette",
    HolidayHome = "HolidayHome",
    Professional = "Professional",
}

export class MediaOrder implements IMediaOrder {
    mediaId?: string;
    order?: number;

    constructor(data?: IMediaOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mediaId = _data["mediaId"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): MediaOrder {
        data = typeof data === 'object' ? data : {};
        let result = new MediaOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mediaId"] = this.mediaId;
        data["order"] = this.order;
        return data;
    }
}

export interface IMediaOrder {
    mediaId?: string;
    order?: number;
}

export class MediaOrderRequest implements IMediaOrderRequest {
    request?: MediaOrder[] | undefined;

    constructor(data?: IMediaOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["request"])) {
                this.request = [] as any;
                for (let item of _data["request"])
                    this.request!.push(MediaOrder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MediaOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MediaOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.request)) {
            data["request"] = [];
            for (let item of this.request)
                data["request"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMediaOrderRequest {
    request?: MediaOrder[] | undefined;
}

export enum MediaTag {
    Kitchen = "Kitchen",
    LivingRoom = "LivingRoom",
    Bathroom = "Bathroom",
    Wc = "Wc",
    Bedroom = "Bedroom",
    MasterBedroom = "MasterBedroom",
    LaundryRoom = "LaundryRoom",
    Garage = "Garage",
    Hallway = "Hallway",
    Balcony = "Balcony",
    GuestRoom = "GuestRoom",
    HomeOffice = "HomeOffice",
    StorageRoom = "StorageRoom",
    HomeGym = "HomeGym",
}

export enum MediaType {
    Photos = "Photos",
    Photos3d = "Photos3d",
    PropertyElevation = "PropertyElevation",
    Video = "Video",
    DollHouse = "DollHouse",
}

export class MyRequestsResponse implements IMyRequestsResponse {
    request?: Request;
    propertySummary?: RequestPropertySummary;

    constructor(data?: IMyRequestsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.request = _data["request"] ? Request.fromJS(_data["request"]) : <any>undefined;
            this.propertySummary = _data["propertySummary"] ? RequestPropertySummary.fromJS(_data["propertySummary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MyRequestsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MyRequestsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["propertySummary"] = this.propertySummary ? this.propertySummary.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMyRequestsResponse {
    request?: Request;
    propertySummary?: RequestPropertySummary;
}

export class MyRequestsResponseResultSet implements IMyRequestsResponseResultSet {
    count?: number;
    items?: MyRequestsResponse[] | undefined;

    constructor(data?: IMyRequestsResponseResultSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MyRequestsResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MyRequestsResponseResultSet {
        data = typeof data === 'object' ? data : {};
        let result = new MyRequestsResponseResultSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMyRequestsResponseResultSet {
    count?: number;
    items?: MyRequestsResponse[] | undefined;
}

export class NbgBranch implements INbgBranch {
    id?: string;
    branchCode?: string | undefined;
    branchType?: number;
    areaId?: number;
    post1?: string | undefined;
    post2?: string | undefined;
    phone1?: string | undefined;
    phone2?: string | undefined;
    branchName?: string | undefined;
    address?: string | undefined;
    zoom?: number;
    kallikratisMunicipality?: string | undefined;
    fr?: string | undefined;
    location?: string | undefined;

    constructor(data?: INbgBranch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.branchCode = _data["branchCode"];
            this.branchType = _data["branchType"];
            this.areaId = _data["areaId"];
            this.post1 = _data["post1"];
            this.post2 = _data["post2"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.branchName = _data["branchName"];
            this.address = _data["address"];
            this.zoom = _data["zoom"];
            this.kallikratisMunicipality = _data["kallikratisMunicipality"];
            this.fr = _data["fr"];
            this.location = _data["location"];
        }
    }

    static fromJS(data: any): NbgBranch {
        data = typeof data === 'object' ? data : {};
        let result = new NbgBranch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["branchCode"] = this.branchCode;
        data["branchType"] = this.branchType;
        data["areaId"] = this.areaId;
        data["post1"] = this.post1;
        data["post2"] = this.post2;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["branchName"] = this.branchName;
        data["address"] = this.address;
        data["zoom"] = this.zoom;
        data["kallikratisMunicipality"] = this.kallikratisMunicipality;
        data["fr"] = this.fr;
        data["location"] = this.location;
        return data;
    }
}

export interface INbgBranch {
    id?: string;
    branchCode?: string | undefined;
    branchType?: number;
    areaId?: number;
    post1?: string | undefined;
    post2?: string | undefined;
    phone1?: string | undefined;
    phone2?: string | undefined;
    branchName?: string | undefined;
    address?: string | undefined;
    zoom?: number;
    kallikratisMunicipality?: string | undefined;
    fr?: string | undefined;
    location?: string | undefined;
}

export class NbgBranchResultSet implements INbgBranchResultSet {
    count?: number;
    items?: NbgBranch[] | undefined;

    constructor(data?: INbgBranchResultSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NbgBranch.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NbgBranchResultSet {
        data = typeof data === 'object' ? data : {};
        let result = new NbgBranchResultSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface INbgBranchResultSet {
    count?: number;
    items?: NbgBranch[] | undefined;
}

export class NbgBranchesRequest implements INbgBranchesRequest {
    longitude?: number;
    latitude?: number;

    constructor(data?: INbgBranchesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
        }
    }

    static fromJS(data: any): NbgBranchesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NbgBranchesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        return data;
    }
}

export interface INbgBranchesRequest {
    longitude?: number;
    latitude?: number;
}

export enum NotificationFrequency {
    Never = "Never",
    Daily = "Daily",
    Weekly = "Weekly",
}

export class Notifications implements INotifications {
    openOffers?: number;
    openRequestedWalkthroughs?: number;
    openReceivedWalkthroughs?: number;
    sellerOpenOffers?: number;
    buyerOpenOffers?: number;
    readonly totalCount?: number;
    readonly hasNotifications?: boolean;

    constructor(data?: INotifications) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.openOffers = _data["openOffers"];
            this.openRequestedWalkthroughs = _data["openRequestedWalkthroughs"];
            this.openReceivedWalkthroughs = _data["openReceivedWalkthroughs"];
            this.sellerOpenOffers = _data["sellerOpenOffers"];
            this.buyerOpenOffers = _data["buyerOpenOffers"];
            (<any>this).totalCount = _data["totalCount"];
            (<any>this).hasNotifications = _data["hasNotifications"];
        }
    }

    static fromJS(data: any): Notifications {
        data = typeof data === 'object' ? data : {};
        let result = new Notifications();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["openOffers"] = this.openOffers;
        data["openRequestedWalkthroughs"] = this.openRequestedWalkthroughs;
        data["openReceivedWalkthroughs"] = this.openReceivedWalkthroughs;
        data["sellerOpenOffers"] = this.sellerOpenOffers;
        data["buyerOpenOffers"] = this.buyerOpenOffers;
        data["totalCount"] = this.totalCount;
        data["hasNotifications"] = this.hasNotifications;
        return data;
    }
}

export interface INotifications {
    openOffers?: number;
    openRequestedWalkthroughs?: number;
    openReceivedWalkthroughs?: number;
    sellerOpenOffers?: number;
    buyerOpenOffers?: number;
    totalCount?: number;
    hasNotifications?: boolean;
}

export enum OfferStatus {
    Open = "Open",
    Accepted = "Accepted",
    Rejected = "Rejected",
    Canceled = "Canceled",
    Pending = "Pending",
}

export enum Orientation {
    North = "North",
    NorthEast = "NorthEast",
    NorthWest = "NorthWest",
    South = "South",
    SouthEast = "SouthEast",
    SouthWest = "SouthWest",
    East = "East",
    West = "West",
}

export class Ownership implements IOwnership {
    kaek?: string | undefined;
    usageCategory?: PropertyUsageCategory;
    ownershipType?: OwnershipType;
    ownershipPercentage?: number | undefined;
    availability?: PropertyAvailability;

    constructor(data?: IOwnership) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kaek = _data["kaek"];
            this.usageCategory = _data["usageCategory"];
            this.ownershipType = _data["ownershipType"];
            this.ownershipPercentage = _data["ownershipPercentage"];
            this.availability = _data["availability"];
        }
    }

    static fromJS(data: any): Ownership {
        data = typeof data === 'object' ? data : {};
        let result = new Ownership();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kaek"] = this.kaek;
        data["usageCategory"] = this.usageCategory;
        data["ownershipType"] = this.ownershipType;
        data["ownershipPercentage"] = this.ownershipPercentage;
        data["availability"] = this.availability;
        return data;
    }
}

export interface IOwnership {
    kaek?: string | undefined;
    usageCategory?: PropertyUsageCategory;
    ownershipType?: OwnershipType;
    ownershipPercentage?: number | undefined;
    availability?: PropertyAvailability;
}

export enum OwnershipType {
    Full = "Full",
    Bare = "Bare",
    Split = "Split",
}

export enum ParkingType {
    None = "None",
    Closed = "Closed",
    Underground = "Underground",
    Carport = "Carport",
    Shared = "Shared",
    Open = "Open",
    Other = "Other",
}

export class Partner implements IPartner {
    id?: string;
    email!: string | undefined;
    fullName!: string | undefined;

    constructor(data?: IPartner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): Partner {
        data = typeof data === 'object' ? data : {};
        let result = new Partner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IPartner {
    id?: string;
    email: string | undefined;
    fullName: string | undefined;
}

export class Photo implements IPhoto {
    mediaGuid?: string | undefined;
    isDefault?: boolean | undefined;
    uri?: string | undefined;
    fallbackUri?: string | undefined;
    altText?: string | undefined;
    order?: number | undefined;
    type?: MediaType;
    tag?: MediaTag;
    photoItems?: PhotoItem[] | undefined;

    constructor(data?: IPhoto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mediaGuid = _data["mediaGuid"];
            this.isDefault = _data["isDefault"];
            this.uri = _data["uri"];
            this.fallbackUri = _data["fallbackUri"];
            this.altText = _data["altText"];
            this.order = _data["order"];
            this.type = _data["type"];
            this.tag = _data["tag"];
            if (Array.isArray(_data["photoItems"])) {
                this.photoItems = [] as any;
                for (let item of _data["photoItems"])
                    this.photoItems!.push(PhotoItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Photo {
        data = typeof data === 'object' ? data : {};
        let result = new Photo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mediaGuid"] = this.mediaGuid;
        data["isDefault"] = this.isDefault;
        data["uri"] = this.uri;
        data["fallbackUri"] = this.fallbackUri;
        data["altText"] = this.altText;
        data["order"] = this.order;
        data["type"] = this.type;
        data["tag"] = this.tag;
        if (Array.isArray(this.photoItems)) {
            data["photoItems"] = [];
            for (let item of this.photoItems)
                data["photoItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPhoto {
    mediaGuid?: string | undefined;
    isDefault?: boolean | undefined;
    uri?: string | undefined;
    fallbackUri?: string | undefined;
    altText?: string | undefined;
    order?: number | undefined;
    type?: MediaType;
    tag?: MediaTag;
    photoItems?: PhotoItem[] | undefined;
}

export class PhotoItem implements IPhotoItem {
    uri?: string | undefined;
    contentType?: string | undefined;

    constructor(data?: IPhotoItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uri = _data["uri"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): PhotoItem {
        data = typeof data === 'object' ? data : {};
        let result = new PhotoItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uri"] = this.uri;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface IPhotoItem {
    uri?: string | undefined;
    contentType?: string | undefined;
}

export class PhotoResultSet implements IPhotoResultSet {
    count?: number;
    items?: Photo[] | undefined;

    constructor(data?: IPhotoResultSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Photo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PhotoResultSet {
        data = typeof data === 'object' ? data : {};
        let result = new PhotoResultSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPhotoResultSet {
    count?: number;
    items?: Photo[] | undefined;
}

export class PhotoUploadRequest implements IPhotoUploadRequest {
    file?: string | undefined;
    fileName?: string | undefined;
    length?: number | undefined;
    isDefault?: boolean;
    order?: number | undefined;

    constructor(data?: IPhotoUploadRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"];
            this.fileName = _data["fileName"];
            this.length = _data["length"];
            this.isDefault = _data["isDefault"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): PhotoUploadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PhotoUploadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file;
        data["fileName"] = this.fileName;
        data["length"] = this.length;
        data["isDefault"] = this.isDefault;
        data["order"] = this.order;
        return data;
    }
}

export interface IPhotoUploadRequest {
    file?: string | undefined;
    fileName?: string | undefined;
    length?: number | undefined;
    isDefault?: boolean;
    order?: number | undefined;
}

export enum PlaceType {
    Unknown = "Unknown",
    Kindergarden = "Kindergarden",
    ElementarySchool = "ElementarySchool",
    PrimarySchool = "PrimarySchool",
    School = "School",
    SecondarySchool = "SecondarySchool",
    HighSchool = "HighSchool",
    LightRailStation = "LightRailStation",
    TrainStation = "TrainStation",
    MetroStation = "MetroStation",
    BusStation = "BusStation",
    BusStop = "BusStop",
    FutureMetroStation = "FutureMetroStation",
    TramStation = "TramStation",
    Park = "Park",
    Supermarket = "Supermarket",
    FuelStation = "FuelStation",
    ShoppingMall = "ShoppingMall",
    Hospital = "Hospital",
    Clinic = "Clinic",
    Playground = "Playground",
    Church = "Church",
    Bank = "Bank",
    Airport = "Airport",
    Police = "Police",
    PostOffice = "PostOffice",
    Stadium = "Stadium",
    University = "University",
    CityHall = "CityHall",
    Sports = "Sports",
}

export enum PreApprovalStatus {
    Rejected = "Rejected",
    Approved = "Approved",
    PendingRequest = "PendingRequest",
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class PropertyAddressInfo implements IPropertyAddressInfo {
    id?: string;
    code?: string | undefined;
    address?: Address;
    title?: string | undefined;
    defaultPhoto?: Photo;

    constructor(data?: IPropertyAddressInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.title = _data["title"];
            this.defaultPhoto = _data["defaultPhoto"] ? Photo.fromJS(_data["defaultPhoto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PropertyAddressInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyAddressInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["defaultPhoto"] = this.defaultPhoto ? this.defaultPhoto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPropertyAddressInfo {
    id?: string;
    code?: string | undefined;
    address?: Address;
    title?: string | undefined;
    defaultPhoto?: Photo;
}

export class PropertyAmenities implements IPropertyAmenities {
    hasFacadeSign?: boolean | undefined;
    hasElevator?: boolean | undefined;
    hasAlarm?: boolean | undefined;
    isAiry?: boolean | undefined;
    sieves?: boolean | undefined;
    hasSolarWaterHeating?: boolean | undefined;
    hasBoiler?: boolean | undefined;
    suitableForProfessionalUse?: boolean | undefined;
    suitableForTouristUse?: boolean | undefined;
    hasNightElectricCurrent?: boolean | undefined;
    hasSafetyDoor?: boolean | undefined;
    isBright?: boolean | undefined;
    accessibilityForDisabled?: boolean | undefined;
    hasPlayroom?: boolean | undefined;
    isPenthouse?: boolean | undefined;
    hasGarden?: boolean | undefined;
    hasPool?: boolean | undefined;
    hasStorageRoom?: boolean | undefined;
    petsAreAllowed?: boolean | undefined;
    hasTents?: boolean | undefined;
    isFloorApartment?: boolean | undefined;
    internalStaircase?: boolean | undefined;
    hasGym?: boolean | undefined;
    hasSeaView?: boolean | undefined;
    hasGreatView?: boolean | undefined;
    hasAirconditioning?: boolean | undefined;
    hasFirePlace?: boolean | undefined;

    constructor(data?: IPropertyAmenities) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasFacadeSign = _data["hasFacadeSign"];
            this.hasElevator = _data["hasElevator"];
            this.hasAlarm = _data["hasAlarm"];
            this.isAiry = _data["isAiry"];
            this.sieves = _data["sieves"];
            this.hasSolarWaterHeating = _data["hasSolarWaterHeating"];
            this.hasBoiler = _data["hasBoiler"];
            this.suitableForProfessionalUse = _data["suitableForProfessionalUse"];
            this.suitableForTouristUse = _data["suitableForTouristUse"];
            this.hasNightElectricCurrent = _data["hasNightElectricCurrent"];
            this.hasSafetyDoor = _data["hasSafetyDoor"];
            this.isBright = _data["isBright"];
            this.accessibilityForDisabled = _data["accessibilityForDisabled"];
            this.hasPlayroom = _data["hasPlayroom"];
            this.isPenthouse = _data["isPenthouse"];
            this.hasGarden = _data["hasGarden"];
            this.hasPool = _data["hasPool"];
            this.hasStorageRoom = _data["hasStorageRoom"];
            this.petsAreAllowed = _data["petsAreAllowed"];
            this.hasTents = _data["hasTents"];
            this.isFloorApartment = _data["isFloorApartment"];
            this.internalStaircase = _data["internalStaircase"];
            this.hasGym = _data["hasGym"];
            this.hasSeaView = _data["hasSeaView"];
            this.hasGreatView = _data["hasGreatView"];
            this.hasAirconditioning = _data["hasAirconditioning"];
            this.hasFirePlace = _data["hasFirePlace"];
        }
    }

    static fromJS(data: any): PropertyAmenities {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyAmenities();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasFacadeSign"] = this.hasFacadeSign;
        data["hasElevator"] = this.hasElevator;
        data["hasAlarm"] = this.hasAlarm;
        data["isAiry"] = this.isAiry;
        data["sieves"] = this.sieves;
        data["hasSolarWaterHeating"] = this.hasSolarWaterHeating;
        data["hasBoiler"] = this.hasBoiler;
        data["suitableForProfessionalUse"] = this.suitableForProfessionalUse;
        data["suitableForTouristUse"] = this.suitableForTouristUse;
        data["hasNightElectricCurrent"] = this.hasNightElectricCurrent;
        data["hasSafetyDoor"] = this.hasSafetyDoor;
        data["isBright"] = this.isBright;
        data["accessibilityForDisabled"] = this.accessibilityForDisabled;
        data["hasPlayroom"] = this.hasPlayroom;
        data["isPenthouse"] = this.isPenthouse;
        data["hasGarden"] = this.hasGarden;
        data["hasPool"] = this.hasPool;
        data["hasStorageRoom"] = this.hasStorageRoom;
        data["petsAreAllowed"] = this.petsAreAllowed;
        data["hasTents"] = this.hasTents;
        data["isFloorApartment"] = this.isFloorApartment;
        data["internalStaircase"] = this.internalStaircase;
        data["hasGym"] = this.hasGym;
        data["hasSeaView"] = this.hasSeaView;
        data["hasGreatView"] = this.hasGreatView;
        data["hasAirconditioning"] = this.hasAirconditioning;
        data["hasFirePlace"] = this.hasFirePlace;
        return data;
    }
}

export interface IPropertyAmenities {
    hasFacadeSign?: boolean | undefined;
    hasElevator?: boolean | undefined;
    hasAlarm?: boolean | undefined;
    isAiry?: boolean | undefined;
    sieves?: boolean | undefined;
    hasSolarWaterHeating?: boolean | undefined;
    hasBoiler?: boolean | undefined;
    suitableForProfessionalUse?: boolean | undefined;
    suitableForTouristUse?: boolean | undefined;
    hasNightElectricCurrent?: boolean | undefined;
    hasSafetyDoor?: boolean | undefined;
    isBright?: boolean | undefined;
    accessibilityForDisabled?: boolean | undefined;
    hasPlayroom?: boolean | undefined;
    isPenthouse?: boolean | undefined;
    hasGarden?: boolean | undefined;
    hasPool?: boolean | undefined;
    hasStorageRoom?: boolean | undefined;
    petsAreAllowed?: boolean | undefined;
    hasTents?: boolean | undefined;
    isFloorApartment?: boolean | undefined;
    internalStaircase?: boolean | undefined;
    hasGym?: boolean | undefined;
    hasSeaView?: boolean | undefined;
    hasGreatView?: boolean | undefined;
    hasAirconditioning?: boolean | undefined;
    hasFirePlace?: boolean | undefined;
}

export class PropertyAnalytics implements IPropertyAnalytics {
    id?: string;
    viewsTotal?: number;
    favoritesTotal?: number;
    callbacks?: number;
    walkthroughs?: number;
    viewsRangeChart?: ChartData[] | undefined;

    constructor(data?: IPropertyAnalytics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.viewsTotal = _data["viewsTotal"];
            this.favoritesTotal = _data["favoritesTotal"];
            this.callbacks = _data["callbacks"];
            this.walkthroughs = _data["walkthroughs"];
            if (Array.isArray(_data["viewsRangeChart"])) {
                this.viewsRangeChart = [] as any;
                for (let item of _data["viewsRangeChart"])
                    this.viewsRangeChart!.push(ChartData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PropertyAnalytics {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyAnalytics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["viewsTotal"] = this.viewsTotal;
        data["favoritesTotal"] = this.favoritesTotal;
        data["callbacks"] = this.callbacks;
        data["walkthroughs"] = this.walkthroughs;
        if (Array.isArray(this.viewsRangeChart)) {
            data["viewsRangeChart"] = [];
            for (let item of this.viewsRangeChart)
                data["viewsRangeChart"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPropertyAnalytics {
    id?: string;
    viewsTotal?: number;
    favoritesTotal?: number;
    callbacks?: number;
    walkthroughs?: number;
    viewsRangeChart?: ChartData[] | undefined;
}

export enum PropertyAvailability {
    Unknown = "Unknown",
    Rented = "Rented",
    Vacant = "Vacant",
    UsedByOwner = "UsedByOwner",
}

export enum PropertyCondition {
    Unknown = "Unknown",
    Completed = "Completed",
    Incomplete = "Incomplete",
    NewlyBuilt = "NewlyBuilt",
    Good = "Good",
    NeedsRenovation = "NeedsRenovation",
    Renovated = "Renovated",
    Excellent = "Excellent",
}

export class PropertyDetails implements IPropertyDetails {
    id?: string;
    code?: string | undefined;
    price?: number;
    auctionDateTime?: Date | undefined;
    timeSpanToNextRound?: TimeSpanForNextAuction;
    auctionRound?: number | undefined;
    floor?: number | undefined;
    propertyArea?: number | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    category?: string | undefined;
    type?: PropertyType;
    viewCount?: number;
    isSold?: boolean;
    preApproved?: PreApprovalStatus;
    preApprovalDescription?: LocalizedText;
    defaultImagePath?: string | undefined;
    isPromoted?: boolean;
    isFavorite?: boolean;
    isHot?: boolean;
    isSponsored?: boolean;
    distanceFromSelectedProperty?: number | undefined;
    lastModified?: Date | undefined;
    previousPrice?: number | undefined;
    address?: Address;
    createdOn?: Date;
    tags?: string[] | undefined;
    readonly title?: string | undefined;
    numberOfFloors?: number | undefined;
    numberOfRooms?: number | undefined;
    numberOfBathrooms?: number | undefined;
    numberOfWC?: number | undefined;
    defaultPhoto?: Photo;
    constructionYear?: number | undefined;
    isExclusive?: boolean;
    auctionRounds?: AuctionDetails;
    publishedStatus?: ArticleStatus;
    amenities?: PropertyAmenities;
    externalCode?: string | undefined;
    kaek?: string | undefined;
    coveredVeranda?: number | undefined;
    uncoveredVeranda?: number | undefined;
    basementSize?: number | undefined;
    plotArea?: number | undefined;
    ownershipPercentage?: number | undefined;
    ownershipType?: OwnershipType;
    neighborhood?: string | undefined;
    renovationYear?: number | undefined;
    propertyStatus?: string | undefined;
    constructionMaterial?: ConstructionMaterial[] | undefined;
    developer?: string | undefined;
    propertyUsageCategory?: PropertyUsageCategory;
    residentialZone?: boolean | undefined;
    parkingType?: ParkingType[] | undefined;
    parkingSpace?: number | undefined;
    storageArea?: number | undefined;
    storageAreaAmount?: number | undefined;
    energyClass?: EnergyClass;
    heatingType?: HeatingType;
    frames?: string | undefined;
    availability?: PropertyAvailability;
    floorMaterial?: FloorMaterial[] | undefined;
    masterRoom?: number;
    heatingControl?: HeatingControl;
    view?: View[] | undefined;
    orientation?: Orientation;
    nearbyHighways?: string | undefined;
    municipalTaxes?: number | undefined;
    sharedExpenses?: number | undefined;
    singlePropertyOwnershipTax?: number | undefined;
    estRentalIncome?: number | undefined;
    preApprovalAmmount?: number | undefined;
    preApprovalDate?: Date | undefined;
    details?: string | undefined;
    otherCosts?: number | undefined;
    brokerName?: string | undefined;
    brokerEmail?: string | undefined;
    storageType?: StorageType[] | undefined;
    publishedVersion?: number | undefined;

    constructor(data?: IPropertyDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.price = _data["price"];
            this.auctionDateTime = _data["auctionDateTime"] ? new Date(_data["auctionDateTime"].toString()) : <any>undefined;
            this.timeSpanToNextRound = _data["timeSpanToNextRound"] ? TimeSpanForNextAuction.fromJS(_data["timeSpanToNextRound"]) : <any>undefined;
            this.auctionRound = _data["auctionRound"];
            this.floor = _data["floor"];
            this.propertyArea = _data["propertyArea"];
            this.description = _data["description"];
            this.shortDescription = _data["shortDescription"];
            this.category = _data["category"];
            this.type = _data["type"];
            this.viewCount = _data["viewCount"];
            this.isSold = _data["isSold"];
            this.preApproved = _data["preApproved"];
            this.preApprovalDescription = _data["preApprovalDescription"] ? LocalizedText.fromJS(_data["preApprovalDescription"]) : <any>undefined;
            this.defaultImagePath = _data["defaultImagePath"];
            this.isPromoted = _data["isPromoted"];
            this.isFavorite = _data["isFavorite"];
            this.isHot = _data["isHot"];
            this.isSponsored = _data["isSponsored"];
            this.distanceFromSelectedProperty = _data["distanceFromSelectedProperty"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.previousPrice = _data["previousPrice"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            (<any>this).title = _data["title"];
            this.numberOfFloors = _data["numberOfFloors"];
            this.numberOfRooms = _data["numberOfRooms"];
            this.numberOfBathrooms = _data["numberOfBathrooms"];
            this.numberOfWC = _data["numberOfWC"];
            this.defaultPhoto = _data["defaultPhoto"] ? Photo.fromJS(_data["defaultPhoto"]) : <any>undefined;
            this.constructionYear = _data["constructionYear"];
            this.isExclusive = _data["isExclusive"];
            this.auctionRounds = _data["auctionRounds"] ? AuctionDetails.fromJS(_data["auctionRounds"]) : <any>undefined;
            this.publishedStatus = _data["publishedStatus"];
            this.amenities = _data["amenities"] ? PropertyAmenities.fromJS(_data["amenities"]) : <any>undefined;
            this.externalCode = _data["externalCode"];
            this.kaek = _data["kaek"];
            this.coveredVeranda = _data["coveredVeranda"];
            this.uncoveredVeranda = _data["uncoveredVeranda"];
            this.basementSize = _data["basementSize"];
            this.plotArea = _data["plotArea"];
            this.ownershipPercentage = _data["ownershipPercentage"];
            this.ownershipType = _data["ownershipType"];
            this.neighborhood = _data["neighborhood"];
            this.renovationYear = _data["renovationYear"];
            this.propertyStatus = _data["propertyStatus"];
            if (Array.isArray(_data["constructionMaterial"])) {
                this.constructionMaterial = [] as any;
                for (let item of _data["constructionMaterial"])
                    this.constructionMaterial!.push(item);
            }
            this.developer = _data["developer"];
            this.propertyUsageCategory = _data["propertyUsageCategory"];
            this.residentialZone = _data["residentialZone"];
            if (Array.isArray(_data["parkingType"])) {
                this.parkingType = [] as any;
                for (let item of _data["parkingType"])
                    this.parkingType!.push(item);
            }
            this.parkingSpace = _data["parkingSpace"];
            this.storageArea = _data["storageArea"];
            this.storageAreaAmount = _data["storageAreaAmount"];
            this.energyClass = _data["energyClass"];
            this.heatingType = _data["heatingType"];
            this.frames = _data["frames"];
            this.availability = _data["availability"];
            if (Array.isArray(_data["floorMaterial"])) {
                this.floorMaterial = [] as any;
                for (let item of _data["floorMaterial"])
                    this.floorMaterial!.push(item);
            }
            this.masterRoom = _data["masterRoom"];
            this.heatingControl = _data["heatingControl"];
            if (Array.isArray(_data["view"])) {
                this.view = [] as any;
                for (let item of _data["view"])
                    this.view!.push(item);
            }
            this.orientation = _data["orientation"];
            this.nearbyHighways = _data["nearbyHighways"];
            this.municipalTaxes = _data["municipalTaxes"];
            this.sharedExpenses = _data["sharedExpenses"];
            this.singlePropertyOwnershipTax = _data["singlePropertyOwnershipTax"];
            this.estRentalIncome = _data["estRentalIncome"];
            this.preApprovalAmmount = _data["preApprovalAmmount"];
            this.preApprovalDate = _data["preApprovalDate"] ? new Date(_data["preApprovalDate"].toString()) : <any>undefined;
            this.details = _data["details"];
            this.otherCosts = _data["otherCosts"];
            this.brokerName = _data["brokerName"];
            this.brokerEmail = _data["brokerEmail"];
            if (Array.isArray(_data["storageType"])) {
                this.storageType = [] as any;
                for (let item of _data["storageType"])
                    this.storageType!.push(item);
            }
            this.publishedVersion = _data["publishedVersion"];
        }
    }

    static fromJS(data: any): PropertyDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["price"] = this.price;
        data["auctionDateTime"] = this.auctionDateTime ? this.auctionDateTime.toISOString() : <any>undefined;
        data["timeSpanToNextRound"] = this.timeSpanToNextRound ? this.timeSpanToNextRound.toJSON() : <any>undefined;
        data["auctionRound"] = this.auctionRound;
        data["floor"] = this.floor;
        data["propertyArea"] = this.propertyArea;
        data["description"] = this.description;
        data["shortDescription"] = this.shortDescription;
        data["category"] = this.category;
        data["type"] = this.type;
        data["viewCount"] = this.viewCount;
        data["isSold"] = this.isSold;
        data["preApproved"] = this.preApproved;
        data["preApprovalDescription"] = this.preApprovalDescription ? this.preApprovalDescription.toJSON() : <any>undefined;
        data["defaultImagePath"] = this.defaultImagePath;
        data["isPromoted"] = this.isPromoted;
        data["isFavorite"] = this.isFavorite;
        data["isHot"] = this.isHot;
        data["isSponsored"] = this.isSponsored;
        data["distanceFromSelectedProperty"] = this.distanceFromSelectedProperty;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["previousPrice"] = this.previousPrice;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["title"] = this.title;
        data["numberOfFloors"] = this.numberOfFloors;
        data["numberOfRooms"] = this.numberOfRooms;
        data["numberOfBathrooms"] = this.numberOfBathrooms;
        data["numberOfWC"] = this.numberOfWC;
        data["defaultPhoto"] = this.defaultPhoto ? this.defaultPhoto.toJSON() : <any>undefined;
        data["constructionYear"] = this.constructionYear;
        data["isExclusive"] = this.isExclusive;
        data["auctionRounds"] = this.auctionRounds ? this.auctionRounds.toJSON() : <any>undefined;
        data["publishedStatus"] = this.publishedStatus;
        data["amenities"] = this.amenities ? this.amenities.toJSON() : <any>undefined;
        data["externalCode"] = this.externalCode;
        data["kaek"] = this.kaek;
        data["coveredVeranda"] = this.coveredVeranda;
        data["uncoveredVeranda"] = this.uncoveredVeranda;
        data["basementSize"] = this.basementSize;
        data["plotArea"] = this.plotArea;
        data["ownershipPercentage"] = this.ownershipPercentage;
        data["ownershipType"] = this.ownershipType;
        data["neighborhood"] = this.neighborhood;
        data["renovationYear"] = this.renovationYear;
        data["propertyStatus"] = this.propertyStatus;
        if (Array.isArray(this.constructionMaterial)) {
            data["constructionMaterial"] = [];
            for (let item of this.constructionMaterial)
                data["constructionMaterial"].push(item);
        }
        data["developer"] = this.developer;
        data["propertyUsageCategory"] = this.propertyUsageCategory;
        data["residentialZone"] = this.residentialZone;
        if (Array.isArray(this.parkingType)) {
            data["parkingType"] = [];
            for (let item of this.parkingType)
                data["parkingType"].push(item);
        }
        data["parkingSpace"] = this.parkingSpace;
        data["storageArea"] = this.storageArea;
        data["storageAreaAmount"] = this.storageAreaAmount;
        data["energyClass"] = this.energyClass;
        data["heatingType"] = this.heatingType;
        data["frames"] = this.frames;
        data["availability"] = this.availability;
        if (Array.isArray(this.floorMaterial)) {
            data["floorMaterial"] = [];
            for (let item of this.floorMaterial)
                data["floorMaterial"].push(item);
        }
        data["masterRoom"] = this.masterRoom;
        data["heatingControl"] = this.heatingControl;
        if (Array.isArray(this.view)) {
            data["view"] = [];
            for (let item of this.view)
                data["view"].push(item);
        }
        data["orientation"] = this.orientation;
        data["nearbyHighways"] = this.nearbyHighways;
        data["municipalTaxes"] = this.municipalTaxes;
        data["sharedExpenses"] = this.sharedExpenses;
        data["singlePropertyOwnershipTax"] = this.singlePropertyOwnershipTax;
        data["estRentalIncome"] = this.estRentalIncome;
        data["preApprovalAmmount"] = this.preApprovalAmmount;
        data["preApprovalDate"] = this.preApprovalDate ? this.preApprovalDate.toISOString() : <any>undefined;
        data["details"] = this.details;
        data["otherCosts"] = this.otherCosts;
        data["brokerName"] = this.brokerName;
        data["brokerEmail"] = this.brokerEmail;
        if (Array.isArray(this.storageType)) {
            data["storageType"] = [];
            for (let item of this.storageType)
                data["storageType"].push(item);
        }
        data["publishedVersion"] = this.publishedVersion;
        return data;
    }
}

export interface IPropertyDetails {
    id?: string;
    code?: string | undefined;
    price?: number;
    auctionDateTime?: Date | undefined;
    timeSpanToNextRound?: TimeSpanForNextAuction;
    auctionRound?: number | undefined;
    floor?: number | undefined;
    propertyArea?: number | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    category?: string | undefined;
    type?: PropertyType;
    viewCount?: number;
    isSold?: boolean;
    preApproved?: PreApprovalStatus;
    preApprovalDescription?: LocalizedText;
    defaultImagePath?: string | undefined;
    isPromoted?: boolean;
    isFavorite?: boolean;
    isHot?: boolean;
    isSponsored?: boolean;
    distanceFromSelectedProperty?: number | undefined;
    lastModified?: Date | undefined;
    previousPrice?: number | undefined;
    address?: Address;
    createdOn?: Date;
    tags?: string[] | undefined;
    title?: string | undefined;
    numberOfFloors?: number | undefined;
    numberOfRooms?: number | undefined;
    numberOfBathrooms?: number | undefined;
    numberOfWC?: number | undefined;
    defaultPhoto?: Photo;
    constructionYear?: number | undefined;
    isExclusive?: boolean;
    auctionRounds?: AuctionDetails;
    publishedStatus?: ArticleStatus;
    amenities?: PropertyAmenities;
    externalCode?: string | undefined;
    kaek?: string | undefined;
    coveredVeranda?: number | undefined;
    uncoveredVeranda?: number | undefined;
    basementSize?: number | undefined;
    plotArea?: number | undefined;
    ownershipPercentage?: number | undefined;
    ownershipType?: OwnershipType;
    neighborhood?: string | undefined;
    renovationYear?: number | undefined;
    propertyStatus?: string | undefined;
    constructionMaterial?: ConstructionMaterial[] | undefined;
    developer?: string | undefined;
    propertyUsageCategory?: PropertyUsageCategory;
    residentialZone?: boolean | undefined;
    parkingType?: ParkingType[] | undefined;
    parkingSpace?: number | undefined;
    storageArea?: number | undefined;
    storageAreaAmount?: number | undefined;
    energyClass?: EnergyClass;
    heatingType?: HeatingType;
    frames?: string | undefined;
    availability?: PropertyAvailability;
    floorMaterial?: FloorMaterial[] | undefined;
    masterRoom?: number;
    heatingControl?: HeatingControl;
    view?: View[] | undefined;
    orientation?: Orientation;
    nearbyHighways?: string | undefined;
    municipalTaxes?: number | undefined;
    sharedExpenses?: number | undefined;
    singlePropertyOwnershipTax?: number | undefined;
    estRentalIncome?: number | undefined;
    preApprovalAmmount?: number | undefined;
    preApprovalDate?: Date | undefined;
    details?: string | undefined;
    otherCosts?: number | undefined;
    brokerName?: string | undefined;
    brokerEmail?: string | undefined;
    storageType?: StorageType[] | undefined;
    publishedVersion?: number | undefined;
}

export class PropertyDetailsResultSet implements IPropertyDetailsResultSet {
    count?: number;
    items?: PropertyDetails[] | undefined;

    constructor(data?: IPropertyDetailsResultSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PropertyDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PropertyDetailsResultSet {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyDetailsResultSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPropertyDetailsResultSet {
    count?: number;
    items?: PropertyDetails[] | undefined;
}

export class PropertyListFilter implements IPropertyListFilter {
    searchTerm?: string | undefined;
    minPrice?: number | undefined;
    maxPrice?: number | undefined;
    type?: PropertyType[] | undefined;
    minSqMeters?: number | undefined;
    maxSqMeters?: number | undefined;
    floor?: FloorFilter[] | undefined;
    hasParking?: boolean | undefined;
    parkingSpace?: BedroomFilter[] | undefined;
    bedrooms?: BedroomFilter[] | undefined;
    bathrooms?: BedroomFilter[] | undefined;
    minConstructionYear?: number | undefined;
    maxConstructionYear?: number | undefined;
    preApproved?: boolean | undefined;
    inAuction?: boolean | undefined;
    auctionRound?: AuctionRoundFilter[] | undefined;
    hasElevator?: boolean | undefined;
    hasAlarm?: boolean | undefined;
    isAiry?: boolean | undefined;
    sieves?: boolean | undefined;
    hasSolarWaterHeating?: boolean | undefined;
    hasBoiler?: boolean | undefined;
    suitableForProfessionalUse?: boolean | undefined;
    suitableForTouristUse?: boolean | undefined;
    hasNightElectricCurrent?: boolean | undefined;
    hasSafetyDoor?: boolean | undefined;
    isBright?: boolean | undefined;
    accessibilityForDisabled?: boolean | undefined;
    hasPlayroom?: boolean | undefined;
    isPenthouse?: boolean | undefined;
    hasGarden?: boolean | undefined;
    hasPool?: boolean | undefined;
    hasStorageRoom?: boolean | undefined;
    petsAreAllowed?: boolean | undefined;
    hasTents?: boolean | undefined;
    isFloorApartment?: boolean | undefined;
    internalStaircase?: boolean | undefined;
    view?: string | undefined;
    numberOfRooms?: string | undefined;
    numberOfBathRooms?: string | undefined;
    hasGym?: boolean | undefined;
    hasSeaView?: boolean | undefined;
    hasGreatView?: boolean | undefined;
    hasAirconditioning?: boolean | undefined;
    hasFirePlace?: boolean | undefined;
    heatingType?: HeatingType[] | undefined;
    heatingControl?: HeatingControl[] | undefined;
    area?: string | undefined;
    includeDetails?: boolean;
    clauses?: string | undefined;
    isREO?: boolean | undefined;
    isSold?: boolean | undefined;
    tag?: string[] | undefined;
    searchFromMap?: boolean | undefined;
    propertyIds?: string[] | undefined;

    constructor(data?: IPropertyListFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchTerm = _data["searchTerm"];
            this.minPrice = _data["minPrice"];
            this.maxPrice = _data["maxPrice"];
            if (Array.isArray(_data["type"])) {
                this.type = [] as any;
                for (let item of _data["type"])
                    this.type!.push(item);
            }
            this.minSqMeters = _data["minSqMeters"];
            this.maxSqMeters = _data["maxSqMeters"];
            if (Array.isArray(_data["floor"])) {
                this.floor = [] as any;
                for (let item of _data["floor"])
                    this.floor!.push(item);
            }
            this.hasParking = _data["hasParking"];
            if (Array.isArray(_data["parkingSpace"])) {
                this.parkingSpace = [] as any;
                for (let item of _data["parkingSpace"])
                    this.parkingSpace!.push(item);
            }
            if (Array.isArray(_data["bedrooms"])) {
                this.bedrooms = [] as any;
                for (let item of _data["bedrooms"])
                    this.bedrooms!.push(item);
            }
            if (Array.isArray(_data["bathrooms"])) {
                this.bathrooms = [] as any;
                for (let item of _data["bathrooms"])
                    this.bathrooms!.push(item);
            }
            this.minConstructionYear = _data["minConstructionYear"];
            this.maxConstructionYear = _data["maxConstructionYear"];
            this.preApproved = _data["preApproved"];
            this.inAuction = _data["inAuction"];
            if (Array.isArray(_data["auctionRound"])) {
                this.auctionRound = [] as any;
                for (let item of _data["auctionRound"])
                    this.auctionRound!.push(item);
            }
            this.hasElevator = _data["hasElevator"];
            this.hasAlarm = _data["hasAlarm"];
            this.isAiry = _data["isAiry"];
            this.sieves = _data["sieves"];
            this.hasSolarWaterHeating = _data["hasSolarWaterHeating"];
            this.hasBoiler = _data["hasBoiler"];
            this.suitableForProfessionalUse = _data["suitableForProfessionalUse"];
            this.suitableForTouristUse = _data["suitableForTouristUse"];
            this.hasNightElectricCurrent = _data["hasNightElectricCurrent"];
            this.hasSafetyDoor = _data["hasSafetyDoor"];
            this.isBright = _data["isBright"];
            this.accessibilityForDisabled = _data["accessibilityForDisabled"];
            this.hasPlayroom = _data["hasPlayroom"];
            this.isPenthouse = _data["isPenthouse"];
            this.hasGarden = _data["hasGarden"];
            this.hasPool = _data["hasPool"];
            this.hasStorageRoom = _data["hasStorageRoom"];
            this.petsAreAllowed = _data["petsAreAllowed"];
            this.hasTents = _data["hasTents"];
            this.isFloorApartment = _data["isFloorApartment"];
            this.internalStaircase = _data["internalStaircase"];
            this.view = _data["view"];
            this.numberOfRooms = _data["numberOfRooms"];
            this.numberOfBathRooms = _data["numberOfBathRooms"];
            this.hasGym = _data["hasGym"];
            this.hasSeaView = _data["hasSeaView"];
            this.hasGreatView = _data["hasGreatView"];
            this.hasAirconditioning = _data["hasAirconditioning"];
            this.hasFirePlace = _data["hasFirePlace"];
            if (Array.isArray(_data["heatingType"])) {
                this.heatingType = [] as any;
                for (let item of _data["heatingType"])
                    this.heatingType!.push(item);
            }
            if (Array.isArray(_data["heatingControl"])) {
                this.heatingControl = [] as any;
                for (let item of _data["heatingControl"])
                    this.heatingControl!.push(item);
            }
            this.area = _data["area"];
            this.includeDetails = _data["includeDetails"];
            this.clauses = _data["clauses"];
            this.isREO = _data["isREO"];
            this.isSold = _data["isSold"];
            if (Array.isArray(_data["tag"])) {
                this.tag = [] as any;
                for (let item of _data["tag"])
                    this.tag!.push(item);
            }
            this.searchFromMap = _data["searchFromMap"];
            if (Array.isArray(_data["propertyIds"])) {
                this.propertyIds = [] as any;
                for (let item of _data["propertyIds"])
                    this.propertyIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PropertyListFilter {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyListFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchTerm"] = this.searchTerm;
        data["minPrice"] = this.minPrice;
        data["maxPrice"] = this.maxPrice;
        if (Array.isArray(this.type)) {
            data["type"] = [];
            for (let item of this.type)
                data["type"].push(item);
        }
        data["minSqMeters"] = this.minSqMeters;
        data["maxSqMeters"] = this.maxSqMeters;
        if (Array.isArray(this.floor)) {
            data["floor"] = [];
            for (let item of this.floor)
                data["floor"].push(item);
        }
        data["hasParking"] = this.hasParking;
        if (Array.isArray(this.parkingSpace)) {
            data["parkingSpace"] = [];
            for (let item of this.parkingSpace)
                data["parkingSpace"].push(item);
        }
        if (Array.isArray(this.bedrooms)) {
            data["bedrooms"] = [];
            for (let item of this.bedrooms)
                data["bedrooms"].push(item);
        }
        if (Array.isArray(this.bathrooms)) {
            data["bathrooms"] = [];
            for (let item of this.bathrooms)
                data["bathrooms"].push(item);
        }
        data["minConstructionYear"] = this.minConstructionYear;
        data["maxConstructionYear"] = this.maxConstructionYear;
        data["preApproved"] = this.preApproved;
        data["inAuction"] = this.inAuction;
        if (Array.isArray(this.auctionRound)) {
            data["auctionRound"] = [];
            for (let item of this.auctionRound)
                data["auctionRound"].push(item);
        }
        data["hasElevator"] = this.hasElevator;
        data["hasAlarm"] = this.hasAlarm;
        data["isAiry"] = this.isAiry;
        data["sieves"] = this.sieves;
        data["hasSolarWaterHeating"] = this.hasSolarWaterHeating;
        data["hasBoiler"] = this.hasBoiler;
        data["suitableForProfessionalUse"] = this.suitableForProfessionalUse;
        data["suitableForTouristUse"] = this.suitableForTouristUse;
        data["hasNightElectricCurrent"] = this.hasNightElectricCurrent;
        data["hasSafetyDoor"] = this.hasSafetyDoor;
        data["isBright"] = this.isBright;
        data["accessibilityForDisabled"] = this.accessibilityForDisabled;
        data["hasPlayroom"] = this.hasPlayroom;
        data["isPenthouse"] = this.isPenthouse;
        data["hasGarden"] = this.hasGarden;
        data["hasPool"] = this.hasPool;
        data["hasStorageRoom"] = this.hasStorageRoom;
        data["petsAreAllowed"] = this.petsAreAllowed;
        data["hasTents"] = this.hasTents;
        data["isFloorApartment"] = this.isFloorApartment;
        data["internalStaircase"] = this.internalStaircase;
        data["view"] = this.view;
        data["numberOfRooms"] = this.numberOfRooms;
        data["numberOfBathRooms"] = this.numberOfBathRooms;
        data["hasGym"] = this.hasGym;
        data["hasSeaView"] = this.hasSeaView;
        data["hasGreatView"] = this.hasGreatView;
        data["hasAirconditioning"] = this.hasAirconditioning;
        data["hasFirePlace"] = this.hasFirePlace;
        if (Array.isArray(this.heatingType)) {
            data["heatingType"] = [];
            for (let item of this.heatingType)
                data["heatingType"].push(item);
        }
        if (Array.isArray(this.heatingControl)) {
            data["heatingControl"] = [];
            for (let item of this.heatingControl)
                data["heatingControl"].push(item);
        }
        data["area"] = this.area;
        data["includeDetails"] = this.includeDetails;
        data["clauses"] = this.clauses;
        data["isREO"] = this.isREO;
        data["isSold"] = this.isSold;
        if (Array.isArray(this.tag)) {
            data["tag"] = [];
            for (let item of this.tag)
                data["tag"].push(item);
        }
        data["searchFromMap"] = this.searchFromMap;
        if (Array.isArray(this.propertyIds)) {
            data["propertyIds"] = [];
            for (let item of this.propertyIds)
                data["propertyIds"].push(item);
        }
        return data;
    }
}

export interface IPropertyListFilter {
    searchTerm?: string | undefined;
    minPrice?: number | undefined;
    maxPrice?: number | undefined;
    type?: PropertyType[] | undefined;
    minSqMeters?: number | undefined;
    maxSqMeters?: number | undefined;
    floor?: FloorFilter[] | undefined;
    hasParking?: boolean | undefined;
    parkingSpace?: BedroomFilter[] | undefined;
    bedrooms?: BedroomFilter[] | undefined;
    bathrooms?: BedroomFilter[] | undefined;
    minConstructionYear?: number | undefined;
    maxConstructionYear?: number | undefined;
    preApproved?: boolean | undefined;
    inAuction?: boolean | undefined;
    auctionRound?: AuctionRoundFilter[] | undefined;
    hasElevator?: boolean | undefined;
    hasAlarm?: boolean | undefined;
    isAiry?: boolean | undefined;
    sieves?: boolean | undefined;
    hasSolarWaterHeating?: boolean | undefined;
    hasBoiler?: boolean | undefined;
    suitableForProfessionalUse?: boolean | undefined;
    suitableForTouristUse?: boolean | undefined;
    hasNightElectricCurrent?: boolean | undefined;
    hasSafetyDoor?: boolean | undefined;
    isBright?: boolean | undefined;
    accessibilityForDisabled?: boolean | undefined;
    hasPlayroom?: boolean | undefined;
    isPenthouse?: boolean | undefined;
    hasGarden?: boolean | undefined;
    hasPool?: boolean | undefined;
    hasStorageRoom?: boolean | undefined;
    petsAreAllowed?: boolean | undefined;
    hasTents?: boolean | undefined;
    isFloorApartment?: boolean | undefined;
    internalStaircase?: boolean | undefined;
    view?: string | undefined;
    numberOfRooms?: string | undefined;
    numberOfBathRooms?: string | undefined;
    hasGym?: boolean | undefined;
    hasSeaView?: boolean | undefined;
    hasGreatView?: boolean | undefined;
    hasAirconditioning?: boolean | undefined;
    hasFirePlace?: boolean | undefined;
    heatingType?: HeatingType[] | undefined;
    heatingControl?: HeatingControl[] | undefined;
    area?: string | undefined;
    includeDetails?: boolean;
    clauses?: string | undefined;
    isREO?: boolean | undefined;
    isSold?: boolean | undefined;
    tag?: string[] | undefined;
    searchFromMap?: boolean | undefined;
    propertyIds?: string[] | undefined;
}

export class PropertyListForMap implements IPropertyListForMap {
    geoPoint?: string | undefined;
    price?: number;
    id?: string;
    code?: string | undefined;

    constructor(data?: IPropertyListForMap) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.geoPoint = _data["geoPoint"];
            this.price = _data["price"];
            this.id = _data["id"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): PropertyListForMap {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyListForMap();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geoPoint"] = this.geoPoint;
        data["price"] = this.price;
        data["id"] = this.id;
        data["code"] = this.code;
        return data;
    }
}

export interface IPropertyListForMap {
    geoPoint?: string | undefined;
    price?: number;
    id?: string;
    code?: string | undefined;
}

export class PropertyListForMapResponse implements IPropertyListForMapResponse {
    criteriaAdjusted?: boolean;
    properties?: PropertyListForMap[] | undefined;

    constructor(data?: IPropertyListForMapResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.criteriaAdjusted = _data["criteriaAdjusted"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(PropertyListForMap.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PropertyListForMapResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyListForMapResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteriaAdjusted"] = this.criteriaAdjusted;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPropertyListForMapResponse {
    criteriaAdjusted?: boolean;
    properties?: PropertyListForMap[] | undefined;
}

export class PropertyListResponse implements IPropertyListResponse {
    criteriaAdjusted?: boolean;
    properties?: PropertyDetailsResultSet;

    constructor(data?: IPropertyListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.criteriaAdjusted = _data["criteriaAdjusted"];
            this.properties = _data["properties"] ? PropertyDetailsResultSet.fromJS(_data["properties"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PropertyListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteriaAdjusted"] = this.criteriaAdjusted;
        data["properties"] = this.properties ? this.properties.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPropertyListResponse {
    criteriaAdjusted?: boolean;
    properties?: PropertyDetailsResultSet;
}

export class PropertyListingDetails implements IPropertyListingDetails {
    propertyId?: string | undefined;
    publishedStatus?: ArticleStatus;
    basicInfo?: BasicInfo;
    content?: Content;
    advisor?: Advisor;
    features?: Features;
    construction?: Construction;
    ownership?: Ownership;
    surroundings?: Surroundings;
    auctionDetails?: AuctionDetails;

    constructor(data?: IPropertyListingDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyId = _data["propertyId"];
            this.publishedStatus = _data["publishedStatus"];
            this.basicInfo = _data["basicInfo"] ? BasicInfo.fromJS(_data["basicInfo"]) : <any>undefined;
            this.content = _data["content"] ? Content.fromJS(_data["content"]) : <any>undefined;
            this.advisor = _data["advisor"] ? Advisor.fromJS(_data["advisor"]) : <any>undefined;
            this.features = _data["features"] ? Features.fromJS(_data["features"]) : <any>undefined;
            this.construction = _data["construction"] ? Construction.fromJS(_data["construction"]) : <any>undefined;
            this.ownership = _data["ownership"] ? Ownership.fromJS(_data["ownership"]) : <any>undefined;
            this.surroundings = _data["surroundings"] ? Surroundings.fromJS(_data["surroundings"]) : <any>undefined;
            this.auctionDetails = _data["auctionDetails"] ? AuctionDetails.fromJS(_data["auctionDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PropertyListingDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyListingDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyId"] = this.propertyId;
        data["publishedStatus"] = this.publishedStatus;
        data["basicInfo"] = this.basicInfo ? this.basicInfo.toJSON() : <any>undefined;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["advisor"] = this.advisor ? this.advisor.toJSON() : <any>undefined;
        data["features"] = this.features ? this.features.toJSON() : <any>undefined;
        data["construction"] = this.construction ? this.construction.toJSON() : <any>undefined;
        data["ownership"] = this.ownership ? this.ownership.toJSON() : <any>undefined;
        data["surroundings"] = this.surroundings ? this.surroundings.toJSON() : <any>undefined;
        data["auctionDetails"] = this.auctionDetails ? this.auctionDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPropertyListingDetails {
    propertyId?: string | undefined;
    publishedStatus?: ArticleStatus;
    basicInfo?: BasicInfo;
    content?: Content;
    advisor?: Advisor;
    features?: Features;
    construction?: Construction;
    ownership?: Ownership;
    surroundings?: Surroundings;
    auctionDetails?: AuctionDetails;
}

export class PropertyListingDetailsUpsertRequest implements IPropertyListingDetailsUpsertRequest {
    propertyId?: string | undefined;
    basicInfo?: BasicInfo;
    content?: Content;
    features?: Features;
    construction?: Construction;
    ownership?: Ownership;
    surroundings?: Surroundings;

    constructor(data?: IPropertyListingDetailsUpsertRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyId = _data["propertyId"];
            this.basicInfo = _data["basicInfo"] ? BasicInfo.fromJS(_data["basicInfo"]) : <any>undefined;
            this.content = _data["content"] ? Content.fromJS(_data["content"]) : <any>undefined;
            this.features = _data["features"] ? Features.fromJS(_data["features"]) : <any>undefined;
            this.construction = _data["construction"] ? Construction.fromJS(_data["construction"]) : <any>undefined;
            this.ownership = _data["ownership"] ? Ownership.fromJS(_data["ownership"]) : <any>undefined;
            this.surroundings = _data["surroundings"] ? Surroundings.fromJS(_data["surroundings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PropertyListingDetailsUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyListingDetailsUpsertRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyId"] = this.propertyId;
        data["basicInfo"] = this.basicInfo ? this.basicInfo.toJSON() : <any>undefined;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["features"] = this.features ? this.features.toJSON() : <any>undefined;
        data["construction"] = this.construction ? this.construction.toJSON() : <any>undefined;
        data["ownership"] = this.ownership ? this.ownership.toJSON() : <any>undefined;
        data["surroundings"] = this.surroundings ? this.surroundings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPropertyListingDetailsUpsertRequest {
    propertyId?: string | undefined;
    basicInfo?: BasicInfo;
    content?: Content;
    features?: Features;
    construction?: Construction;
    ownership?: Ownership;
    surroundings?: Surroundings;
}

export class PropertyOffer implements IPropertyOffer {
    id?: string;
    propertyId?: string;
    byUserId!: string | undefined;
    price?: number;
    loanAmount?: number;
    ownFunds?: number;
    placedIn?: Date;
    status?: OfferStatus;
    rejectedReason?: string | undefined;
    workflowId?: string;

    constructor(data?: IPropertyOffer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.propertyId = _data["propertyId"];
            this.byUserId = _data["byUserId"];
            this.price = _data["price"];
            this.loanAmount = _data["loanAmount"];
            this.ownFunds = _data["ownFunds"];
            this.placedIn = _data["placedIn"] ? new Date(_data["placedIn"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.rejectedReason = _data["rejectedReason"];
            this.workflowId = _data["workflowId"];
        }
    }

    static fromJS(data: any): PropertyOffer {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyOffer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["propertyId"] = this.propertyId;
        data["byUserId"] = this.byUserId;
        data["price"] = this.price;
        data["loanAmount"] = this.loanAmount;
        data["ownFunds"] = this.ownFunds;
        data["placedIn"] = this.placedIn ? this.placedIn.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["rejectedReason"] = this.rejectedReason;
        data["workflowId"] = this.workflowId;
        return data;
    }
}

export interface IPropertyOffer {
    id?: string;
    propertyId?: string;
    byUserId: string | undefined;
    price?: number;
    loanAmount?: number;
    ownFunds?: number;
    placedIn?: Date;
    status?: OfferStatus;
    rejectedReason?: string | undefined;
    workflowId?: string;
}

export class PropertyOfferResultSet implements IPropertyOfferResultSet {
    count?: number;
    items?: PropertyOffer[] | undefined;

    constructor(data?: IPropertyOfferResultSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PropertyOffer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PropertyOfferResultSet {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyOfferResultSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPropertyOfferResultSet {
    count?: number;
    items?: PropertyOffer[] | undefined;
}

export class PropertyOffersBuyerResponse implements IPropertyOffersBuyerResponse {
    offers?: PropertyOfferResultSet;

    constructor(data?: IPropertyOffersBuyerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offers = _data["offers"] ? PropertyOfferResultSet.fromJS(_data["offers"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PropertyOffersBuyerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyOffersBuyerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offers"] = this.offers ? this.offers.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPropertyOffersBuyerResponse {
    offers?: PropertyOfferResultSet;
}

export class PropertyOffersSellerResponse implements IPropertyOffersSellerResponse {
    offers?: PropertyOfferResultSet;
    highestOffer?: PropertyOffer;

    constructor(data?: IPropertyOffersSellerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offers = _data["offers"] ? PropertyOfferResultSet.fromJS(_data["offers"]) : <any>undefined;
            this.highestOffer = _data["highestOffer"] ? PropertyOffer.fromJS(_data["highestOffer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PropertyOffersSellerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyOffersSellerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offers"] = this.offers ? this.offers.toJSON() : <any>undefined;
        data["highestOffer"] = this.highestOffer ? this.highestOffer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPropertyOffersSellerResponse {
    offers?: PropertyOfferResultSet;
    highestOffer?: PropertyOffer;
}

export class PropertyOwnershipResponse implements IPropertyOwnershipResponse {
    isMine?: boolean;

    constructor(data?: IPropertyOwnershipResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isMine = _data["isMine"];
        }
    }

    static fromJS(data: any): PropertyOwnershipResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyOwnershipResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isMine"] = this.isMine;
        return data;
    }
}

export interface IPropertyOwnershipResponse {
    isMine?: boolean;
}

export class PropertyPointOfInterest implements IPropertyPointOfInterest {
    name?: string | undefined;
    distance?: number;
    coordinates?: string | undefined;
    placeType?: PlaceType;

    constructor(data?: IPropertyPointOfInterest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.distance = _data["distance"];
            this.coordinates = _data["coordinates"];
            this.placeType = _data["placeType"];
        }
    }

    static fromJS(data: any): PropertyPointOfInterest {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyPointOfInterest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["distance"] = this.distance;
        data["coordinates"] = this.coordinates;
        data["placeType"] = this.placeType;
        return data;
    }
}

export interface IPropertyPointOfInterest {
    name?: string | undefined;
    distance?: number;
    coordinates?: string | undefined;
    placeType?: PlaceType;
}

export class PropertyReport implements IPropertyReport {
    id?: string;
    externalId?: string | undefined;
    report?: any | undefined;
    externalStaticId?: string | undefined;
    staticReport?: any | undefined;

    constructor(data?: IPropertyReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalId = _data["externalId"];
            this.report = _data["report"];
            this.externalStaticId = _data["externalStaticId"];
            this.staticReport = _data["staticReport"];
        }
    }

    static fromJS(data: any): PropertyReport {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalId"] = this.externalId;
        data["report"] = this.report;
        data["externalStaticId"] = this.externalStaticId;
        data["staticReport"] = this.staticReport;
        return data;
    }
}

export interface IPropertyReport {
    id?: string;
    externalId?: string | undefined;
    report?: any | undefined;
    externalStaticId?: string | undefined;
    staticReport?: any | undefined;
}

export class PropertyReportPartial implements IPropertyReportPartial {
    id?: string;
    liquidityScore?: string | undefined;
    hotnessScore?: string | undefined;
    minPriceSqm?: number | undefined;
    maxPriceSqm?: number | undefined;
    minPrice?: number | undefined;
    maxPrice?: number | undefined;
    minRentPrice?: number | undefined;
    maxRentPrice?: number | undefined;
    maxRentYieldPercentage?: number | undefined;
    minRentYieldPercentage?: number | undefined;
    objectiveValue?: number | undefined;

    constructor(data?: IPropertyReportPartial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.liquidityScore = _data["liquidityScore"];
            this.hotnessScore = _data["hotnessScore"];
            this.minPriceSqm = _data["minPriceSqm"];
            this.maxPriceSqm = _data["maxPriceSqm"];
            this.minPrice = _data["minPrice"];
            this.maxPrice = _data["maxPrice"];
            this.minRentPrice = _data["minRentPrice"];
            this.maxRentPrice = _data["maxRentPrice"];
            this.maxRentYieldPercentage = _data["maxRentYieldPercentage"];
            this.minRentYieldPercentage = _data["minRentYieldPercentage"];
            this.objectiveValue = _data["objectiveValue"];
        }
    }

    static fromJS(data: any): PropertyReportPartial {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyReportPartial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["liquidityScore"] = this.liquidityScore;
        data["hotnessScore"] = this.hotnessScore;
        data["minPriceSqm"] = this.minPriceSqm;
        data["maxPriceSqm"] = this.maxPriceSqm;
        data["minPrice"] = this.minPrice;
        data["maxPrice"] = this.maxPrice;
        data["minRentPrice"] = this.minRentPrice;
        data["maxRentPrice"] = this.maxRentPrice;
        data["maxRentYieldPercentage"] = this.maxRentYieldPercentage;
        data["minRentYieldPercentage"] = this.minRentYieldPercentage;
        data["objectiveValue"] = this.objectiveValue;
        return data;
    }
}

export interface IPropertyReportPartial {
    id?: string;
    liquidityScore?: string | undefined;
    hotnessScore?: string | undefined;
    minPriceSqm?: number | undefined;
    maxPriceSqm?: number | undefined;
    minPrice?: number | undefined;
    maxPrice?: number | undefined;
    minRentPrice?: number | undefined;
    maxRentPrice?: number | undefined;
    maxRentYieldPercentage?: number | undefined;
    minRentYieldPercentage?: number | undefined;
    objectiveValue?: number | undefined;
}

export class PropertySummary implements IPropertySummary {
    id?: string;
    code?: string | undefined;
    price?: number;
    auctionDateTime?: Date | undefined;
    timeSpanToNextRound?: TimeSpanForNextAuction;
    auctionRound?: number | undefined;
    floor?: number | undefined;
    propertyArea?: number | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    category?: string | undefined;
    type?: PropertyType;
    viewCount?: number;
    isSold?: boolean;
    preApproved?: PreApprovalStatus;
    preApprovalDescription?: LocalizedText;
    defaultImagePath?: string | undefined;
    isPromoted?: boolean;
    isFavorite?: boolean;
    isHot?: boolean;
    isSponsored?: boolean;
    distanceFromSelectedProperty?: number | undefined;
    lastModified?: Date | undefined;
    previousPrice?: number | undefined;
    address?: Address;
    createdOn?: Date;
    tags?: string[] | undefined;
    readonly title?: string | undefined;
    numberOfFloors?: number | undefined;
    numberOfRooms?: number | undefined;
    numberOfBathrooms?: number | undefined;
    numberOfWC?: number | undefined;
    defaultPhoto?: Photo;
    constructionYear?: number | undefined;
    isExclusive?: boolean;
    auctionRounds?: AuctionDetails;
    publishedStatus?: ArticleStatus;

    constructor(data?: IPropertySummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.price = _data["price"];
            this.auctionDateTime = _data["auctionDateTime"] ? new Date(_data["auctionDateTime"].toString()) : <any>undefined;
            this.timeSpanToNextRound = _data["timeSpanToNextRound"] ? TimeSpanForNextAuction.fromJS(_data["timeSpanToNextRound"]) : <any>undefined;
            this.auctionRound = _data["auctionRound"];
            this.floor = _data["floor"];
            this.propertyArea = _data["propertyArea"];
            this.description = _data["description"];
            this.shortDescription = _data["shortDescription"];
            this.category = _data["category"];
            this.type = _data["type"];
            this.viewCount = _data["viewCount"];
            this.isSold = _data["isSold"];
            this.preApproved = _data["preApproved"];
            this.preApprovalDescription = _data["preApprovalDescription"] ? LocalizedText.fromJS(_data["preApprovalDescription"]) : <any>undefined;
            this.defaultImagePath = _data["defaultImagePath"];
            this.isPromoted = _data["isPromoted"];
            this.isFavorite = _data["isFavorite"];
            this.isHot = _data["isHot"];
            this.isSponsored = _data["isSponsored"];
            this.distanceFromSelectedProperty = _data["distanceFromSelectedProperty"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.previousPrice = _data["previousPrice"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            (<any>this).title = _data["title"];
            this.numberOfFloors = _data["numberOfFloors"];
            this.numberOfRooms = _data["numberOfRooms"];
            this.numberOfBathrooms = _data["numberOfBathrooms"];
            this.numberOfWC = _data["numberOfWC"];
            this.defaultPhoto = _data["defaultPhoto"] ? Photo.fromJS(_data["defaultPhoto"]) : <any>undefined;
            this.constructionYear = _data["constructionYear"];
            this.isExclusive = _data["isExclusive"];
            this.auctionRounds = _data["auctionRounds"] ? AuctionDetails.fromJS(_data["auctionRounds"]) : <any>undefined;
            this.publishedStatus = _data["publishedStatus"];
        }
    }

    static fromJS(data: any): PropertySummary {
        data = typeof data === 'object' ? data : {};
        let result = new PropertySummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["price"] = this.price;
        data["auctionDateTime"] = this.auctionDateTime ? this.auctionDateTime.toISOString() : <any>undefined;
        data["timeSpanToNextRound"] = this.timeSpanToNextRound ? this.timeSpanToNextRound.toJSON() : <any>undefined;
        data["auctionRound"] = this.auctionRound;
        data["floor"] = this.floor;
        data["propertyArea"] = this.propertyArea;
        data["description"] = this.description;
        data["shortDescription"] = this.shortDescription;
        data["category"] = this.category;
        data["type"] = this.type;
        data["viewCount"] = this.viewCount;
        data["isSold"] = this.isSold;
        data["preApproved"] = this.preApproved;
        data["preApprovalDescription"] = this.preApprovalDescription ? this.preApprovalDescription.toJSON() : <any>undefined;
        data["defaultImagePath"] = this.defaultImagePath;
        data["isPromoted"] = this.isPromoted;
        data["isFavorite"] = this.isFavorite;
        data["isHot"] = this.isHot;
        data["isSponsored"] = this.isSponsored;
        data["distanceFromSelectedProperty"] = this.distanceFromSelectedProperty;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["previousPrice"] = this.previousPrice;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["title"] = this.title;
        data["numberOfFloors"] = this.numberOfFloors;
        data["numberOfRooms"] = this.numberOfRooms;
        data["numberOfBathrooms"] = this.numberOfBathrooms;
        data["numberOfWC"] = this.numberOfWC;
        data["defaultPhoto"] = this.defaultPhoto ? this.defaultPhoto.toJSON() : <any>undefined;
        data["constructionYear"] = this.constructionYear;
        data["isExclusive"] = this.isExclusive;
        data["auctionRounds"] = this.auctionRounds ? this.auctionRounds.toJSON() : <any>undefined;
        data["publishedStatus"] = this.publishedStatus;
        return data;
    }
}

export interface IPropertySummary {
    id?: string;
    code?: string | undefined;
    price?: number;
    auctionDateTime?: Date | undefined;
    timeSpanToNextRound?: TimeSpanForNextAuction;
    auctionRound?: number | undefined;
    floor?: number | undefined;
    propertyArea?: number | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    category?: string | undefined;
    type?: PropertyType;
    viewCount?: number;
    isSold?: boolean;
    preApproved?: PreApprovalStatus;
    preApprovalDescription?: LocalizedText;
    defaultImagePath?: string | undefined;
    isPromoted?: boolean;
    isFavorite?: boolean;
    isHot?: boolean;
    isSponsored?: boolean;
    distanceFromSelectedProperty?: number | undefined;
    lastModified?: Date | undefined;
    previousPrice?: number | undefined;
    address?: Address;
    createdOn?: Date;
    tags?: string[] | undefined;
    title?: string | undefined;
    numberOfFloors?: number | undefined;
    numberOfRooms?: number | undefined;
    numberOfBathrooms?: number | undefined;
    numberOfWC?: number | undefined;
    defaultPhoto?: Photo;
    constructionYear?: number | undefined;
    isExclusive?: boolean;
    auctionRounds?: AuctionDetails;
    publishedStatus?: ArticleStatus;
}

export class PropertySummaryBuying implements IPropertySummaryBuying {
    id?: string;
    code?: string | undefined;
    price?: number;
    auctionDateTime?: Date | undefined;
    timeSpanToNextRound?: TimeSpanForNextAuction;
    auctionRound?: number | undefined;
    floor?: number | undefined;
    propertyArea?: number | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    category?: string | undefined;
    type?: PropertyType;
    viewCount?: number;
    isSold?: boolean;
    preApproved?: PreApprovalStatus;
    preApprovalDescription?: LocalizedText;
    defaultImagePath?: string | undefined;
    isPromoted?: boolean;
    isFavorite?: boolean;
    isHot?: boolean;
    isSponsored?: boolean;
    distanceFromSelectedProperty?: number | undefined;
    lastModified?: Date | undefined;
    previousPrice?: number | undefined;
    address?: Address;
    createdOn?: Date;
    tags?: string[] | undefined;
    readonly title?: string | undefined;
    numberOfFloors?: number | undefined;
    numberOfRooms?: number | undefined;
    numberOfBathrooms?: number | undefined;
    numberOfWC?: number | undefined;
    defaultPhoto?: Photo;
    constructionYear?: number | undefined;
    isExclusive?: boolean;
    auctionRounds?: AuctionDetails;
    publishedStatus?: ArticleStatus;

    constructor(data?: IPropertySummaryBuying) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.price = _data["price"];
            this.auctionDateTime = _data["auctionDateTime"] ? new Date(_data["auctionDateTime"].toString()) : <any>undefined;
            this.timeSpanToNextRound = _data["timeSpanToNextRound"] ? TimeSpanForNextAuction.fromJS(_data["timeSpanToNextRound"]) : <any>undefined;
            this.auctionRound = _data["auctionRound"];
            this.floor = _data["floor"];
            this.propertyArea = _data["propertyArea"];
            this.description = _data["description"];
            this.shortDescription = _data["shortDescription"];
            this.category = _data["category"];
            this.type = _data["type"];
            this.viewCount = _data["viewCount"];
            this.isSold = _data["isSold"];
            this.preApproved = _data["preApproved"];
            this.preApprovalDescription = _data["preApprovalDescription"] ? LocalizedText.fromJS(_data["preApprovalDescription"]) : <any>undefined;
            this.defaultImagePath = _data["defaultImagePath"];
            this.isPromoted = _data["isPromoted"];
            this.isFavorite = _data["isFavorite"];
            this.isHot = _data["isHot"];
            this.isSponsored = _data["isSponsored"];
            this.distanceFromSelectedProperty = _data["distanceFromSelectedProperty"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.previousPrice = _data["previousPrice"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            (<any>this).title = _data["title"];
            this.numberOfFloors = _data["numberOfFloors"];
            this.numberOfRooms = _data["numberOfRooms"];
            this.numberOfBathrooms = _data["numberOfBathrooms"];
            this.numberOfWC = _data["numberOfWC"];
            this.defaultPhoto = _data["defaultPhoto"] ? Photo.fromJS(_data["defaultPhoto"]) : <any>undefined;
            this.constructionYear = _data["constructionYear"];
            this.isExclusive = _data["isExclusive"];
            this.auctionRounds = _data["auctionRounds"] ? AuctionDetails.fromJS(_data["auctionRounds"]) : <any>undefined;
            this.publishedStatus = _data["publishedStatus"];
        }
    }

    static fromJS(data: any): PropertySummaryBuying {
        data = typeof data === 'object' ? data : {};
        let result = new PropertySummaryBuying();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["price"] = this.price;
        data["auctionDateTime"] = this.auctionDateTime ? this.auctionDateTime.toISOString() : <any>undefined;
        data["timeSpanToNextRound"] = this.timeSpanToNextRound ? this.timeSpanToNextRound.toJSON() : <any>undefined;
        data["auctionRound"] = this.auctionRound;
        data["floor"] = this.floor;
        data["propertyArea"] = this.propertyArea;
        data["description"] = this.description;
        data["shortDescription"] = this.shortDescription;
        data["category"] = this.category;
        data["type"] = this.type;
        data["viewCount"] = this.viewCount;
        data["isSold"] = this.isSold;
        data["preApproved"] = this.preApproved;
        data["preApprovalDescription"] = this.preApprovalDescription ? this.preApprovalDescription.toJSON() : <any>undefined;
        data["defaultImagePath"] = this.defaultImagePath;
        data["isPromoted"] = this.isPromoted;
        data["isFavorite"] = this.isFavorite;
        data["isHot"] = this.isHot;
        data["isSponsored"] = this.isSponsored;
        data["distanceFromSelectedProperty"] = this.distanceFromSelectedProperty;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["previousPrice"] = this.previousPrice;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["title"] = this.title;
        data["numberOfFloors"] = this.numberOfFloors;
        data["numberOfRooms"] = this.numberOfRooms;
        data["numberOfBathrooms"] = this.numberOfBathrooms;
        data["numberOfWC"] = this.numberOfWC;
        data["defaultPhoto"] = this.defaultPhoto ? this.defaultPhoto.toJSON() : <any>undefined;
        data["constructionYear"] = this.constructionYear;
        data["isExclusive"] = this.isExclusive;
        data["auctionRounds"] = this.auctionRounds ? this.auctionRounds.toJSON() : <any>undefined;
        data["publishedStatus"] = this.publishedStatus;
        return data;
    }
}

export interface IPropertySummaryBuying {
    id?: string;
    code?: string | undefined;
    price?: number;
    auctionDateTime?: Date | undefined;
    timeSpanToNextRound?: TimeSpanForNextAuction;
    auctionRound?: number | undefined;
    floor?: number | undefined;
    propertyArea?: number | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    category?: string | undefined;
    type?: PropertyType;
    viewCount?: number;
    isSold?: boolean;
    preApproved?: PreApprovalStatus;
    preApprovalDescription?: LocalizedText;
    defaultImagePath?: string | undefined;
    isPromoted?: boolean;
    isFavorite?: boolean;
    isHot?: boolean;
    isSponsored?: boolean;
    distanceFromSelectedProperty?: number | undefined;
    lastModified?: Date | undefined;
    previousPrice?: number | undefined;
    address?: Address;
    createdOn?: Date;
    tags?: string[] | undefined;
    title?: string | undefined;
    numberOfFloors?: number | undefined;
    numberOfRooms?: number | undefined;
    numberOfBathrooms?: number | undefined;
    numberOfWC?: number | undefined;
    defaultPhoto?: Photo;
    constructionYear?: number | undefined;
    isExclusive?: boolean;
    auctionRounds?: AuctionDetails;
    publishedStatus?: ArticleStatus;
}

export class PropertySummaryBuyingResultSet implements IPropertySummaryBuyingResultSet {
    count?: number;
    items?: PropertySummaryBuying[] | undefined;

    constructor(data?: IPropertySummaryBuyingResultSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PropertySummaryBuying.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PropertySummaryBuyingResultSet {
        data = typeof data === 'object' ? data : {};
        let result = new PropertySummaryBuyingResultSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPropertySummaryBuyingResultSet {
    count?: number;
    items?: PropertySummaryBuying[] | undefined;
}

export class PropertySummaryResultSet implements IPropertySummaryResultSet {
    count?: number;
    items?: PropertySummary[] | undefined;

    constructor(data?: IPropertySummaryResultSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PropertySummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PropertySummaryResultSet {
        data = typeof data === 'object' ? data : {};
        let result = new PropertySummaryResultSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPropertySummaryResultSet {
    count?: number;
    items?: PropertySummary[] | undefined;
}

export class PropertySummaryWithCounts implements IPropertySummaryWithCounts {
    id?: string;
    code?: string | undefined;
    price?: number;
    auctionDateTime?: Date | undefined;
    timeSpanToNextRound?: TimeSpanForNextAuction;
    auctionRound?: number | undefined;
    floor?: number | undefined;
    propertyArea?: number | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    category?: string | undefined;
    type?: PropertyType;
    viewCount?: number;
    isSold?: boolean;
    preApproved?: PreApprovalStatus;
    preApprovalDescription?: LocalizedText;
    defaultImagePath?: string | undefined;
    isPromoted?: boolean;
    isFavorite?: boolean;
    isHot?: boolean;
    isSponsored?: boolean;
    distanceFromSelectedProperty?: number | undefined;
    lastModified?: Date | undefined;
    previousPrice?: number | undefined;
    address?: Address;
    createdOn?: Date;
    tags?: string[] | undefined;
    readonly title?: string | undefined;
    numberOfFloors?: number | undefined;
    numberOfRooms?: number | undefined;
    numberOfBathrooms?: number | undefined;
    numberOfWC?: number | undefined;
    defaultPhoto?: Photo;
    constructionYear?: number | undefined;
    isExclusive?: boolean;
    auctionRounds?: AuctionDetails;
    publishedStatus?: ArticleStatus;
    offersCount?: number;
    walkthroughsCount?: number;

    constructor(data?: IPropertySummaryWithCounts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.price = _data["price"];
            this.auctionDateTime = _data["auctionDateTime"] ? new Date(_data["auctionDateTime"].toString()) : <any>undefined;
            this.timeSpanToNextRound = _data["timeSpanToNextRound"] ? TimeSpanForNextAuction.fromJS(_data["timeSpanToNextRound"]) : <any>undefined;
            this.auctionRound = _data["auctionRound"];
            this.floor = _data["floor"];
            this.propertyArea = _data["propertyArea"];
            this.description = _data["description"];
            this.shortDescription = _data["shortDescription"];
            this.category = _data["category"];
            this.type = _data["type"];
            this.viewCount = _data["viewCount"];
            this.isSold = _data["isSold"];
            this.preApproved = _data["preApproved"];
            this.preApprovalDescription = _data["preApprovalDescription"] ? LocalizedText.fromJS(_data["preApprovalDescription"]) : <any>undefined;
            this.defaultImagePath = _data["defaultImagePath"];
            this.isPromoted = _data["isPromoted"];
            this.isFavorite = _data["isFavorite"];
            this.isHot = _data["isHot"];
            this.isSponsored = _data["isSponsored"];
            this.distanceFromSelectedProperty = _data["distanceFromSelectedProperty"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.previousPrice = _data["previousPrice"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            (<any>this).title = _data["title"];
            this.numberOfFloors = _data["numberOfFloors"];
            this.numberOfRooms = _data["numberOfRooms"];
            this.numberOfBathrooms = _data["numberOfBathrooms"];
            this.numberOfWC = _data["numberOfWC"];
            this.defaultPhoto = _data["defaultPhoto"] ? Photo.fromJS(_data["defaultPhoto"]) : <any>undefined;
            this.constructionYear = _data["constructionYear"];
            this.isExclusive = _data["isExclusive"];
            this.auctionRounds = _data["auctionRounds"] ? AuctionDetails.fromJS(_data["auctionRounds"]) : <any>undefined;
            this.publishedStatus = _data["publishedStatus"];
            this.offersCount = _data["offersCount"];
            this.walkthroughsCount = _data["walkthroughsCount"];
        }
    }

    static fromJS(data: any): PropertySummaryWithCounts {
        data = typeof data === 'object' ? data : {};
        let result = new PropertySummaryWithCounts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["price"] = this.price;
        data["auctionDateTime"] = this.auctionDateTime ? this.auctionDateTime.toISOString() : <any>undefined;
        data["timeSpanToNextRound"] = this.timeSpanToNextRound ? this.timeSpanToNextRound.toJSON() : <any>undefined;
        data["auctionRound"] = this.auctionRound;
        data["floor"] = this.floor;
        data["propertyArea"] = this.propertyArea;
        data["description"] = this.description;
        data["shortDescription"] = this.shortDescription;
        data["category"] = this.category;
        data["type"] = this.type;
        data["viewCount"] = this.viewCount;
        data["isSold"] = this.isSold;
        data["preApproved"] = this.preApproved;
        data["preApprovalDescription"] = this.preApprovalDescription ? this.preApprovalDescription.toJSON() : <any>undefined;
        data["defaultImagePath"] = this.defaultImagePath;
        data["isPromoted"] = this.isPromoted;
        data["isFavorite"] = this.isFavorite;
        data["isHot"] = this.isHot;
        data["isSponsored"] = this.isSponsored;
        data["distanceFromSelectedProperty"] = this.distanceFromSelectedProperty;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["previousPrice"] = this.previousPrice;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["title"] = this.title;
        data["numberOfFloors"] = this.numberOfFloors;
        data["numberOfRooms"] = this.numberOfRooms;
        data["numberOfBathrooms"] = this.numberOfBathrooms;
        data["numberOfWC"] = this.numberOfWC;
        data["defaultPhoto"] = this.defaultPhoto ? this.defaultPhoto.toJSON() : <any>undefined;
        data["constructionYear"] = this.constructionYear;
        data["isExclusive"] = this.isExclusive;
        data["auctionRounds"] = this.auctionRounds ? this.auctionRounds.toJSON() : <any>undefined;
        data["publishedStatus"] = this.publishedStatus;
        data["offersCount"] = this.offersCount;
        data["walkthroughsCount"] = this.walkthroughsCount;
        return data;
    }
}

export interface IPropertySummaryWithCounts {
    id?: string;
    code?: string | undefined;
    price?: number;
    auctionDateTime?: Date | undefined;
    timeSpanToNextRound?: TimeSpanForNextAuction;
    auctionRound?: number | undefined;
    floor?: number | undefined;
    propertyArea?: number | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    category?: string | undefined;
    type?: PropertyType;
    viewCount?: number;
    isSold?: boolean;
    preApproved?: PreApprovalStatus;
    preApprovalDescription?: LocalizedText;
    defaultImagePath?: string | undefined;
    isPromoted?: boolean;
    isFavorite?: boolean;
    isHot?: boolean;
    isSponsored?: boolean;
    distanceFromSelectedProperty?: number | undefined;
    lastModified?: Date | undefined;
    previousPrice?: number | undefined;
    address?: Address;
    createdOn?: Date;
    tags?: string[] | undefined;
    title?: string | undefined;
    numberOfFloors?: number | undefined;
    numberOfRooms?: number | undefined;
    numberOfBathrooms?: number | undefined;
    numberOfWC?: number | undefined;
    defaultPhoto?: Photo;
    constructionYear?: number | undefined;
    isExclusive?: boolean;
    auctionRounds?: AuctionDetails;
    publishedStatus?: ArticleStatus;
    offersCount?: number;
    walkthroughsCount?: number;
}

export class PropertySummaryWithCountsResultSet implements IPropertySummaryWithCountsResultSet {
    count?: number;
    items?: PropertySummaryWithCounts[] | undefined;

    constructor(data?: IPropertySummaryWithCountsResultSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PropertySummaryWithCounts.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PropertySummaryWithCountsResultSet {
        data = typeof data === 'object' ? data : {};
        let result = new PropertySummaryWithCountsResultSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPropertySummaryWithCountsResultSet {
    count?: number;
    items?: PropertySummaryWithCounts[] | undefined;
}

export class PropertyTag implements IPropertyTag {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: IPropertyTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PropertyTag {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IPropertyTag {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
}

export enum PropertyType {
    Unknown = "Unknown",
    Apartment = "Apartment",
    Studio = "Studio",
    ApartmentComplex = "ApartmentComplex",
    Loft = "Loft",
    ResidentialBuilding = "ResidentialBuilding",
    Maisonette = "Maisonette",
    DetachedHouse = "DetachedHouse",
    Villa = "Villa",
    Duplex = "Duplex",
    FarmHouse = "FarmHouse",
    Bungallow = "Bungallow",
    SemiDetached = "SemiDetached",
    ResidenceWithCommercialUse = "ResidenceWithCommercialUse",
    Office = "Office",
    CommercialOfficeBuilding = "CommercialOfficeBuilding",
    Shop = "Shop",
    Space = "Space",
    Business = "Business",
    Showroom = "Showroom",
    CommercialBuilding = "CommercialBuilding",
    SpecialPurpose = "SpecialPurpose",
    IndustrialSpace = "IndustrialSpace",
    Hall = "Hall",
    LightIndustrialSpace = "LightIndustrialSpace",
    Warehouse = "Warehouse",
    Land = "Land",
    LandPlot = "LandPlot",
    ParcelOrLandField = "ParcelOrLandField",
    Hotel = "Hotel",
    Other = "Other",
    Parking = "Parking",
    Storage = "Storage",
    Island = "Island",
    Prefabricated = "Prefabricated",
    Detachable = "Detachable",
    Air = "Air",
    CountryHouse = "CountryHouse",
}

export enum PropertyUsageCategory {
    Unknown = "Unknown",
    Commercial = "Commercial",
    Residential = "Residential",
    Industrial = "Industrial",
    Land = "Land",
    Leisure = "Leisure",
    Other = "Other",
}

export enum QuestionType {
    Emoji = "emoji",
    Select = "select",
    Star = "star",
    Text = "text",
    Range = "range",
}

export class RelatedAuction implements IRelatedAuction {
    code?: string | undefined;
    url?: string | undefined;
    type?: string | undefined;
    price?: string | undefined;
    datetime?: Date | undefined;

    constructor(data?: IRelatedAuction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.url = _data["url"];
            this.type = _data["type"];
            this.price = _data["price"];
            this.datetime = _data["datetime"] ? new Date(_data["datetime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RelatedAuction {
        data = typeof data === 'object' ? data : {};
        let result = new RelatedAuction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["url"] = this.url;
        data["type"] = this.type;
        data["price"] = this.price;
        data["datetime"] = this.datetime ? this.datetime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRelatedAuction {
    code?: string | undefined;
    url?: string | undefined;
    type?: string | undefined;
    price?: string | undefined;
    datetime?: Date | undefined;
}

export class Request implements IRequest {
    id?: string;
    referenceNumber?: number | undefined;
    created?: Date | undefined;
    caseTypeCode?: string | undefined;
    title?: string | undefined;
    checkpointType?: CheckpointType;
    metadata?: { [key: string]: string; } | undefined;
    message?: string | undefined;
    translations?: { [key: string]: CaseTypeTranslation; } | undefined;
    data?: any | undefined;
    completed?: Date | undefined;
    createdById?: string | undefined;
    ownerUserId?: string | undefined;
    propertyId?: string | undefined;

    constructor(data?: IRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.referenceNumber = _data["referenceNumber"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.caseTypeCode = _data["caseTypeCode"];
            this.title = _data["title"];
            this.checkpointType = _data["checkpointType"] ? CheckpointType.fromJS(_data["checkpointType"]) : <any>undefined;
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (<any>this.metadata)![key] = _data["metadata"][key];
                }
            }
            this.message = _data["message"];
            if (_data["translations"]) {
                this.translations = {} as any;
                for (let key in _data["translations"]) {
                    if (_data["translations"].hasOwnProperty(key))
                        (<any>this.translations)![key] = _data["translations"][key] ? CaseTypeTranslation.fromJS(_data["translations"][key]) : new CaseTypeTranslation();
                }
            }
            this.data = _data["data"];
            this.completed = _data["completed"] ? new Date(_data["completed"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.ownerUserId = _data["ownerUserId"];
            this.propertyId = _data["propertyId"];
        }
    }

    static fromJS(data: any): Request {
        data = typeof data === 'object' ? data : {};
        let result = new Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["referenceNumber"] = this.referenceNumber;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["caseTypeCode"] = this.caseTypeCode;
        data["title"] = this.title;
        data["checkpointType"] = this.checkpointType ? this.checkpointType.toJSON() : <any>undefined;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (<any>data["metadata"])[key] = (<any>this.metadata)[key];
            }
        }
        data["message"] = this.message;
        if (this.translations) {
            data["translations"] = {};
            for (let key in this.translations) {
                if (this.translations.hasOwnProperty(key))
                    (<any>data["translations"])[key] = this.translations[key] ? this.translations[key].toJSON() : <any>undefined;
            }
        }
        data["data"] = this.data;
        data["completed"] = this.completed ? this.completed.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["ownerUserId"] = this.ownerUserId;
        data["propertyId"] = this.propertyId;
        return data;
    }
}

export interface IRequest {
    id?: string;
    referenceNumber?: number | undefined;
    created?: Date | undefined;
    caseTypeCode?: string | undefined;
    title?: string | undefined;
    checkpointType?: CheckpointType;
    metadata?: { [key: string]: string; } | undefined;
    message?: string | undefined;
    translations?: { [key: string]: CaseTypeTranslation; } | undefined;
    data?: any | undefined;
    completed?: Date | undefined;
    createdById?: string | undefined;
    ownerUserId?: string | undefined;
    propertyId?: string | undefined;
}

export class RequestPropertySummary implements IRequestPropertySummary {
    id?: string;
    code?: string | undefined;
    title?: LocalizedText;
    prefecture?: LocalizedText;
    defaultPhoto?: Photo;
    isMine?: boolean;

    constructor(data?: IRequestPropertySummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.title = _data["title"] ? LocalizedText.fromJS(_data["title"]) : <any>undefined;
            this.prefecture = _data["prefecture"] ? LocalizedText.fromJS(_data["prefecture"]) : <any>undefined;
            this.defaultPhoto = _data["defaultPhoto"] ? Photo.fromJS(_data["defaultPhoto"]) : <any>undefined;
            this.isMine = _data["isMine"];
        }
    }

    static fromJS(data: any): RequestPropertySummary {
        data = typeof data === 'object' ? data : {};
        let result = new RequestPropertySummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        data["prefecture"] = this.prefecture ? this.prefecture.toJSON() : <any>undefined;
        data["defaultPhoto"] = this.defaultPhoto ? this.defaultPhoto.toJSON() : <any>undefined;
        data["isMine"] = this.isMine;
        return data;
    }
}

export interface IRequestPropertySummary {
    id?: string;
    code?: string | undefined;
    title?: LocalizedText;
    prefecture?: LocalizedText;
    defaultPhoto?: Photo;
    isMine?: boolean;
}

export enum RequestTypeFilter {
    Offers = "Offers",
    Walkthroughs = "Walkthroughs",
    Other = "Other",
}

export class SavePropertySearchFilterRequest implements ISavePropertySearchFilterRequest {
    search?: Search;
    frequency?: NotificationFrequency;

    constructor(data?: ISavePropertySearchFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["search"] ? Search.fromJS(_data["search"]) : <any>undefined;
            this.frequency = _data["frequency"];
        }
    }

    static fromJS(data: any): SavePropertySearchFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SavePropertySearchFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["search"] = this.search ? this.search.toJSON() : <any>undefined;
        data["frequency"] = this.frequency;
        return data;
    }
}

export interface ISavePropertySearchFilterRequest {
    search?: Search;
    frequency?: NotificationFrequency;
}

export enum SavedSearchType {
    All = "All",
    SavedOnly = "SavedOnly",
    HistoryOnly = "HistoryOnly",
}

export class Search implements ISearch {
    id?: string | undefined;
    name?: string | undefined;
    placeName?: string | undefined;
    propertyType?: string | undefined;
    addresses?: Address[] | undefined;
    query?: PropertyListFilter;
    notificationFrequency?: NotificationFrequency;
    createdOn?: Date | undefined;

    constructor(data?: ISearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.placeName = _data["placeName"];
            this.propertyType = _data["propertyType"];
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(Address.fromJS(item));
            }
            this.query = _data["query"] ? PropertyListFilter.fromJS(_data["query"]) : <any>undefined;
            this.notificationFrequency = _data["notificationFrequency"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Search {
        data = typeof data === 'object' ? data : {};
        let result = new Search();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["placeName"] = this.placeName;
        data["propertyType"] = this.propertyType;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["query"] = this.query ? this.query.toJSON() : <any>undefined;
        data["notificationFrequency"] = this.notificationFrequency;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISearch {
    id?: string | undefined;
    name?: string | undefined;
    placeName?: string | undefined;
    propertyType?: string | undefined;
    addresses?: Address[] | undefined;
    query?: PropertyListFilter;
    notificationFrequency?: NotificationFrequency;
    createdOn?: Date | undefined;
}

export enum SearchHistoryDateRange {
    JustLooking = "JustLooking",
    UpToSixMonths = "UpToSixMonths",
    UpToTwelveMonths = "UpToTwelveMonths",
    MoreThanTwelveMonths = "MoreThanTwelveMonths",
}

export class SendForReviewResponse implements ISendForReviewResponse {
    email?: string | undefined;
    fullName?: string | undefined;
    phone?: string | undefined;

    constructor(data?: ISendForReviewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.fullName = _data["fullName"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): SendForReviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendForReviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        data["phone"] = this.phone;
        return data;
    }
}

export interface ISendForReviewResponse {
    email?: string | undefined;
    fullName?: string | undefined;
    phone?: string | undefined;
}

export enum StorageType {
    Internal = "Internal",
    External = "External",
}

export class SubmitOfferResultRequest implements ISubmitOfferResultRequest {
    status?: SubmitOfferStatus;
    reason?: string | undefined;

    constructor(data?: ISubmitOfferResultRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): SubmitOfferResultRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitOfferResultRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["reason"] = this.reason;
        return data;
    }
}

export interface ISubmitOfferResultRequest {
    status?: SubmitOfferStatus;
    reason?: string | undefined;
}

export enum SubmitOfferStatus {
    Accept = "Accept",
    Reject = "Reject",
}

export enum Surrounding {
    Parks = "Parks",
    Beach = "Beach",
    MetroStop = "MetroStop",
    BusStop = "BusStop",
    TrainStation = "TrainStation",
}

export class Surroundings implements ISurroundings {
    plotArea?: number | undefined;
    view?: View[] | undefined;
    orientation?: Orientation;
    surrounding?: Surrounding[] | undefined;
    nearbyHighwaysEl?: string | undefined;
    nearbyHighwaysEn?: string | undefined;

    constructor(data?: ISurroundings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plotArea = _data["plotArea"];
            if (Array.isArray(_data["view"])) {
                this.view = [] as any;
                for (let item of _data["view"])
                    this.view!.push(item);
            }
            this.orientation = _data["orientation"];
            if (Array.isArray(_data["surrounding"])) {
                this.surrounding = [] as any;
                for (let item of _data["surrounding"])
                    this.surrounding!.push(item);
            }
            this.nearbyHighwaysEl = _data["nearbyHighwaysEl"];
            this.nearbyHighwaysEn = _data["nearbyHighwaysEn"];
        }
    }

    static fromJS(data: any): Surroundings {
        data = typeof data === 'object' ? data : {};
        let result = new Surroundings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plotArea"] = this.plotArea;
        if (Array.isArray(this.view)) {
            data["view"] = [];
            for (let item of this.view)
                data["view"].push(item);
        }
        data["orientation"] = this.orientation;
        if (Array.isArray(this.surrounding)) {
            data["surrounding"] = [];
            for (let item of this.surrounding)
                data["surrounding"].push(item);
        }
        data["nearbyHighwaysEl"] = this.nearbyHighwaysEl;
        data["nearbyHighwaysEn"] = this.nearbyHighwaysEn;
        return data;
    }
}

export interface ISurroundings {
    plotArea?: number | undefined;
    view?: View[] | undefined;
    orientation?: Orientation;
    surrounding?: Surrounding[] | undefined;
    nearbyHighwaysEl?: string | undefined;
    nearbyHighwaysEn?: string | undefined;
}

export class ThreeDTourMedia implements IThreeDTourMedia {
    spaceId?: string | undefined;

    constructor(data?: IThreeDTourMedia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.spaceId = _data["spaceId"];
        }
    }

    static fromJS(data: any): ThreeDTourMedia {
        data = typeof data === 'object' ? data : {};
        let result = new ThreeDTourMedia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["spaceId"] = this.spaceId;
        return data;
    }
}

export interface IThreeDTourMedia {
    spaceId?: string | undefined;
}

export class TimeSpanForNextAuction implements ITimeSpanForNextAuction {
    days?: number;
    hours?: number;
    minutes?: number;

    constructor(data?: ITimeSpanForNextAuction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.days = _data["days"];
            this.hours = _data["hours"];
            this.minutes = _data["minutes"];
        }
    }

    static fromJS(data: any): TimeSpanForNextAuction {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSpanForNextAuction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["days"] = this.days;
        data["hours"] = this.hours;
        data["minutes"] = this.minutes;
        return data;
    }
}

export interface ITimeSpanForNextAuction {
    days?: number;
    hours?: number;
    minutes?: number;
}

export enum TotpMessageType {
    Other = "Other",
    Offer = "Offer",
    Walkthrough = "Walkthrough",
    ChangePhone = "ChangePhone",
}

export class TotpRequestBody implements ITotpRequestBody {
    messageType?: TotpMessageType;

    constructor(data?: ITotpRequestBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageType = _data["messageType"];
        }
    }

    static fromJS(data: any): TotpRequestBody {
        data = typeof data === 'object' ? data : {};
        let result = new TotpRequestBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageType"] = this.messageType;
        return data;
    }
}

export interface ITotpRequestBody {
    messageType?: TotpMessageType;
}

export class TotpVerificationBody implements ITotpVerificationBody {
    code?: string | undefined;

    constructor(data?: ITotpVerificationBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): TotpVerificationBody {
        data = typeof data === 'object' ? data : {};
        let result = new TotpVerificationBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    }
}

export interface ITotpVerificationBody {
    code?: string | undefined;
}

export class UtmDetails implements IUtmDetails {
    anonymousId?: string | undefined;
    source?: ContactSource;
    campaign?: string | undefined;

    constructor(data?: IUtmDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.anonymousId = _data["anonymousId"];
            this.source = _data["source"];
            this.campaign = _data["campaign"];
        }
    }

    static fromJS(data: any): UtmDetails {
        data = typeof data === 'object' ? data : {};
        let result = new UtmDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["anonymousId"] = this.anonymousId;
        data["source"] = this.source;
        data["campaign"] = this.campaign;
        return data;
    }
}

export interface IUtmDetails {
    anonymousId?: string | undefined;
    source?: ContactSource;
    campaign?: string | undefined;
}

export enum View {
    Park = "Park",
    Square = "Square",
    UncoveredArea = "UncoveredArea",
    Footpath = "Footpath",
    CityStreet = "CityStreet",
    Mountain = "Mountain",
    City = "City",
    Other = "Other",
    Sights = "Sights",
    Green = "Green",
    Sea = "Sea",
}

export class WaitingListFormRequest implements IWaitingListFormRequest {
    isSeller?: boolean;
    email!: string | undefined;
    phone?: string | undefined;
    fullName?: string | undefined;

    constructor(data?: IWaitingListFormRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSeller = _data["isSeller"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): WaitingListFormRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WaitingListFormRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSeller"] = this.isSeller;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IWaitingListFormRequest {
    isSeller?: boolean;
    email: string | undefined;
    phone?: string | undefined;
    fullName?: string | undefined;
}
export interface FileParameter {
    data: any;
    fileName: string;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}